import { SP, V2, DUR, MOBILE_APP_BAR_CLEARANCE, MOBILE_BOTTOM_NAV_CLEARANCE, hoverOnly,
         SUCHE_ABSTAND_PX, SUCHE_FELD_RADIUS, SUCHE_FELD_HOEHE_PX,
         SUCHE_V2_RAND, SUCHE_PANEL_MINDESTHOEHE_PX, SUCHE_IKON_PX,
         SUCHE_LUECKE_HALB, SUCHE_FELD_SCHATTEN,
         SUCHE_SCHICHT_UEBERSTAND_PX, SUCHE_SICHER_OBEN,
         SUCHE_TASTATUR_SCHWELLE_PX, SUCHE_TASTATUR_SCALE_MAX,
         SUCHPANEL_TREFFER_POLSTER_PX,
         SUCHE_ZEILE_BILD_PX, SUCHE_ZEILE_POLSTER, SUCHE_ZEILE_BILD_RADIUS,
         FS, SKELETON_PILL_RADIUS, focusRing } from '../theme/tokens'
// src/components/SidebarAndHeaderBar.jsx
import React, { createContext, useContext, useState, useRef, useEffect, useCallback, useMemo, Suspense } from 'react'
import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import ErrorBoundary from './common/ErrorBoundary'
import RouteFallback from './common/RouteFallback'
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion'
import Popper from '@mui/material/Popper'
import Paper  from '@mui/material/Paper'
import {
  Box,
  Drawer,
  ListItemButton,
  AppBar,
  Toolbar,
  LinearProgress,
  IconButton,
  Button,
  Typography,
  InputBase,
  Skeleton,
  Menu,
  MenuItem,
  Grow,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useTheme,
  useMediaQuery,
  Collapse,
  Tooltip,
  Divider,
  ClickAwayListener,
} from '@mui/material'
import { alpha, styled, keyframes } from '@mui/material/styles'
import debounce from 'lodash.debounce'
import SearchIcon              from '@mui/icons-material/Search'
import AccessTimeIcon          from '@mui/icons-material/AccessTime'

import AddCircleIcon           from '@mui/icons-material/AddCircle'
import CloseIcon               from '@mui/icons-material/Close'
import ExpandMoreIcon          from '@mui/icons-material/ExpandMore'

import { Shield, Sun, Moon } from 'lucide-react'
import { navItem, navItemSicher, ariaCurrentTraeger, istAktuelleSeite } from '../navigation/navItems'
import { oeffneTreffer } from '../utils/trefferNavigation'
import {
  SeitenleisteZeile, SeitenleisteBearbeiten, SortierbareZeile, Zeilenbereich,
} from '../navigation/SeitenleisteBearbeiten'
import LogoImg from '../assets/Logo.png'
import { useColorMode } from '../App'
import SearchResultItem, { KIND_LABEL } from './common/SearchResultItem'
import SearchBereichWahl, {
  ALLE_BEREICHE, bereichsEtikett, bereichIstAbgeschaltet, ladeBereiche,
  SYNTAX_HINWEIS_TEXT,
} from './common/SearchBereichWahl'
import SucheBereichChips from './search/SucheBereichChips'
import { ladeRecents, loescheRecents, merkeRecent } from './search/sucheRecents'
import EmptyState from './common/EmptyState'

import MobileBottomNav from './MobileBottomNav'
import { istFallansicht } from '../fall/lib/route'
import Bell from './notifications/Bell'
import UserMenu from './UserMenu'
import IOSInstallBanner from './notifications/IOSInstallBanner'
import CommandPalette, { istPaletteGeste } from '../navigation/CommandPalette'
import {
  holePrefs, merkePrefs, wendeAn, sichtbarePfade, sortiereNachPrefs,
  darfVerstecken, istStandard, istFavorit, hefteAn, loeseFavorit,
  verstecke, zeige, wendeZugAn, FAVORITEN,
} from '../navigation/sidebarPrefs'
import { useRMAWizard } from '../rma/RMAWizardContext'

// your HTTP client and API base‐URL
import axios from 'axios'
/**
 * RoutedContent — der Inhalt der Layout-Route, mit Netz und Platzhalter.
 *
 * 🔴 **Warum die Boundary HIER liegt und nicht in App.js.** Der erste Bau hatte
 * ein `<Suspense>` um den ganzen `<Routes>`-Block. Suspendiert dann ein Kind,
 * ersetzt React den Inhalt der Boundary — also **Sidebar und Header mit**. Bei
 * jeder Client-Navigation waere das Geruest verschwunden und einer nackten
 * Platzhalterzeile gewichen. Hier umschliesst sie nur den Outlet, also genau
 * das, was sich tatsaechlich aendert. Das `ErrorBoundary` liegt aus demselben
 * Grund innen: ein fehlgeschlagener Chunk soll die Seite melden, nicht das
 * Geruest mitnehmen. `resetKey` loescht den Fehler beim naechsten Ortswechsel.
 */
function RoutedContent() {
  const { pathname } = useLocation()
  return (
    <ErrorBoundary resetKey={pathname}>
      <Suspense fallback={<RouteFallback />}>
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  )
}

const API = process.env.REACT_APP_API_BASE_URL
const JOB_POLL_FAST = 5000;   // when jobs are actively running
const JOB_POLL_IDLE = 30000;  // when no jobs — reduces 502 noise during normal usage
const DASHBOARD_JOBS_EVENT = 'dashboard-jobs:update';
const DASHBOARD_JOBS_REFRESH = 'dashboard-jobs:refresh';
const pulse = keyframes`
  0% { transform: scale(0.85); opacity: 0.6; }
  50% { transform: scale(1.15); opacity: 1; }
  100% { transform: scale(0.85); opacity: 0.6; }
`;
const PulseDot = styled(Box)(({ theme }) => ({
  width: 12,
  height: 12,
  borderRadius: '50%',
  backgroundColor: theme.palette.success.main,
  boxShadow: `0 0 0 4px ${alpha(theme.palette.success.main, 0.35)}`,
  animation: `${pulse} 1.5s ease-in-out infinite`,
}));

/** Width of the sidebar drawer */
const SIDEBAR_WIDTH = 240

/**
 * Die Breite der Leiste IM Customize-Modus.
 *
 * 🔴 Sie ist groesser, weil der Modus MEHR in dieselbe Zeile legt und das
 *   Etikett der Leidtragende waere. Rechnung, bei 13 px (FS.md, die Groesse des
 *   Etiketts) mit den Schriften dieser Maschine gemessen — Arial und SF Pro
 *   Text, jeweils der groessere Wert, Inter liegt dazwischen:
 *
 *     laengstes Etikett      121 px   („Dependency Health", neu gemessen 06.10.)
 *     zweitlaengstes         117 px   („Incoming Inventory"; „Customer Invoices" 113)
 *
 *   Nutzbar sind heute `240 − 2 x 12` (Liste) `− 2 x 12` (Zeile) = 192 px.
 *   Der Modus braucht Griff (24) + zwei Luecken (2 x 8) + Aktionsspalte
 *   (24 + 4 + 24 = 52) = 92 px. Bleiben 100 px — 21 px ZU WENIG.
 *
 *   Mit 280 px bleiben 232 − 92 = 140 px. Das deckt auch die 14-px-Fassung
 *   (131 px) und laesst 18 px Luft fuer die Schrift, die das Theme wirklich
 *   laedt (Inter) und die auf dieser Maschine nicht liegt.
 *
 * 🔴 Nur im Modus. Ausserhalb bleibt es bei 240 — das Ziel ist „kein Etikett
 *   abgeschnitten", nicht „die Leiste ist breiter".
 */
const SIDEBAR_WIDTH_MODUS = 280

/**
 * Der Namenszusatz der Favoriten-Kopie (W5).
 *
 * 🔴 Er ist ein eigener, unsichtbarer Textknoten — NICHT mit dem sichtbaren
 * Label in denselben Knoten konkateniert. `getByRole('button', { name: 'Cases' })`
 * vergleicht exakt; „Cases (favorite)" ≠ „Cases", also genau EIN Treffer.
 *
 * 🔴 Und er gehoert auch an die BEDIENELEMENTE der Kopie (Griff, Stern): im Modus
 * ist die Zeile kein benanntes Element mehr, also truege der Griff sonst zweimal
 * „Move Cases" — zwei gleichnamige Knoepfe mit verschiedener Wirkung
 * (WCAG 4.1.2), und die Spec koennte die Kopie nicht adressieren.
 */
const FAVORIT_ZUSATZ = ' (favorite)'

/**
 * Der Flaechenradius einer Zeile — ein Gestaltungswert der LISTE, nicht der Zeile.
 *
 * 🔴 Er steht als Konstante und nicht zweimal im Quelltext: `check_ui_tokens.py`
 * zaehlt `borderRadius: <Zahl>` ueber den ROHTEXT (Regel 22). Zwei Zeilen mit
 * demselben Wert waeren zwei Literale und truegen die Grundlinie um eins hoch;
 * eine Konstante ist EIN Literal und haelt sie. Der Wert bleibt bei 2, weil er
 * das Aussehen nicht aendern darf.
 */
const ZEILEN_SX = { borderRadius: 2 }

// Grouped navigation sections — DIE eine Navigationsvokabel.
// 🔴 Bis 2026-09-28 stand hier "mirrors MobileSidebar structure". Der
// Kommentar war der einzige Grund, warum `MobileSidebar.jsx` lebendig
// AUSSAH: eine Teilstring-Suche zaehlte ihn als Importeur. Die Datei hatte
// null echte Importeure und ist geloescht (W-17/W-19). Wer die Struktur
// hier aendert, aendert die Navigation — es gibt keine zweite Kopie mehr.
const NAV_SECTIONS = [
  {
    id: 'core',
    title: null,
    items: [
      navItem('/'),
      navItem('/overview'),
      navItem('/po-inbox'),
      // 🔴 Kein Zaehler-Abzeichen. Ein Abzeichen zeigte den BESTAND — gemessen 22 offene
      // Vorgaenge, die sich in sechs Tagen um einen bewegt haben — und waere nach zwei
      // Wochen Farbe ohne Aussage. Wer den Bestand sehen will, oeffnet die Seite.
      navItem('/ops/po-anomalies'),
      // 🔴 C3 (Owner-Entscheid, 2026-09-28). Die Entscheidung lautete "in
      // OpsCockpit montieren" — **eine `OpsCockpit.jsx` gibt es nicht.** Der
      // Audit nannte eine Komponente, die nie existierte. `/ops/` hat genau
      // drei Dateien, und `PoAnomalies` ist seit immer ein Menuepunkt.
      // Die zwei anderen sind seine Geschwister und stehen jetzt daneben.
      navItem('/ops/dep-health'),
      navItem('/ops/lsm-watcher'),
    ],
  },
  {
    id: 'aftersales',
    title: 'After-Sales',
    items: [
      navItem('/rma'),
      navItem('/rma/inbox'),
      navItem('/rma/reports'),
      navItem('/rma/sla-overview'),
      // Von master nach dem Katalog gebaut (Merge 30.09.) — ohne diesen
      // Eintrag waere das Ziel beim Zusammenfuehren verschwunden.
      navItem('/rma/faelligkeit'),
      navItem('/rma/analytics/inquiry-products'),
      navItem('/rma/inquiry-knowledge'),
      navItem('/reports/refunds'),    ],
  },
  {
    id: 'catalogue',
    title: 'Catalogue',
    items: [
      navItem('/products'),
      navItem('/taxonomy'),
      navItem('/vendors'),
      navItem('/media'),
    ],
  },
  {
    id: 'intelligence',
    title: 'Intelligence',
    items: [
      navItem('/intelligence/market-lab'),
      navItem('/competitors'),
      navItem('/discovery'),
      navItem('/blog-sources'),
      navItem('/scrapers'),
      navItem('/vendors/reports'),
    ],
  },
  {
    id: 'operations',
    title: 'Operations',
    items: [
      navItem('/fulfillment'),
      // 🔴 C2 (Owner-Entscheid, 2026-09-28): Vollkostenrechnung je SKU
      // (`/api/fca/by-sku`, `/api/fca/fulfillment/by-sku`). Ausgeliefert und
      // unerreichbar — kein Menuepunkt, kein Link. Gehoert zu Operations, weil
      // sie die Kosten der Abwicklung rechnet.
      navItem('/fca'),
      navItem('/incoming-inventory'),
      navItem('/kn-shipments'),
      navItem('/invoicing'), navItem('/monatsabschluss'),
      // Meldungsregister: Jahres- und Monatsmeldungen mit ihren Fristen. Bis
      // 2026-10-19 nur ueber die Befehlspalette erreichbar — `NAV_ITEMS` kannte die
      // Seite, `NAV_SECTIONS` und `MORE_SECTIONS` nicht.
      navItem('/declarations'),
      navItem('/admin/privacy'),
    ],
  },
];


// Fallback titles for routes that don't call setHeaderConfig themselves.
// Longest-prefix match is used, so /rma/some-id → 'Cases', /rma/inbox → 'Inbox'.
const ROUTE_TITLES = {
  '/':                   'Home',
  '/overview':           'Purchase Orders',
  // 5(ii) aus Welle 2 PR 2 (2026-10-06): die Detailseite `/purchase_order/:po_id`
  // rendert ihren EIGENEN `ViewHeader` und leert den geteilten Kopf bewusst
  // (`PODetail.jsx:3021`, der `useEffect` mit `setHeaderConfig`). Der Eintrag ist der Rueckfall fuer alles
  // AUSSERHALB der App-Leiste; die App-Leiste selbst zeigt fuer diese Route NICHTS,
  // weil `/purchase_order` in `ROUTES_WITH_OWN_HEADER` steht (5(i)). Ohne 5(i) haette
  // dieser Eintrag genau die Doppelung erzeugt, die 5(i) behebt (Grill B2, Ziel c).
  '/purchase_order':     'Purchase Orders',
  '/new':                'New Purchase Order',
  '/po-inbox':           'Procurement Inbox',
  '/products':           'Products',
  '/rma':                'Cases',
  '/rma/inbox':          'Inbox',
  '/rma/reports':        'Reports',
  '/rma/sla-overview':   'SLA Overview',
  '/rma/faelligkeit':    'Due',
  '/rma/analytics/inquiry-products': 'Inquiry Analytics',
  '/reports/refunds':    'Refunds',
  '/rma/new':            'New Case',
  '/rma/inquiry-knowledge': 'Knowledge Base',
  '/media':               'Media Library',
  '/vendors':            'Vendors',
  '/vendors/new':        'New Vendor',
  '/vendors/reports':    'Vendor Reports',
  '/taxonomy':           'Taxonomy Hub',
  '/competitors':        'Competitors',
  '/competitors/new':    'New Competitor',
  '/discovery':          'Discovery Inbox',
  '/blog-sources':       'Blog Sources',
  '/scrapers':           'Scrapers',
  '/scrapers/new':       'New Scraper Target',
  '/fulfillment':        'Fulfillment',
  '/incoming-inventory': 'Incoming Inventory',
  // 🔴 EINE Zeile, und das genuegt: `deriveRouteTitle` greift zuerst EXAKT zu
  //    und faellt danach auf den laengsten Praefix zurueck. Die Detailseite
  //    `/kn-shipments/:id` erbt den Titel also ueber den Praefix.
  //    ⚠️ Hier stand „BEIDE Zeilen EXAKT" — es war immer nur eine. Vom
  //    Regel-16-Tor gemessen (W6), zehn Zeilen ueber einem Kommentar, der sich
  //    fuer die Korrektur genau dieser Fehlerart lobt.
  '/kn-shipments':       'K&N Shipments',
  // 🔴 Eine Zeile genügt: `deriveRouteTitle` greift zuerst EXAKT zu und fällt
  //    danach auf den längsten Präfix zurück — die Detailseite `/invoicing/:id`
  //    (S5.5) erbt den Titel also.
  '/invoicing':          'Customer Invoices', '/monatsabschluss': 'Month-end Close',
  '/admin':              'Admin',
}

function deriveRouteTitle(pathname) {
  if (ROUTE_TITLES[pathname]) return ROUTE_TITLES[pathname]
  // Walk backwards through path segments for longest-prefix match
  const segs = pathname.split('/').filter(Boolean)
  for (let i = segs.length - 1; i >= 1; i--) {
    const prefix = '/' + segs.slice(0, i).join('/')
    if (ROUTE_TITLES[prefix]) return ROUTE_TITLES[prefix]
  }
  return ''
}

// ── Befund 5(i), Welle 2 PR 2 (2026-10-06) — die App-Leisten-Regel, Form (A) ────
//
// Die mobile App-Leiste rendert `{title || deriveRouteTitle(pathname)}`. Seiten mit
// eigenem Seitentitel zeigen ihn damit ZWEIMAL — einmal in der Leiste, einmal im
// Seitenkopf. Gemessen an zwei Formen derselben Ursache:
//
//   Home    „Home"   in der Leiste (`ROUTE_TITLES['/']`) gegen „Home"   im Kopf
//   /rma    „Cases"  in der Leiste (`ROUTE_TITLES['/rma']`) gegen „After-Sales" im Kopf
//
// Nur die MOBILE Leiste zeigt den Titel; der Desktop-`HeaderBar` rendert ihn nicht
// (`HeaderBar` nimmt `title` entgegen und gibt es nie aus). Die Doppelung ist also
// mobil-only, und die Regel ebenso.
//
// 🔴 Die Menge ist die EINE Stelle, an der die Regel lebt (Grill F3, Form (A) —
// nicht Form (B), die jede der 52 `ViewHeader`-Seiten angefasst haette). Sie muss
// GEPFLEGT werden: jede neue Seite mit eigenem Seitentitel traegt ihren Praefix hier
// ein, sonst erscheint ihr Titel auf Mobil doppelt.
//
// Treffer: exakte Ausnahme > exakter Pfad > laengster Praefix.
//   `/vendors` hat einen eigenen Kopf, `/vendors/new` (VendorWizard) NICHT — der
//   Wizard rendert einen Dialog und traegt seinen Titel ueber `headerConfig`.
//
// 🔴 FOLGE, die man kennen muss: fast JEDE Seite traegt heute einen eigenen Kopf,
// also schweigt die mobile App-Leiste fast ueberall. `deriveRouteTitle` hat genau
// EINEN Aufrufer — die mobile Leiste —, und sie ruft es NUR, wenn `hatEigenenKopf`
// FALSCH ist. Eine `ROUTE_TITLES`-Zeile fuer eine Route IN dieser Menge kann deshalb
// NIE gerendert werden; sie ist toter Text. `DocumentTitle` fuehrt ein EIGENES Array
// und ist KEIN Leser — der frueher hier genannte „Rueckfall fuer Flaechen ausserhalb
// der Leiste" benannte eine Flaeche, die es nicht gibt (Regel-15-Bericht W3, 2026-10-06).
//
// 🔴 Wer prueft, ob eine Zeile „noch gebraucht" wird, prueft gegen DIESE Menge, nicht
// gegen den Titel allein. Die Zeilen fuer `/ops/*` und `/second-life` sind deshalb
// entfernt — ihre Zusicherungen prueften toten Text. Die uebrigen Zeilen fuer Routen
// IN der Menge tragen dieselbe Eigenschaft und stehen noch.
const ROUTES_WITH_OWN_HEADER = new Set([
  '/overview',               // POOverview
  '/new',                    // PODetail (Anlege-Modus)
  '/purchase_order',         // PODetail
  '/po-inbox',               // POInbox
  '/products',               // ProductsOverview · ProductDetail · Attributes · Taxonomy
  '/second-life',            // SecondLifeBestand
  '/incoming-inventory',     // IncomingInventory
  '/kn-shipments',           // KnShipments · KnShipmentDetail
  '/fulfillment',            // FulfillmentDashboard
  '/vendors',                // VendorsOverview · VendorDetails · VendorReports
  // CustomerDetail (Stufe K, 2026-10-16) rendert einen `ViewHeader`. Der Eintrag
  // fehlte, seit die Route dazukam — `shellRouten.waechter.test.js` war deshalb
  // rot: die Route stand in der Shell, aber weder in dieser Menge noch in der
  // Ausnahmeliste. Gemessen am 2026-10-19, auf `origin/master` genauso.
  '/customers',              // CustomerDetail (ViewHeader, Stufe K)
  '/competitors',            // CompetitorList · CompetitorDetail
  '/scrapers',               // ScraperList · ScraperConfigForm · Review-Inbox · Findings
  '/intelligence/market-lab', // MarketLab
  '/taxonomy',               // TaxonomyHub
  '/admin',                  // AdminLayout (alle Unterseiten)
  '/blog-sources',           // SourceManagerPage
  '/ops',                    // DepHealth · LsmWatcher · PoAnomalies
  '/rma',                    // OverviewLayout · Inbox · Reports · Detail · Wizard · …
  '/reports/refunds',        // RefundsReport
  '/invoicing', '/monatsabschluss', // InvoiceList · InvoiceDetail · Monatsabschluss (S2)
  '/discovery',              // DiscoveryInbox
  // DesignCatalog rendert einen EIGENEN h1 („Komponentenkatalog"). Ohne diese Zeile
  // faellt der Leisten-Titel auf `deriveRouteTitle('/design')` zurueck — der heute ''
  // liefert, also zufaellig nichts zeigt. Die Zeile macht den Grund wahr: die Seite
  // ist kopfbesitzend, die Leiste schweigt DESHALB. (Regel-15-Bericht W1 + Regel-16 W1.)
  '/design',                 // DesignCatalog (eigener h1, Komponentenkatalog)
  '/media',                  // MediaLibraryPage (ViewHeader, seit 2026-10-07)
  '/fca',                    // FCADashboard (eigener h5, kein ViewHeader)
  '/notifications',          // NotificationCenter
  '/settings/notifications', // SettingsNotifications
  '/declarations',           // Meldungen · MeldungDetail (ViewHeader, Meldungsregister)
])

// Exakte Pfade, die TROTZ eines Praefix-Treffers keinen eigenen Seitentitel haben.
const ROUTES_WITHOUT_OWN_HEADER = new Set([
  '/vendors/new',            // VendorWizard — Dialog, Titel ueber `headerConfig`
])

// '/' ist EXAKT (Home), NICHT Praefix — als Praefix traefe es jede Route.
const ROUTE_WITH_OWN_HEADER_EXACT = new Set(['/'])

/**
 * hatEigenenKopf — rendert die Seite ihren eigenen Seitentitel?
 *
 * true  → die mobile App-Leiste zeigt KEINEN Titel; die Seite traegt ihn allein.
 * false → die App-Leiste zeigt `title || deriveRouteTitle(pathname)`.
 */
export function hatEigenenKopf(pathname) {
  if (ROUTES_WITHOUT_OWN_HEADER.has(pathname)) return false
  if (ROUTE_WITH_OWN_HEADER_EXACT.has(pathname)) return true
  if (ROUTES_WITH_OWN_HEADER.has(pathname)) return true
  const segs = pathname.split('/').filter(Boolean)
  for (let i = segs.length - 1; i >= 1; i--) {
    const prefix = '/' + segs.slice(0, i).join('/')
    if (ROUTES_WITH_OWN_HEADER.has(prefix)) return true
  }
  return false
}

/**
 * gruppiereNachArt — die Gruppen der Trefferliste, in der Reihenfolge der EINGABE.
 *
 * 🔴 **Keine Sortierung — und das ist die Zusicherung, nicht eine Auslassung.**
 * Seit Stufe R (`backend/search.py`, `ART_RANG`) kommt die Liste bereits in der
 * Relevanz-Rangfolge: Gewichtsstufe, dann Textrang, dann Art, dann Schluessel.
 * Eine zweite Sortierung hier waere ein zweiter Ort fuer dieselbe Ordnung — und
 * ein Kopf, der beim Tippen umspringt, ist genau das, was Owner F2 mit
 * „logische und sinnvolle Reihenfolge" nicht gemeint hat.
 *
 * `Object.entries` ueber ein `reduce` behaelt die Einfuegereihenfolge der
 * Schluessel: die Gruppe steht dort, wo ihr ERSTER Treffer steht. Der Rueckfall
 * `'other'` faengt eine Art ohne `type` ab, statt sie zu verlieren.
 *
 * Gepinnt von `SidebarAndHeaderBar.gruppenordnung.test.js`.
 *
 * @param {Array<{type?: string}>} results Treffer in der Reihenfolge des Backends
 * @returns {Array<[string, Array]>} Paare `[art, treffer]` in Einfuegereihenfolge
 */
export function gruppiereNachArt(results) {
  return Object.entries((results || []).reduce((acc, r) => {
    const k = r.type || 'other';
    (acc[k] ||= []).push(r);
    return acc;
  }, {}))
}

/**
 * AbschnittsKopf — die Ueberschrift eines Abschnitts, auf- und zuklappbar.
 *
 * 🔴 Im Bearbeitungsmodus ist der Kopf STILLGELEGT (`disabled`, kein Chevron):
 *   das Auf- und Zuklappen wuerde die Zieh-Flaechen verschieben, waehrend jemand
 *   sortiert (Plan §E7/W11). `AbschnittsKopf` ist absichtlich hier und nicht in
 *   `navigation/SeitenleisteBearbeiten.jsx`: die Ueberschrift traegt `fontSize: 10`,
 *   und eine rohe Schriftgroesse in einer bisher sauberen Datei macht
 *   `check_ui_tokens.py` rot (Regel 22, §6.7). Hier steht sie schon in der
 *   Grundlinie.
 */
export function AbschnittsKopf({ titel, offen, onToggle, stillgelegt = false }) {
  return (
    <ListItemButton
      onClick={stillgelegt ? undefined : onToggle}
      disabled={stillgelegt}
      // 🔴 Name und `aria-expanded` bleiben in BEIDEN Modi stehen: der Name ist
      // die Adresse der Flaeche, und ein Modus, der sie umbenennt, macht jede
      // Suche nach ihr zweideutig. Stillgelegt ist nur die HANDLUNG.
      aria-expanded={offen}
      aria-label={`${titel} section, ${offen ? 'expanded' : 'collapsed'}`}
      sx={{
        py: 0.5,
        px: 2.5,
        mt: 1,
        gap: 1,
        borderRadius: 0,
        // 🔴 Zuruecksetzung bleibt NACKT: sie NIMMT MUI's `ListItemButton`-Hover weg,
        // sie bringt keinen (`pattern-library.md` §Hover-Hintergrund). Ein Gatter
        // liesse ihn auf einem groben Zeiger stehen — genau der Zustand, den K-H beendet.
        '&:hover': { bgcolor: 'transparent' },
        // 🔴 Im Modus stillgelegt, aber LESBAR: der Abschnittsname ist dort die
        // EINZIGE Orientierung, welchen Abschnitt man gerade umsortiert. MUI's
        // Default `&.Mui-disabled { opacity: 0.38 }` liesse ihn auf ~1,7:1
        // fallen (text.secondary = Alpha 0,6, mal 0,38, auf Weiss). Die
        // Stilllegung tragen schon der fehlende Chevron (unten) und das
        // entfernte Hover — der Name bleibt deshalb voll deckend. Die
        // Pill-Hauszahl 0,45 hoebe ihn nur auf ~1,9:1, weiter weit unter 4,5:1.
        '&.Mui-disabled': { opacity: 1 },
      }}
      disableRipple
    >
      <Typography
        variant="overline"
        sx={{
          flex: 1,
          color: 'text.secondary',
          fontSize: 10,
          letterSpacing: 1.2,
          lineHeight: 1,
        }}
      >
        {titel}
      </Typography>
      {/* Unread counts moved to per-entry badges below */}
      {!stillgelegt && (
        <ExpandMoreIcon
          sx={{
            fontSize: 16,
            color: 'text.disabled',
            transform: offen ? 'rotate(0deg)' : 'rotate(-90deg)',
            transition: 'transform 0.2s',
          }}
        />
      )}
    </ListItemButton>
  )
}

// ① Create the context
export const UnsavedContext = createContext({
    unsaved: false,
    registerDiscard: (fn)=>{},
    clearUnsaved: ()=>{}
  })

/**
 * Sidebar component.
 *
 * 🔴 `anpassen`/`setAnpassen` kommen seit dem 2026-10-06 von aussen: der
 *   Customize-Modus aendert die BREITE der Leiste, und die steht als
 *   `--sidebar-width` am Grid-Rahmen — eine Ebene ueber dieser Komponente.
 *   Beide Props haben Vorgaben, damit ein direktes `<Sidebar />` (die
 *   Jest-Suiten tun das) unveraendert weiterlaeuft.
 */
export function Sidebar({
  onNavigate,
  headerHeight = 64,
  anpassen = false,
  setAnpassen = () => {},
}) {
  const location = useLocation();

  const { mode, toggleColorMode } = useColorMode();

  // ── Persoenlicher Geltungsbereich der Navigation (W-21) ──────────────────
  // Geteilt bleibt, was die Verwaltung definiert: Abschnitte, Beschriftungen,
  // Symbole. Persoenlich sind Sichtbarkeit und Reihenfolge INNERHALB eines
  // Abschnitts. Die Invariante (ein Abschnitt behaelt seinen Standard) sitzt
  // in `sidebarPrefs.js`, nicht hier — sie ist eine Regel, kein Layout.
  const [prefs, setPrefs] = useState(() => holePrefs());
  // Der Quellabschnitt eines laufenden Zuges. Er ist der DOM-Riegel gegen den
  // Zug ueber die Abschnittsgrenze: jedes andere `Droppable` wird gesperrt,
  // solange er gesetzt ist (Plan §3.3, B1). `null` heisst „aus den Favoriten".
  const [quellAbschnitt, setQuellAbschnitt] = useState(null);
  const setzePrefs = (naechste) => { setPrefs(naechste); merkePrefs(naechste); };

  // Collapsible section state — persisted in localStorage
  const [collapsed, setCollapsed] = useState(() => {
    try {
      const stored = localStorage.getItem('pog-nav-collapsed');
      return stored ? JSON.parse(stored) : {};
    } catch { return {}; }
  });
  const toggleSection = (id) => {
    setCollapsed((prev) => {
      const next = { ...prev, [id]: !prev[id] };
      try { localStorage.setItem('pog-nav-collapsed', JSON.stringify(next)); } catch { /* quota */ }
      return next;
    });
  };

  // Sidebar badges — `casesUnread` now means "open cases" (status NOT in
  // resolved/rejected/cancelled), not "cases with new updates since last
  // view". The previous unread-based count inflated past the actual work
  // queue because terminal cases keep receiving updates (refund settles,
  // archive, etc). The inbox count (N62, 2026-09-27) is the SERVER's `total`
  // of unarchived rows that staff has not processed yet OR whose processing
  // failed (`action_taken` in pending, error). Until N62 it counted `pending`
  // client-side over at most 100 rows (`per_page` is capped server-side) and
  // showed 3 of 10 at prod; failed rows were never counted. `stats.inbox_pending`
  // (pending + notified) is a different set and stays that way (N35).
  const [casesUnread, setCasesUnread] = useState(0);
  const [inboxUnread, setInboxUnread] = useState(0);
  const [gdprPending, setGdprPending] = useState(0);
  useEffect(() => {
    let cancelled = false;
    const fetchCounts = async () => {
      try {
        const [casesRes, inboxRes, gdprRes] = await Promise.all([
          axios.get(`${API}/api/rma/cases`, { params: { open_only: true } }),
          // One row requested, only `total` read. `.catch` yields total 0 → no
          // badge: the one place where "unknown" shows as "nothing" (pre-existing
          // trade-off, a badge has no cell for a dash).
          axios.get(`${API}/api/rma/inbox`, { params: { action: ['pending', 'error'], archived: '0', per_page: 1 } })
            .catch(() => ({ data: { total: 0, items: [] } })),
          axios.get(`${API}/api/admin/privacy/requests/count-open`).catch(() => ({ data: { count: 0 } })),
        ]);
        if (cancelled) return;
        const cases = Array.isArray(casesRes.data) ? casesRes.data : [];
        setCasesUnread(cases.length);
        setInboxUnread(inboxRes.data?.total ?? 0);
        setGdprPending(gdprRes.data?.count || 0);
      } catch { /* ignore */ }
    };
    fetchCounts();
    const iv = setInterval(fetchCounts, 60_000);
    return () => { cancelled = true; clearInterval(iv); };
  }, []);

  // ── Bearbeitungsmodus: Favoriten, Zaehler, Zug (W-21b) ──────────────────────
  // 🔴 `favoriten[]` ist die EINZIGE Quelle der Favoriten-Reihenfolge. Der
  // Abschnitt wird AUSSERHALB der `NAV_SECTIONS`-Abbildung gerendert: er hat kein
  // `items`, und `isSectionActive` (`section.items.some`) wuerfe beim ersten
  // Rendern (Plan §3.1, N8). Unbekannte Pfade fallen still heraus — sie kommen
  // aus `localStorage`, nicht aus dem Quelltext (`navItemSicher`).
  const favoritenZeilen = (prefs.favoriten || []).map(navItemSicher).filter(Boolean);
  const favoritenEingeklappt = !anpassen && !!collapsed[FAVORITEN];

  // Der Zaehler haengt am PFAD, nicht am Abschnitt: sonst verloere die
  // Favoriten-Kopie von `/rma` ihren Zaehler still (Plan §6.9).
  const badgeFuer = (path) => {
    if (path === '/rma') return casesUnread;
    if (path === '/rma/inbox') return inboxUnread;
    if (path === '/admin/privacy') return gdprPending;
    return 0;
  };
  const badgeKnoten = (count) => (count > 0 ? (
    <Box
      component="span"
      sx={{
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        borderRadius: 99,
        fontSize: 10,
        fontWeight: 600,
        minWidth: 18,
        height: 18,
        px: 0.75,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      {count > 99 ? '99+' : count}
    </Box>
  ) : null);

  // Die TATSAECHLICH gerenderten Pfade — im Modus ALLE Eintraege (ein
  // ausgeblendeter steht dort an seinem Platz), ausserhalb nur die sichtbaren.
  // Beide Mengen tragen die Favoriten-Pfade, sonst waere die Kopie eines
  // ausgeblendeten Eintrags traegerlos (Plan §3.4, N3/B4).
  const kandidaten = anpassen
    ? [
      ...NAV_SECTIONS.flatMap((s) => sortiereNachPrefs(s, prefs).map((i) => i.path)),
      ...favoritenZeilen.map((e) => e.path),
    ]
    : alleSichtbarenPfade(prefs);

  // 🔴 Die SICHTBARE Aktiv-Marke: der LAENGSTE passende Eintrag gewinnt.
  //
  // Bis zum 2026-10-07 war das ein Praefix-Vergleich
  // (`location.pathname.startsWith(path + '/')`), und auf `/rma/faelligkeit`
  // leuchteten „Cases" (`/rma`) UND „Due" (`/rma/faelligkeit`) gleichzeitig —
  // auf `/rma/reports` „Cases" und „Reports". Zwei Marken nebeneinander sagen
  // „du bist hier" zweimal und damit nichts.
  //
  // `istAktuelleSeite` traegt genau diese Regel seit R16 fuer `aria-current`
  // („der laengste Treffer gewinnt"); die sichtbare Marke folgt ihr jetzt,
  // statt eine zweite Regel zu fuehren. `kandidaten` sind die TATSAECHLICH
  // gerenderten Pfade — ein ausgeblendetes Kind gibt die Markierung damit an
  // den sichtbaren Eltern weiter, statt sie verschwinden zu lassen.
  const isActivePath = (path) => istAktuelleSeite(path, location.pathname, kandidaten);

  // Check if any item in a section is active (to auto-expand that section)
  const isSectionActive = (section) => section.items.some((item) => isActivePath(item.path));

  /** Die Zeilen EINES Bereichs in der Reihenfolge, die das DOM zeigt (Index-Zuordnung des Zuges). */
  const zeilenFuer = (bereichId) => (
    bereichId === FAVORITEN
      ? favoritenZeilen
      : sortiereNachPrefs(NAV_SECTIONS.find((s) => s.id === bereichId), prefs)
  );

  const onDragStart = ({ source }) => {
    setQuellAbschnitt(source.droppableId === FAVORITEN ? null : source.droppableId);
  };
  const onDragEnd = ({ source, destination }) => {
    setQuellAbschnitt(null);
    if (!destination) return;
    const pfad = zeilenFuer(source.droppableId)[source.index]?.path;
    if (!pfad) return;
    const vonSection = source.droppableId === FAVORITEN
      ? null
      : NAV_SECTIONS.find((s) => s.id === source.droppableId) || null;
    setzePrefs(wendeZugAn(prefs, {
      pfad, vonSection, nachId: destination.droppableId, index: destination.index,
    }));
  };

  /** EINE Zeile eines Verwaltungs-Abschnitts (im Modus mit Griff · Auge · Stern). */
  const zeileAbschnitt = (entry, i, section, griffProps, isDragging) => {
    const { path, label, icon } = entry;
    const versteckt = prefs.versteckt.includes(path);
    const favorit = istFavorit(path, prefs);
    const gesperrt = versteckt ? false : !darfVerstecken(section, path, prefs);
    return (
      <SeitenleisteZeile
        icon={icon}
        label={label}
        active={isActivePath(path)}
        // R16-A C1 / R16-B W4: nur der LAENGSTE Treffer traegt `aria-current`,
        // und bei einer Kopie entscheidet `ariaCurrentTraeger` (Plan §3.4, B4).
        ariaCurrent={ariaCurrentTraeger(path, location.pathname, kandidaten, { istKopie: false })}
        onClick={() => onNavigate(path)}
        // Der Radius ist ein Gestaltungswert der LISTE, nicht der Zeile — er
        // kommt als `sx` herein und haelt die ausgezogene Datei literal-frei.
        sx={ZEILEN_SX}
        badge={badgeKnoten(badgeFuer(path))}
        modus={anpassen}
        gedimmt={anpassen && versteckt}
        griffProps={anpassen ? griffProps : null}
        wackeln={anpassen && !isDragging}
        isDragging={isDragging}
        wackelVersatz={i}
        // W1: die Heimatzeile eines angehefteten Eintrags sagt, was der Stern dort
        // bedeutet — die Kopie bleibt naemlich stehen.
        titel={anpassen && favorit ? 'Pinned to favorites. The original stays here.' : null}
        auge={anpassen ? {
          // `gedrueckt` heisst „ausgeblendet" und traegt `aria-pressed`; das
          // SYMBOL zeigt denselben Zustand (offenes Auge = sichtbar), der NAME
          // dagegen die AKTION. Owner-Entscheid 2026-10-06.
          gedrueckt: versteckt,
          gesperrt,
          label: `${versteckt ? 'Show' : 'Hide'} ${label}`,
          titel: versteckt
            ? 'Show'
            : (gesperrt
              ? (istStandard(section, path)
                ? 'Default of this section. Stays visible.'
                : 'Last visible entry')
              : 'Hide'),
          onClick: () => setzePrefs(versteckt ? zeige(path, prefs) : verstecke(section, path, prefs)),
        } : null}
        stern={anpassen ? {
          gedrueckt: favorit,
          label: favorit ? `Remove ${label} from favorites` : `Add ${label} to favorites`,
          titel: favorit ? 'Remove from favorites' : 'Add to favorites',
          onClick: () => setzePrefs(favorit ? loeseFavorit(path, prefs) : hefteAn(path, prefs)),
        } : null}
      />
    );
  };

  /** EINE Favoriten-Zeile — Griff + Stern, KEIN Auge (Plan §3.4). */
  const zeileFavorit = (entry, i, griffProps, isDragging) => {
    const { path, label, icon } = entry;
    // Traegt die Heimatzeile `aria-current`, traegt die Kopie es nie.
    const heimatGerendert = anpassen || !prefs.versteckt.includes(path);
    return (
      <SeitenleisteZeile
        icon={icon}
        label={label}
        active={isActivePath(path)}
        ariaCurrent={ariaCurrentTraeger(
          path, location.pathname, kandidaten, { istKopie: true, heimatGerendert },
        )}
        onClick={() => onNavigate(path)}
        sx={ZEILEN_SX}
        badge={badgeKnoten(badgeFuer(path))}
        modus={anpassen}
        griffProps={anpassen ? griffProps : null}
        wackeln={anpassen && !isDragging}
        isDragging={isDragging}
        wackelVersatz={i}
        // W5: eigener, unsichtbarer Textknoten — nicht mit dem Label verkettet.
        // Er geht auch in die Namen der Bedienelemente (Griff, Stern), sonst
        // truegen Kopie und Heimatzeile denselben Knopfnamen.
        zusatzName={FAVORIT_ZUSATZ}
        stern={anpassen ? {
          gedrueckt: true,
          label: `Remove ${label}${FAVORIT_ZUSATZ} from favorites`,
          titel: 'Remove from favorites',
          onClick: () => setzePrefs(loeseFavorit(path, prefs)),
        } : null}
      />
    );
  };

  return (
    <Drawer
      // Kennung fuer den Smoke-Test: das GERUEST, das beim Nachladen stehen
      // bleiben muss. Ein `main` taete es nicht — der Platzhalter sitzt darin.
      data-testid="app-frame"
      variant="permanent"
      PaperProps={{
        sx: {
          width: 'var(--sidebar-width)',
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          borderRight: '1px solid',
          borderColor: 'divider',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.paper',
          zIndex: (theme) => theme.zIndex.appBar - 1,
        },
      }}
    >
      <Toolbar sx={{ minHeight: headerHeight }} />

      {/* Scrollable menu area */}
      <Box sx={{ flex: 1, overflowY: 'auto', py: 1 }}>
        <SeitenleisteBearbeiten
          offen={anpassen}
          onUmschalten={() => setAnpassen(v => !v)}
          prefs={prefs}
          setzePrefs={setzePrefs}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
        >
          {/* ── Favoriten (W-21b) ────────────────────────────────────────────
              Der oberste Abschnitt, AUSSERHALB der `NAV_SECTIONS`-Abbildung:
              er hat kein `items`, und `isSectionActive` (`section.items.some`)
              wuerfe beim ersten Rendern (Plan §3.1, N8). Ausserhalb des Modus
              nur mit Eintraegen; im Modus immer, dann leer als Ablageflaeche
              mit Hinweis (Plan §4 S5). `wendeAn` wird auf ihn NIE angewandt —
              er ist keine `NAV_SECTIONS`-Struktur, sondern eine Pfadliste. */}
          {(anpassen || favoritenZeilen.length > 0) && (
            <Box sx={{ mb: 0.5 }}>
              <AbschnittsKopf
                titel="Favorites"
                offen={!favoritenEingeklappt}
                onToggle={() => toggleSection(FAVORITEN)}
                stillgelegt={anpassen}
              />
              <Collapse in={!favoritenEingeklappt} timeout={200}>
                {/* Die Favoritenliste nimmt IMMER an: ein Zug aus einem
                    Abschnitt heftet an (Plan §3.3, Zeile 3). */}
                <Zeilenbereich bereichId={FAVORITEN} modus={anpassen} sx={{ px: 1.5 }}>
                  {anpassen && favoritenZeilen.length === 0 && (
                    <Typography variant="body2" sx={{ px: 1.5, py: 1, color: 'text.secondary' }}>
                      Nothing pinned yet. Drag entries here or tap the star.
                    </Typography>
                  )}
                  {favoritenZeilen.map((entry, i) => (
                    <SortierbareZeile
                      key={entry.path}
                      modus={anpassen}
                      draggableId={`${FAVORITEN}::${entry.path}`}
                      index={i}
                      zeile={(griffProps, isDragging) => zeileFavorit(entry, i, griffProps, isDragging)}
                    />
                  ))}
                </Zeilenbereich>
              </Collapse>
            </Box>
          )}

          {/* 🔴 Die Grenze Favoriten ↔ erster Abschnitt (Owner-Befund 2026-10-06).
              Der erste Abschnitt hat KEINEN Kopf (`title: null`), also lesen sich
              seine Eintraege mit „Favorites" darueber wie Favoriten — auch
              ausserhalb des Modus. Die Linie steht genau dann, wenn der
              Favoritenblock steht; Abstand aus `SP`, nicht aus einer Zahl. */}
          {(anpassen || favoritenZeilen.length > 0) && (
            <Divider sx={{ mx: SP.card, my: SP.tight }} />
          )}

          {NAV_SECTIONS.map((section) => {
            const sectionActive = isSectionActive(section);
            // 🔴 Im Modus ist kein Abschnitt eingeklappt: ein eingeklappter
            // Abschnitt haette keine Zieh-Flaeche (Plan §E7).
            const isCollapsed = anpassen
              ? false
              : (section.title ? (collapsed[section.id] && !sectionActive) : false);
            // Im Modus rendert die Hauptliste ALLE Eintraege (`sortiereNachPrefs`)
            // — ein ausgeblendeter bleibt an seinem Platz sichtbar und ist
            // gedimmt (Plan §4 S3, N3). Dieselbe Menge sind die `kandidaten`.
            const zeilen = anpassen ? sortiereNachPrefs(section, prefs) : wendeAn(section, prefs);

            return (
              <Box key={section.id} sx={{ mb: 0.5 }}>
                {/* Section header (skip for first unnamed group) */}
                {section.title && (
                  <AbschnittsKopf
                    titel={section.title}
                    offen={!isCollapsed}
                    onToggle={() => toggleSection(section.id)}
                    stillgelegt={anpassen}
                  />
                )}

                <Collapse in={!isCollapsed} timeout={200}>
                  <Zeilenbereich
                    bereichId={section.id}
                    modus={anpassen}
                    // Der DOM-Riegel gegen den Zug ueber die Abschnittsgrenze:
                    // nur der eigene Abschnitt nimmt an, solange gezogen wird —
                    // Plan §3.3, B1.
                    isDropDisabled={section.id !== quellAbschnitt}
                    sx={{ px: 1.5 }}
                  >
                    {zeilen.map((entry, i) => (
                      <SortierbareZeile
                        key={entry.path}
                        modus={anpassen}
                        draggableId={`${section.id}::${entry.path}`}
                        index={i}
                        zeile={(griffProps, isDragging) => zeileAbschnitt(entry, i, section, griffProps, isDragging)}
                      />
                    ))}
                  </Zeilenbereich>
                </Collapse>
              </Box>
            );
          })}
        </SeitenleisteBearbeiten>
      </Box>

      {/* Footer — dark mode toggle + admin */}
      {(
        <Box sx={{ px: 2, py: 1.5, borderTop: '1px solid', borderColor: 'divider' }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Tooltip title={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
              <IconButton size="small" onClick={toggleColorMode}>
                {mode === 'dark' ? <Sun size={18} strokeWidth={1.75} /> : <Moon size={18} strokeWidth={1.75} />}
              </IconButton>
            </Tooltip>
            <Box sx={{ flex: 1 }} />
            <Tooltip title="Admin panel">
              <IconButton size="small" onClick={() => onNavigate('/admin')}>
                <Shield size={18} strokeWidth={1.75} style={{ color: 'inherit' }} />
              </IconButton>
            </Tooltip>
          </Stack>
        </Box>
      )}
    </Drawer>
  );
}


/** Styled search wrapper with animated expansion */
const SearchWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'focused',
})(({ theme, focused }) => ({
  position: 'relative',
  borderRadius: 999,
  backgroundColor: alpha(theme.palette.common.white, focused ? 0.25 : 0.15),
  // 🔴 `styled()` faellt NICHT aus der Regel: `hoverOnly` liefert ein reines
  // Objekt und funktioniert im Callback (R15 W2, Runde 1 — die Ausnahme ist
  // damit entschieden und gestrichen).
  ...hoverOnly({
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  }),
  // 🔴 G0b.5-Nachbesserung 6 (2026-10-13): `marginLeft` gilt wieder — aber nur
  // UNTER `lg` (1200 px). Dort ist die Zone das Fluss-Element von master, und
  // dort stand `marginLeft: theme.spacing(2)` (`2281716d9ed:909`). AB `lg`
  // liegt die Pille in Grid-Spalte 2; ein Rand schöbe sie um 8 px nach rechts
  // und bräche genau die Zentrierung, die die Außenspalten herstellen. Der
  // Abstand zum Rückweg-Knopf kommt dort aus `columnGap` der Zone.
  // `SearchWrapper` wird nur hier benutzt (grep, 2026-10-13) — die Ausnahme ab
  // `lg` trifft keine zweite Stelle.
  // ⚠️ Die Null steht als `theme.spacing(0)`, nicht als nackte `0`: die ist der
  // Token-Weg der Regel 22, und `check_ui_tokens.py` zählt jede nackte Zahl
  // hinter `margin*` als Rohwert (`raw_spacing`, Kalibrierung 2026-10-13).
  marginLeft: theme.spacing(2),
  [theme.breakpoints.up('lg')]: { marginLeft: theme.spacing(0) },
  width: focused ? '65ch' : '35ch',
  // 🔴 **Die Breite ist FEST — auch gegen den Inhalt** (S, Nachbesserung 4,
  // 2026-10-18). `width` allein bindet ein Flex-Kind nicht: seine automatische
  // Untergrenze ist der Min-Content, und ein langes Bereichsetikett koennte die
  // Pille darueber hinaus aufblaehen. `minWidth: 0` nimmt diese Untergrenze,
  // `overflow: 'hidden'` schneidet den Rest ab; das Etikett kuerzt selbst
  // (`SearchBereichWahl`, `renderValue`).
  //
  // 🔴 Der gemessene 32-px-Sprung (S.5: 479 → 511 px) ist damit NICHT erklaert
  // — er ist der Schwanz der 300-ms-Oeffnungsanimation (`35ch` → `65ch`), nicht
  // das Etikett: „All" gegen „Purchase Order" unterscheidet rund 70 px, und der
  // Min-Content der Pille liegt mit Bereichswahl bei ~190 px, weit unter
  // `65ch`. Die Probe misst deshalb erst nach dem Einschwingen (s.
  // `tests/search/arten.spec.ts` S.5). Diese Zeilen sind der Gurt fuer den
  // Fall, dass ein Etikett den Min-Content je darueber hebt.
  minWidth: 0,
  overflow: 'hidden',
  // 🔴 Stufe B: die Pille ist jetzt eine ZEILE aus Lupe, Bereichsauswahl und
  // Eingabe. Die BREITE bleibt unveraendert (`35ch`/`65ch`) — und das ist der
  // Punkt: `frontend/tests/listen/breite.spec.ts` (PW13) misst die Mitte genau
  // dieser Pille gegen die Mitte des Hauptbereichs. Ein Element DANEBEN haette
  // die Pille verschoben und die Probe gebrochen; eines DARIN laesst ihren Kasten
  // unberuehrt.
  display: 'flex',
  alignItems: 'center',
  transition: theme.transitions.create(['width', 'background-color'], {
    duration: theme.transitions.duration.standard,
  }),
}))

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  // 🔴 Stufe B: das Feld fuellt den REST der Pille, statt eine feste Breite
  // (`20ch`/`35ch`) zu tragen. Die feste Breite war richtig, solange links nur
  // die Lupe stand; mit der Bereichsauswahl daneben haette sie die Pille
  // ueberlaufen lassen (die Pille traegt ihre Breite selbst, `35ch`/`65ch`).
  // `minWidth: 0` ist die Bedingung dafuer, dass ein Flex-Kind schrumpfen darf.
  flex: 1,
  minWidth: 0,
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    transition: theme.transitions.create('width'),
    width: '100%',
  },
}))

/** Context & hook for dynamic header configuration */
const HeaderConfigContext = createContext({
  title: '',
  showSearch: true,
  actions: [],
  setHeaderConfig: () => {},
})

/** Call this in your pages to update title, search, and buttons */
export function useHeaderConfig() {
  return useContext(HeaderConfigContext)
}

/** Recent searches localStorage helpers */
const RECENT_SEARCHES_KEY = 'global_recent_searches'
const MAX_RECENT_SEARCHES = 10

function loadRecentSearches() {
  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY)
    return stored ? JSON.parse(stored) : []
  } catch {
    return []
  }
}

function saveRecentSearches(searches) {
  try {
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(searches.slice(0, MAX_RECENT_SEARCHES)))
  } catch {
    // Ignore storage errors
  }
}

/**
 * Was der Server als WIRKSAM gemeldet hat — aus den Antwort-Koepfen der Suche.
 *
 * 🔴 **Warum die Oberflaeche das nicht selbst ausrechnet.** Die Syntax
 * (`PO: 3822`) wird SERVERSEITIG geparst (Entscheid B6, `backend/search.py`);
 * der Browser schickt den Text roh. Ohne diese Koepfe wuesste die Pille nicht,
 * dass gerade nach Bestellungen gefiltert wird, und behauptete „All" — eine
 * Anzeige gegen die Messung (R16-B2). Ein zweiter Parser hier waere genau der
 * zweite Ort, gegen den B6 argumentiert.
 *
 * | Kopf | Rolle |
 * |---|---|
 * | `X-Search-Types` | die wirksamen Arten, komma-getrennt; **leer** = kein Filter |
 * | `X-Search-Q` | der wirksame Suchtext, prozent-kodiert — **fehlt**, wenn der Server ihn nicht angetastet hat |
 *
 * 🔴 **Zwei Rueckfaelle, beide noetig:**
 *  - Fehlt `X-Search-Types` ganz (aelterer Server, Proxy ohne Freigabe), gilt die
 *    **geschickte** Auswahl. Ein leerer Kopf ist etwas anderes als ein fehlender:
 *    der leere sagt „kein Filter", der fehlende sagt „ich weiss es nicht".
 *  - Fehlt `X-Search-Q`, ist der geschickte Text der wirksame.
 *
 * 🔴 Der Kopf kommt prozent-kodiert an, weil HTTP-Koepfe latin-1 sind und ein
 * Umlaut im Suchtext sonst als Mojibake zurueckkaeme. `decodeURIComponent` kann
 * bei verstuemmeltem Eingang werfen — dann gilt der Rohwert, nicht ein Absturz
 * der Suche.
 */
function wirksamAusKoepfen(headers, gefragt, bereich) {
  const arten = headers?.['x-search-types']
  const text = headers?.['x-search-q']
  let wirksamerText = gefragt
  if (typeof text === 'string') {
    try {
      wirksamerText = decodeURIComponent(text)
    } catch {
      wirksamerText = text
    }
  }
  return {
    bereich: typeof arten === 'string' ? arten : (bereich || ''),
    text: wirksamerText,
  }
}

/** HeaderBar renders logo, title, search or buttons, and user avatar/menu */
export function HeaderBar({
  title,
  showSearch,
  actions,
  onCreateStandalone,
  onCreateVariant,   // ← add this here
  backLink,
  appBarSx = {},
  rightAdornment = null,
}) {
  const headerHeight = 64
  const theme = useTheme()
  const navigate = useNavigate()
  // RMA new-case wizard opens as a responsive modal (Dialog / Drawer)
  // mounted at the App root. Per Samuel 2026-05-20.
  const { openWizard: openRMAWizard } = useRMAWizard()
  const hasActions = Array.isArray(actions) && actions.length > 0

  // so we can hide “Add” on /new
  const { pathname } = useLocation()

  // anchor & handlers for our “Add” dropdown
  const [addAnchor, setAddAnchor] = useState(null)
  const openAddMenu  = e => setAddAnchor(e.currentTarget)
  const closeAddMenu = () => setAddAnchor(null)


  const [searchQ, setSearchQ]     = useState('')
  // 🔴 Stufe B: der gewaehlte Suchbereich. `''` heisst „All" — und „All" geht
  // als KEIN Feld hinaus, nicht als leere Liste: der Endpunkt liest „leer oder
  // fehlt" als „wie vorher" (Plan §B).
  const [searchBereich, setSearchBereich] = useState(ALLE_BEREICHE)
  // 🔴 Stufe B (R16-B2): was der Server als WIRKSAM gemeldet hat. Die getippte
  // Syntax ueberstimmt die Auswahl SERVerseitig — hier steht nur das Ergebnis,
  // damit die Pille nicht „All" behauptet, waehrend Bestellungen kommen.
  //
  // 🔴 `fuer` ist der Text, fuer den gemessen wurde. Ohne ihn waere „gekuerzt"
  // von „veraltet" nicht zu unterscheiden: waehrend der Entprellung staende sonst
  // das Ergebnis der VORIGEN Frage in der Pille und im Leerzustand. Was daraus
  // folgt, steht unten bei `gemessen`/`wirksamBereich`/`wirksamText` — die
  // FLAECHE bleibt auf dem letzten Messwert (R16-W2), der TEXT folgt `fuer`,
  // und `syntaxWirksam` sagt, ob der Server den Text angetastet hat (R16-W1).
  const [wirksam, setWirksam] = useState({ fuer: '', bereich: ALLE_BEREICHE, text: '' })
  const [results, setResults]     = useState([])
  const [focused, setFocused]     = useState(false)
  // 🔴 R15-W-4: „nichts gefunden" und „die Suche antwortet nicht" sind ZWEI
  // Zustaende. Der `catch` setzte bisher nur die Trefferliste auf leer, und die
  // Flaeche sagte daraufhin „No results …": ein 500er sah Zeichen fuer Zeichen
  // aus wie eine ehrliche Leermenge (Regel 22 §4). Das Mobil-Panel hat dafuer
  // seit R16-W3 `mobileSearchFehler`; hier fehlte das Gegenstueck in derselben
  // Datei. `searchVersuch` ist der Wiederholweg (dieselbe Bauform wie
  // `mobileSearchVersuch`): ohne ihn waere der Fehler eine Sackgasse.
  const [searchFehler, setSearchFehler] = useState(false)
  const [searchVersuch, setSearchVersuch] = useState(0)
  const [lastResults, setLastResults] = useState([])
  const [recentSearches, setRecentSearches] = useState(() => loadRecentSearches())
  const laufendeSuche             = useRef(0)   // Wettlaufschranke, siehe fetchResults
  const inputRef                  = useRef(null)
  const searchWrapperRef          = useRef(null)
  // 🔴 Owner-Befund 2026-10-16: nach einer Bereichswahl kehrt der Fokus ins
  // Suchfeld zurueck. Die Marke traegt den Entschluss ueber die Menueschliessung
  // hinweg (`onGeschlossen` laeuft erst nach der Grow-Transition, dann ist der
  // `focused`-Wert dieser Runde nicht mehr lesbar).
  const fokusNachWahl             = useRef(false)
  // 🔴 S, Nachbesserung 3 (2026-10-18): solange das Bereichsmenue offen ist UND
  // bis zum Ende seiner Schliess-Transition, darf ein Klick daneben die
  // Kopfsuche nicht zusammenfallen lassen. Der Browser hat die jsdom-
  // Schlussfolgerung der Vorgaengerrunde widerlegt (S.5, unmutiert rot): nach
  // der Wahl war die Trefferliste WEG. Welcher der beiden Wege im Browser
  // feuerte — `ClickAwayListener` oder der `onClick` des Backdrops —, ist
  // NICHT gemessen; die Marke schliesst beide, weil sie in `handleClickAway`
  // steht und nicht an einem der zwei Aufrufer.
  const bereichsMenueOffen        = useRef(false)

  // 1) Debounced fetch
  // eslint-disable-next-line react-hooks/exhaustive-deps -- debounce wrapper; inner deps unknown to ESLint
  const fetchResults = useCallback(debounce(async (q, bereich) => {
    // Laufende Nummer gegen den Wettlauf: bei schnellem Tippen sind mehrere
    // Anfragen unterwegs, und sie kommen NICHT zwingend in der Reihenfolge
    // zurueck, in der sie losgeschickt wurden. Ohne diese Schranke ueberschreibt
    // die Antwort auf `kaf` die Anzeige fuer `kaffee`.
    //
    // Vom Regel-16-Gate am Bildschirm bestaetigt (14.08.), und ausdruecklich
    // VORBESTEHEND — unter GET war dieselbe Schranke schon nicht da. Der
    // Wechsel auf POST hat es nur sichtbarer gemacht: der Browser kann
    // identische POST-Anfragen nicht mehr zusammenfassen.
    //
    // Das richtige Muster stand im selben Diff drei Dateien weiter:
    // `HomeDashboard.jsx` fuehrt eine `active`-Schranke und zeigt deshalb
    // korrekt das juengste Ergebnis.
    const nr = ++laufendeSuche.current
    try {
      // POST, nicht GET: der Suchbegriff darf nicht in die URL. Renders
      // Anfrageprotokoll fuehrt den Query-String je Zeile mit, und dort tippen
      // Nutzer Kundennamen und Mailadressen. Ruempfe protokolliert Render nicht.
      // 🔴 Stufe B: `types` geht MIT — sonst filtert die Bereichswahl nichts.
      // Bei „All" wird das Feld WEGGELASSEN (nicht als `[]` geschickt): der
      // Endpunkt liest „leer oder fehlt" als „alle Arten", und ein ausdrueckliches
      // `[]` waere eine zweite Schreibweise fuer denselben Fall.
      const { data, headers } = await axios.post(`${API}/api/search`, {
        q,
        ...(bereich ? { types: [bereich] } : {}),
      });
      if (nr !== laufendeSuche.current) return   // eine neuere Anfrage laeuft
      setResults(data)
      setLastResults(data) // Preserve results for re-opening
      setSearchFehler(false)
      // 🔴 Stufe B (R16-B2): der wirksame Bereich und der wirksame Text kommen
      // aus den Antwort-Koepfen — hier wird NICHTS geparst (B6).
      setWirksam({ fuer: q, ...wirksamAusKoepfen(headers, q, bereich) })
    } catch {
      if (nr !== laufendeSuche.current) return
      setResults([])
      // 🔴 R15-W-4: nicht nur die Liste leeren — sonst behauptete die Flaeche
      // „nichts gefunden" ueber eine Frage, die nie beantwortet wurde.
      setSearchFehler(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, 300), []) // debounce wrapper; deps unknown to ESLint

  // 2) Trigger fetch when query OR area changes
  // 🔴 Stufe B: die Bereichswahl ist ein zweiter Ausloeser. Ohne sie in den
  // Abhaengigkeiten bliebe die Liste stehen, wenn jemand bei getippter Suche
  // den Bereich umstellt — das Feld saehe aus, als wirke es nicht.
  useEffect(() => {
    if (searchQ) {
      // 🔴 R15-W-4: der Fehler gilt der VORIGEN Frage. Er wird beim Beginn einer
      // neuen zurueckgesetzt — hier, nicht im entprellten `fetchResults`: die
      // Entprellung selbst ist Wartezeit, und genau in ihr stuende sonst der
      // alte Fehler ueber der neuen Frage (dieselbe Begruendung wie im
      // Mobil-Panel, wo beide Zustaende VOR dem Timer gesetzt werden).
      setSearchFehler(false)
      fetchResults(searchQ, searchBereich)
    } else {
      setResults([])
      setSearchFehler(false)
      // 🔴 Ohne Text gibt es keine wirksame Syntax mehr — die Pille faellt auf
      // die Auswahl zurueck. Ohne diese Zeile stuende nach `PO: 3822` und
      // anschliessendem Leeren weiter „Purchase Order (po:)" da, obwohl nichts
      // gefiltert wird: dieselbe Anzeige gegen die Messung, nur andersherum.
      setWirksam({ fuer: '', bereich: searchBereich, text: '' })
    }
  }, [searchQ, searchBereich, fetchResults, searchVersuch])

  // Add to recent searches when navigating to a result
  const addToRecentSearches = useCallback((item) => {
    setRecentSearches(prev => {
      // Remove if already exists, add to front
      const filtered = prev.filter(r => !(r.type === item.type && r.key === item.key))
      const updated = [item, ...filtered].slice(0, MAX_RECENT_SEARCHES)
      saveRecentSearches(updated)
      return updated
    })
  }, [])

  // Handle focus - show recent searches or last results
  const handleSearchFocus = useCallback(() => {
    setFocused(true)
    // If no query but we have last results, show them
    if (!searchQ && lastResults.length > 0) {
      setResults(lastResults)
    }
  }, [searchQ, lastResults])

  // Handle click away - collapse but preserve state
  //
  // 🔴 **Die jsdom-Messung der Vorgaengerrunde war falsch geschlossen** (S,
  // Nachbesserung 3, 2026-10-18). Dort stand: „`focused` aendert sich bei einer
  // Bereichswahl NICHT", gestuetzt auf MUI's `syntheticEventRef` und einen
  // Jest-Lauf. **Der Browser widerlegt das:** `tests/search/arten.spec.ts` S.5
  // ist unmutiert rot — nach der Wahl ist `kopf-trefferliste` aus dem DOM, und
  // sie haengt allein an `focused` (`showDropdown` unten). jsdom kann diesen Weg
  // nicht zeigen: es gibt keine native Fokusreihenfolge, keine Portal-
  // Trefferflaeche und keinen Schliess-Transition-Takt; die Jest-Probe sieht nur
  // den Zustand, den sie selbst herstellt.
  //
  // 🔴 **Welcher Weg im Browser feuerte, ist NICHT gemessen** — es gibt zwei,
  // und beide enden hier: der `ClickAwayListener` um die Suchpille und der
  // `onClick` des Such-Backdrops. Deshalb steht der Riegel in DIESER
  // Funktion und nicht an einem der zwei Aufrufer: er deckt beide.
  // (Der Backdrop trug bis zur Nachbesserung 5 `onPointerDown` — siehe die
  // Begruendung an seiner Stelle: er war damit vor `mouseup`/`click` weg, und
  // der Rest des Klicks traf die Seite darunter.)
  //
  // Die Marke traegt vom Oeffnen des Menues bis zum Ende seiner Schliess-
  // Transition (`onGeoeffnet` / `onGeschlossen` an `SearchBereichWahl`). In
  // dieser Zeit ist ein Klick daneben KEIN „daneben": er gehoert zum Menue.
  // Danach faellt die Marke, und der Klick daneben wirkt wieder — die
  // Kalibrierung in S.5 misst genau das.
  const handleClickAway = useCallback(() => {
    if (bereichsMenueOffen.current) return
    setFocused(false)
    // Don't clear results - keep them for re-opening
  }, [])

  // Determine what to show in dropdown
  const showRecentSearches = focused && !searchQ && results.length === 0 && recentSearches.length > 0
  const displayResults = showRecentSearches ? recentSearches : results
  const showDropdown = focused && (displayResults.length > 0 || (searchQ && results.length === 0))
  // 🔴 R16-W2 (Orchestrator-Entscheid, 2026-10-15) — zwei Groessen, zwei Regeln:
  //
  //   FLAECHE: bleibt auf dem letzten MESSWERT. Waehrend der Entprellung und der
  //   Laufzeit sind die sichtbaren Treffer noch die alten; ein Umschlag auf
  //   „All" widerspraeche ihnen (dieselbe Klasse wie R16-B2, nur transient).
  //   Nur solange noch NIE gemessen wurde, gilt die Auswahl — sonst zeigte die
  //   Pille beim ersten Tippen „All", obwohl „Product" gewaehlt ist.
  //
  //   TEXT: folgt `fuer`. Er ist die Aussage ueber die GESTELLTE Frage, und die
  //   steht erst fest, wenn die Antwort da ist.
  const gemessen = wirksam.fuer !== ''
  const wirksamBereich = gemessen ? wirksam.bereich : searchBereich
  const wirksamText = wirksam.fuer === searchQ ? wirksam.text : searchQ
  // 🔴 R16-W1: „die Syntax hat gegriffen" ist `text !== fuer` — der Server hat
  // den Text angetastet, und `X-Search-Q` wird nur dann gesetzt. Der blosse
  // Unterschied Auswahl ↔ wirksamer Bereich genuegt NICHT: er entsteht auch,
  // wenn die AUSWAHL gerade umgestellt wurde, und dann zeigte die Pille
  // `Product (product:)` fuer ein Token, das nie jemand getippt hat.
  const syntaxWirksam = wirksam.fuer === searchQ && wirksam.text !== wirksam.fuer

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2, // header above drawer
        left: 0,
        width: '100%',
        ...appBarSx,
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* Logo placeholder */}
        <Box sx={{ width: 100, mr: 2 }}>
          <img
            src={LogoImg}
            alt="Logo"
            style={{ maxWidth: '50px', height: 'auto' }}
          />
        </Box>

        {/* Center: either search or action buttons.
            🔴 G0b.5 (2026-10-13), NW4.7:653 / Konzept §4.4:627-639: die
            Kopfleiste ist `position: fixed; left: 0; width: 100%` — volle
            VIEWPORTbreite, kein Versatz um die Leiste. Ihre mittige Suche war
            damit auf dem Viewport zentriert, nicht auf der Inhaltsspalte (bei
            2560: Inhaltsspalte x = 240…2560, Mitte 1400; die Suche stand bei
            1280 — 120 px daneben, mit geoeffneter 280er-Leiste 140 px). Der
            `paddingLeft: var(--sidebar-width)` verschiebt die Mitte um die halbe
            Leistenbreite nach rechts — und folgt damit dem Umschalten 240 ↔ 280,
            weil `--sidebar-width` genau diesen Modus traegt (s. u. die
            Grid-Zelle). Der Mobil-Zweig (eigene `AppBar`, `:1909 ff.`) ist
            unberuehrt; dieser Kopf rendert nur `!isMobile`.
            🔴 G0b.5-Nachbesserung 6 (2026-10-13): **dieser Absatz gilt AB `lg`**
            (1200 px). Darunter ist die Zone wieder das Fluss-Element von master —
            Grund und Grenze stehen am `sx` dieses Kastens. */}
        <Box
          sx={{
            // 🔴 G0b.5-Nachbesserung 6 (2026-10-13): die Zentrierung auf den
            // Hauptbereich gilt erst AB `lg` — der MUI-Vorgabe 1200 px
            // (`theme.js` setzt kein eigenes `breakpoints`; grep, 2026-10-13).
            // Darunter ist die Zone wieder das FLUSS-Element von master
            // (`2281716d9ed:1099`): `flexGrow: 1`, `display: flex`,
            // `justifyContent: center`, `alignItems: center`, `gap: 1.5` —
            // keine absolute Schicht, kein `pl`, kein `pointerEvents`-Umbau.
            //
            // 🔴 **Warum die Grenze.** Der Desktop-Kopf rendert ab 600 px
            // (`isMobile = down('sm')`, `:1488`), und die Leiste ist dort immer
            // 240 px breit (`:1832`) — bei 600 bleiben dem Hauptbereich **360
            // px**. Die zentrierte Gruppe aus Pille (275), Abstand (12) und
            // „Add" (82) liefe dort auch im RUHEZUSTAND unter Glocke und
            // Kontomenü; die Fluss-Form kann ihre Nachbarn nicht unterlaufen,
            // sie nimmt nur den Platz, der übrig bleibt.
            //
            // 🔴 G0b.5-Nachbesserung 5 (2026-10-13), PW13: AB `lg` ist der
            // SUCHBEREICH so breit wie die Kopfleiste (volle Viewportbreite),
            // nicht die Breite zwischen Logo und Rechtszone. Mit
            // `pl: var(--sidebar-width)` liegt sein Inhaltskasten auf
            // `[sidebar, Viewport]`, seine Mitte also auf
            // `(sidebar + Viewport) / 2` — bei 240er UND 280er Leiste.
            // 🔴 **Gemessen und zentriert wird die SICHTBARE PILLE**
            // (`SearchWrapper`, `data-testid="kopf-suchkasten"`), nicht das
            // Eingabefeld und nicht die Gruppe aus Pille und „Add". Die frühere
            // Messung („Suchkasten 329 px, +1,3 px") traf den `input`, der über
            // die Pille hinausragt — sie ist **zurückgezogen** (Kopfvermerk in
            // `…/ui2/berichte/g0b5_messung_suchmitte.md`). Die reine
            // Flex-Zentrierung ließ die Pille um die halbe Add-Breite LINKS der
            // Mitte stehen (gemessen 25,7 px daneben).
            //
            // 🔴 **Warum Grid und nicht Flex.** Mit `1fr auto 1fr` tragen die
            // beiden Außenspalten gleich viel, die Pille steht in der mittleren
            // `auto`-Spalte — ihre Mitte ist damit EXAKT die Mitte des
            // Inhaltskastens, unabhängig von der Add-Breite und vom
            // Spaltenabstand (Herleitung: Außenspalten `(W − Pille − 2·gap)/2`
            // je Seite ⇒ Pille-Mitte = `W/2`). Flex `justifyContent: center`
            // zentriert stattdessen die GRUPPE; der „Add"-Knopf rechts davon
            // verschiebt die Pille nach links.
            //
            // ⚠️ **Der Überstand des `input` über die Pille ist vorbestehend**
            // (`StyledInputBase` ist `35ch` breit plus 46 px Polster links und
            // 8 px rechts, die Pille nur `35ch`) und NICHT Teil dieses Schnitts.
            //
            // ⚠️ Die `gridColumn`-Zuweisungen an den Kindern bleiben stehen: in
            // der Flex-Form unter `lg` sind Gittereigenschaften an einem
            // Flex-Element wirkungslos — `grid-column-*` gilt laut CSS Grid §6
            // nur für Gitterelemente und absolut positionierte Kästen, und
            // `justify-self` laut CSS Box Alignment ebenso. Geprüft an der
            // Spezifikation und am Kode, **nicht im Browser** (Playwright war für
            // diesen Auftrag gesperrt); PW15 misst die Wirkung.
            position: { xs: 'static', lg: 'absolute' },
            inset: { lg: 0 },
            display: { xs: 'flex', lg: 'grid' },
            flexGrow: { xs: 1, lg: 0 },
            justifyContent: { xs: 'center', lg: 'normal' },
            // ⚠️ Zwei LANGHANDS statt `gap` + `columnGap`: `gap` ist die
            // Kurzform von `column-gap`/`row-gap`, und ob die lg-Fassung der
            // einen die lg-Fassung der anderen überschreibt, hinge dann an der
            // Reihenfolge, in der MUI die Medienblöcke schreibt. In der Wirkung
            // ist es masters `gap: 1.5` (row-gap ist bei einer Zeile ohne
            // `flexWrap` ohnehin ohne Wirkung).
            columnGap: 1.5,
            rowGap: { xs: 1.5, lg: 0 },
            gridTemplateColumns: { lg: '1fr auto 1fr' },
            alignItems: 'center',
            pl: { lg: 'var(--sidebar-width)' },
            // AB `lg` deckt der Kasten Logo und Rechtszone ab — nur seine
            // BEDIENELEMENTE nehmen dort Zeiger an; alles andere faellt durch,
            // Logo, Glocke und Benutzermenue bleiben klickbar. Unter `lg` ist die
            // Zone ein normales Fluss-Element und nimmt Zeiger an.
            pointerEvents: { lg: 'none' },
            '& > *': { pointerEvents: { lg: 'auto' } },
          }}
        >
          {backLink && (
            <Button
              size="small"
              onClick={() => {
                if (backLink.onClick) backLink.onClick();
                else if (backLink.href) navigate(backLink.href);
              }}
              startIcon={<Box component="span" sx={{ fontSize: '1.2rem', lineHeight: 1 }}>‹</Box>}
              sx={{
                // G0b.5-Nachbesserung 5: linke Außenspalte, am RECHTEN Rand —
                // so steht der Rückweg-Knopf direkt links neben der Pille.
                gridColumn: 1,
                justifySelf: 'end',
                bgcolor: (theme) => alpha(theme.palette.common.white, 0.2),
                color: '#fff',
                borderRadius: 999,
                px: 2,
                height: 36,
                ...hoverOnly({
                  bgcolor: (theme) => alpha(theme.palette.common.white, 0.3),
                }),
              }}
            >
              {backLink.label}
            </Button>
          )}
          { !hasActions && showSearch && (
            <ClickAwayListener onClickAway={handleClickAway}>
              {/* G0b.5-Nachbesserung 5: mittlere `auto`-Spalte — sie trägt die
                  Pille und ist damit die gemessene und zentrierte Fläche. */}
              <Box sx={{ gridColumn: 2, display: 'flex', alignItems: 'center' }}>
                {/* 🔴 `data-testid` (G0b.5-Nachbesserung 3, 2026-10-13; Fläche
                    korrigiert in Nachbesserung 5): die Messfläche für PW13 ist
                    die SICHTBARE PILLE (`SearchWrapper`), nicht das Eingabefeld
                    und nicht die Gruppe aus Pille und „Add". Die frühere
                    Beschreibung („dieselbe 329-px-Box" des Orchestrators) traf
                    den überstehenden `input` und ist zurückgezogen
                    (`…/ui2/berichte/g0b5_messung_suchmitte.md`). Kennung, kein
                    Gestaltungsmerkmal. */}
                <SearchWrapper focused={focused} ref={searchWrapperRef} data-testid="kopf-suchkasten">
                  <SearchIconWrapper>
                    <SearchIcon />
                  </SearchIconWrapper>
                  {/* 🔴 Stufe B — die Bereichsauswahl LINKS im Suchfeld (Plan §B).
                      `marginLeft: calc(1em + spacing(4))` ist derselbe Abstand,
                      den das Eingabefeld vorher als `paddingLeft` trug: er schiebt
                      die Auswahl an der (absolut positionierten) Lupe vorbei.
                      Danach ein feiner Trenner, damit „Bereich" und „Text" nicht
                      als ein Wort gelesen werden. */}
                  <Box
                    sx={{
                      display: 'flex', alignItems: 'center',
                      // 🔴 Schrumpfbar, damit das Etikett kuerzen kann statt die
                      // Pille zu verbreitern (S, Nachbesserung 4): die Pille hat
                      // eine feste Breite, und `SearchBereichWahl` schneidet den
                      // Rest mit einer Ellipse ab. `flexShrink: 0` stand hier
                      // bis zur Nachbesserung 4 und machte den Min-Content des
                      // Etiketts zur Untergrenze der Pille.
                      flexShrink: 1, minWidth: 0,
                      ml: `calc(1em + ${theme.spacing(4)})`,
                      borderRight: '1px solid',
                      borderColor: alpha(theme.palette.common.white, 0.25),
                      pr: 1, mr: 1,
                    }}
                  >
                    <SearchBereichWahl
                      wert={searchBereich}
                      // 🔴 R16-B2: die Pille folgt dem WIRKSAMEN Bereich. Die
                      // Auswahl (`wert`) bleibt der Zustand fuer den naechsten
                      // Freitext — weicht der wirksame ab, zeigt die Komponente
                      // ihn (`Purchase Order`).
                      wirksam={wirksamBereich}
                      // 🔴 R16-W1: den Kurzweg gibt es NUR, wenn der Server den
                      // Text angetastet hat. Der blosse Unterschied Auswahl ↔
                      // wirksamer Bereich reicht nicht (s. o.).
                      syntaxWirksam={syntaxWirksam}
                      onChange={(kind) => {
                        setSearchBereich(kind)
                        // 🔴 Owner-Befund 2026-10-16, zweite Haelfte: der Fokus
                        // kehrt nach der Wahl ins EINGABEFELD zurueck. MUI gibt
                        // ihn beim Schliessen an den AUSLOESER zurueck (den
                        // Bereichsknopf); das Feld ist danach tot, und die
                        // naechste Taste erreicht die Suche nicht.
                        //
                        // ⚠️ Nur wenn die Suche OFFEN WAR. Ein `focus()` auf
                        // ein geschlossenes Feld liefe in `handleSearchFocus`
                        // und OEFFNETE eine Suche, die niemand geoeffnet hat —
                        // die Auswahl laesst sich auch ohne Fokus treffen.
                        fokusNachWahl.current = focused
                      }}
                      // 🔴 S, Nachbesserung 3: die Marke steht ab dem Oeffnen
                      // und faellt erst, wenn die Schliess-Transition durch ist.
                      // `handleClickAway` kehrt in dieser Zeit frueh zurueck —
                      // sonst nahm ein Klick im Menue der Kopfsuche die Breite
                      // und die Trefferliste (S.5, unmutiert rot im Browser).
                      onGeoeffnet={() => { bereichsMenueOffen.current = true }}
                      onGeschlossen={() => {
                        // Erst den Fokus zurueckholen, DANN die Marke loesen:
                        // `focus()` setzt `focused` ueber `handleSearchFocus`
                        // wieder auf `true`, und ein Klick, der in genau diesem
                        // Fenster daneben faellt, soll die Suche nicht erneut
                        // schliessen.
                        //
                        // 🔴 **Dieser `focus()` ueberlebt MUI jetzt** (S,
                        // Nachbesserung 4, 2026-10-18): `SearchBereichWahl`
                        // traegt `disableRestoreFocus` und setzt den Fokus
                        // selbst auf den Ausloeser, BEVOR es diesen Rueckruf
                        // ruft. Ohne das setzte MUI's `Modal` ihn nach dem
                        // `onExited` zurueck auf den Bereichsknopf — der
                        // Browserbefund war genau das (Fokusspur endete auf
                        // `bereichsknopf`).
                        if (fokusNachWahl.current) {
                          fokusNachWahl.current = false
                          inputRef.current?.focus()
                        }
                        bereichsMenueOffen.current = false
                      }}
                    />
                  </Box>
                  <StyledInputBase
                    placeholder="Search anything…"
                    inputProps={{ 'aria-label': 'search' }}
                    value={searchQ}
                    onChange={e => setSearchQ(e.target.value)}
                    onFocus={handleSearchFocus}
                    inputRef={inputRef}
                  />
                </SearchWrapper>
                {/* Search backdrop — covers sidebar + content behind dropdown.
                    Starts below the header so the AppBar + active search input
                    stay sharp/readable while the rest of the page blurs. */}
                {showDropdown && (
                  <Box
                    // 🔴 **`onClick`, NICHT `onPointerDown`** (S, Nachbesserung 5,
                    // 2026-10-18). Mit `pointerdown` hing der Backdrop ab, sobald
                    // die Maustaste herunterging — `mouseup` und `click` desselben
                    // Klicks hatten damit kein Ziel mehr und trafen die SEITE
                    // darunter. Ein Klick „daneben" loeste so Seiteninhalt aus
                    // (S.5-Kalibrierung: die Messreihe war leer, weil der Klick
                    // navigierte). `click` faellt erst, wenn der Klick vollstaendig
                    // beim Backdrop angekommen ist; das Aushaengen danach erreicht
                    // keinen zweiten Empfaenger. Der `ClickAwayListener` um die
                    // Pille deckt diesen Fall NICHT ab — der Backdrop liegt INNERHALB
                    // seines Kindes, also ruft er hier nicht. **S.7b** misst den
                    // Durchklick auf TOUCH an einem ECHTEN Seitenleisten-Eintrag
                    // (`role="button"`): Suche zu, URL unveraendert. Mit der MAUS
                    // ist er in Chromium nicht beobachtbar (Rotweg s9: MBD blieb
                    // gruen). Warum, ist eine **Hypothese**, nicht am
                    // Browser-Quelltext nachgelesen (R15-B2 = R16-W2): nach
                    // entferntem `mousedown`-Ziel kein `click` darunter.
                    //
                    // 🔴 **Auf Touch ist der WISCH gewollt** (R15-W2 = R16-W3,
                    // Entscheid S Nachbesserung 6, 2026-10-18): ein TIPP (`click`)
                    // schliesst, ein WISCH/Scroll scrollt und schliesst NICHT. Mit
                    // `pointerdown` schloss schon die Beruehrung — Preis des
                    // Durchklick-Fehlers. Widerleger: ein Owner-Wunsch, dass
                    // Scrollen die Suche schliesst (`docs/features/search.md:798`).
                    onClick={handleClickAway}
                    // Messflaeche, kein Gestaltungsmerkmal: die Kalibrierung von
                    // S.5 klickt den Backdrop ueber diese Kennung an, statt eine
                    // Bildschirmkoordinate zu raten (die bei anderer Viewportbreite
                    // in der Trefferliste landen kann).
                    data-testid="kopf-such-backdrop"
                    sx={{
                      position: 'fixed',
                      top: `${headerHeight}px`,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      zIndex: 1299,
                      bgcolor: 'rgba(0,0,0,0.25)',
                      backdropFilter: 'blur(2px)',
                      WebkitBackdropFilter: 'blur(2px)',
                    }}
                  />
                )}
                <Popper
                  open={showDropdown}
                  // 🔴 Messfläche, kein Gestaltungsmerkmal — dieselbe Bauform und
                  // dieselbe Begründung wie `kopf-suchkasten` oben. S.5
                  // (`tests/search/arten.spec.ts`) zeichnet während des
                  // Bereichswechsels alle 50 ms auf, ob die Trefferliste steht;
                  // ohne eine stabile Kennung hinge das an einer MUI-Klasse.
                  // Der `Popper` gibt bei `open={false}` `null` zurück (kein
                  // `keepMounted`), die Kennung ist also genau dann da, wenn die
                  // Liste es ist.
                  data-testid="kopf-trefferliste"
                  anchorEl={searchWrapperRef.current}
                  placement="bottom-start"
                  style={{ zIndex: 1300 }}
                  modifiers={[
                    {
                      name: 'sameWidth',
                      enabled: true,
                      phase: 'beforeWrite',
                      requires: ['computeStyles'],
                      fn: ({ state }) => {
                        state.styles.popper.width = `${state.rects.reference.width}px`
                      },
                      effect: ({ state }) => {
                        state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`
                      },
                    },
                  ]}
                >
                  <Paper
                    elevation={8}
                    sx={{
                      maxHeight: 400,
                      overflowY: 'auto',
                      mt: 0.5,
                      borderRadius: 2,
                    }}
                  >
                    {/* Recent Searches Header */}
                    {showRecentSearches && (
                      <>
                        <Box sx={{ px: 2, py: 1, bgcolor: 'action.hover' }}>
                          <Typography variant="caption" color="text.secondary" fontWeight={500}>
                            Recent Searches
                          </Typography>
                        </Box>
                        <Divider />
                      </>
                    )}
                    {/* Grouped Results — die Reihenfolge kommt aus dem Backend
                        (`gruppiereNachArt` sortiert NICHT, s. dort). */}
                    {gruppiereNachArt(displayResults).map(([group, items]) => (
                      <React.Fragment key={group}>
                        {!showRecentSearches && (
                          <Typography variant="overline" sx={{ px: 2, pt: 1, display: 'block', color: 'text.secondary' }}>
                            {/* Ein Wort je Art, aus SearchResultItem. Vorher formatierte
                                diese Zeile den Rohwert selbst und ersetzte dabei nur den
                                ERSTEN Unterstrich — „RMA INBOX_EMAIL" — und war ausserdem
                                ein zweites Vokabular neben dem Art-Chip. */}
                            {(KIND_LABEL[group] || group.replace(/_/g, ' ')).toUpperCase()}
                          </Typography>
                        )}
                        {items.map(r => (
                          <SearchResultItem
                            key={`${r.type}:${r.key}`}
                            result={r}
                            isRecent={showRecentSearches}
                            showKind={showRecentSearches}
                            onClick={() => {
                              addToRecentSearches(r)
                              setSearchQ('')
                              setResults([])
                              setFocused(false)
                              // Stufe N2: Bestelltreffer tragen den Marker
                              // `shopify-order:<id>`. 🔴 Seit R16-B1 ist die
                              // ZEILE ein echtes `<a href>` (SearchResultItem);
                              // der Browser oeffnet den Admin-Tab, hier bleibt
                              // nur der Innenweg. `oeffneTreffer` oeffnet fuer
                              // den Marker bewusst KEIN Fenster mehr.
                              oeffneTreffer(r.href, navigate)
                            }}
                          />
                        ))}
                      </React.Fragment>
                    ))}

                    {/* Leerzustand — Hausform statt handgeschriebener Zeile.
                        🔴 R16-W5: hier stand `No results for "3822" in Purchase
                        Order`, waehrend das Mobil-Panel dieselbe Auskunft mit
                        `EmptyState` als „Nothing matches “3822”. / Searched in:
                        Purchase Order" gab. Zwei Formulierungen fuer dieselbe
                        Tatsache, beide in derselben Runde entstanden. Jetzt
                        traegt der Kopf denselben Baustein und damit dieselbe
                        Wendung — und `data-reason` (Regel 22 §5) dazu.
                        🔴 R15-W-4: der FEHLER ist ein eigener Zustand. Der
                        `catch` setzte nur die Liste auf leer, und ein 500er sah
                        aus wie eine ehrliche Leermenge (Regel 22 §4). Die
                        Reihenfolge ist die Vorrangfolge — wie im Mobil-Panel:
                        Fehler schlaegt Leermenge.

                        🔴 R16-W1 = R15-W-1 (Nachbesserung 3, 2026-10-15):
                        `showDuringOutage` am FEHLERZWEIG. `EmptyState` gibt fuer
                        `reason="error"` im BESTAETIGTEN Ausfall `null` zurueck —
                        sein Vorgabeverhalten setzt voraus, dass der globale
                        Banner die Aussage traegt (`EmptyState.jsx:84-91`). Hier
                        traegt er sie NICHT: `ServiceOutageBanner` ist in `App.js`
                        vor der Schale gemountet und liegt auf
                        `zIndex.modal - 1` = **1299** — genau der Ebene des
                        Such-Hintergrunds (`:1456`, im DOM SPAETER, also darueber).
                        Der Popper (1300) traegt dann ein LEERES `Paper`: genau
                        die Stille, gegen die R15-W-4 angetreten ist, eine Stufe
                        tiefer (nicht „ein 500er", sondern „der bestaetigte
                        Ausfall"). Das Mobil-Panel setzt die Prop seit R16-W2-1
                        aus demselben Grund (`:2612-2620`).
                        ⚠️ Die Stapelreihenfolge ist am Quelltext gelesen, nicht im
                        Browser gemessen (Regel 17: der Unterscheider ist ein Bild
                        im bestaetigten Ausfall ohne leeren Kasten).

                        🔴 R16-W2 (Nachbesserung 3, 2026-10-15): die LEERMENGE erst,
                        wenn die Antwort zur AKTUELLEN Eingabe da ist. `results`
                        wird beim Tippen nicht geleert, und die Bindung oben haengt
                        an `searchQ` — war die VORIGE Frage leer, stand hier fuer
                        300 ms Entprellung plus Laufzeit „Nothing matches
                        „<neuer Text>"" ueber eine Frage, die noch gar nicht
                        gestellt war. Der Beleg, dass die Antwort zur aktuellen
                        Eingabe vorliegt, ist `wirksam.fuer === searchQ` — genau die
                        Groesse, die der Erfolgspfad setzt (`:1166`). Sonst traegt
                        das Geruest den Zustand, wie im Mobil-Panel
                        (`:2623-2642`, `SuchergebnisGeruest`, `role="status"`).
                        ⚠️ Der Fehlerzweig steht DAVOR und behaelt den Vorrang: ein
                        gescheiterter Abruf setzt `wirksam` nicht, `fuer !== searchQ`
                        gaelte dort also faelschlich als „laedt noch". */}
                    {!showRecentSearches && searchQ && results.length === 0 && (
                      searchFehler ? (
                        <EmptyState
                          reason="error"
                          message="Search is unavailable right now."
                          showDuringOutage
                          onRetry={() => setSearchVersuch((v) => v + 1)}
                        />
                      ) : wirksam.fuer === searchQ ? (
                        /* 🔴 R16-B2 (Nachbesserung 1): ist der WIRKSAME
                           Bereich eine abgeschaltete Art, ist „no-match" die
                           falsche Kategorie — es wurde nicht gesucht und nichts
                           gefunden, die Art wird gar nicht durchsucht. Der
                           Grund kommt aus derselben Server-Antwort wie das
                           Etikett (`bereichIstAbgeschaltet`), und der Ausweg
                           steht daneben. Die Sperre im Dropdown allein genuegt
                           nicht: „All" blendet die Art ebenfalls still aus,
                           und der Nutzer sieht nur ein leeres Feld. */
                        wirksamBereich && bereichIstAbgeschaltet(wirksamBereich) ? (
                          <EmptyState
                            reason="no-data"
                            message={`${bereichsEtikett(wirksamBereich)} is turned off in Admin settings.`}
                            detail="Turn it back on under Admin settings, or clear the area to search everywhere."
                            // 🔴 **R16-W4 — der Knopf setzt auch den BEREICH zurueck.**
                            // Bis hierher leerte „Clear search" nur den Text. Kam der
                            // Bereich aus der Klappliste, setzte `:1199` danach
                            // `wirksam.fuer = ''` → `gemessen` false →
                            // `wirksamBereich` unveraendert → `wirksam.fuer === searchQ`
                            // wieder wahr → **derselbe Leerzustand stand wieder da**,
                            // waehrend der Text „…or clear the area to search
                            // everywhere" genau das versprach. Ein Knopf, der nichts
                            // aendert, ist schlimmer als keiner.
                            onClearSearch={() => {
                              setSearchQ('')
                              setSearchBereich(ALLE_BEREICHE)
                            }}
                            // 🔴 **R16-W5 — der Ausweg fuehrt jetzt DORTHIN, wo er
                            // hinfuehrt.** Der Satz nennt „Admin settings", die
                            // Suchleiste steht aber auf jeder angemeldeten Seite, und
                            // der Text war der einzige Weg — ohne Weg. Der
                            // `action`-Slot von `EmptyState` ist genau dafuer gebaut
                            // und war an dieser Stelle unbenutzt. `outlined` wie die
                            // Mehrheit der Bestands-`action`-Slots (R16-W1): der
                            // Ausweg ist die Hauptsache, „Clear search" bleibt der
                            // leichtere Textknopf daneben.
                            action={(
                              <Button
                                variant="outlined"
                                onClick={() => navigate('/admin/settings')}
                              >
                                Open Admin settings
                              </Button>
                            )}
                          />
                        ) : (
                        <EmptyState
                          reason="no-match"
                          // 🔴 R16-B2, zweite Haelfte: das Echo nennt den
                          // WIRKSAMEN Text und Bereich, nicht den Rohtext. Vorher
                          // stand hier der Rohtext, und dass auf einen Bereich
                          // verengt war, stand nirgends. Die Beschriftung kommt
                          // aus derselben Server-Tabelle wie Pille und Parser
                          // (`bereichsEtikett`), nicht aus einer zweiten Liste.
                          query={wirksamText || searchQ}
                          searchedIn={wirksamBereich
                            ? bereichsEtikett(wirksamBereich)
                            : undefined}
                          onClearSearch={() => setSearchQ('')}
                        />
                        )
                      ) : (
                        <SuchergebnisGeruest />
                      )
                    )}
                  </Paper>
                </Popper>
              </Box>
            </ClickAwayListener>
          )}

          { pathname !== '/new' && !hasActions && (
                <>
                <Button
                   color="inherit"
                   startIcon={<AddCircleIcon />}
                   onClick={openAddMenu}
                   // G0b.5-Nachbesserung 5: steht eine Suche daneben, sitzt
                   // „Add" in der RECHTEN Außenspalte (3) und beginnt an deren
                   // linkem Rand — also direkt rechts neben der Pille. Ohne
                   // Suche bleibt die mittlere Spalte (2). `justifySelf: start`
                   // ist nötig, weil `1fr` den Knopf sonst über die ganze
                   // Spaltenbreite strecken würde.
                   sx={{
                     gridColumn: showSearch ? 3 : 2,
                     justifySelf: 'start',
                   }}
                 >
                   Add
                 </Button>
                {/* `Menu` ist ein Portal und erzeugt an dieser Stelle KEIN
                    Gitterelement — die DOM-Reihenfolge bleibt unverändert. */}
                <Menu
                    anchorEl={addAnchor}
                    open={Boolean(addAnchor)}
                    onClose={closeAddMenu}
                >
                    <MenuItem onClick={()=>{
                       closeAddMenu();
                       openRMAWizard();
                    }}>
                       Create new RMA case
                    </MenuItem>
                    <MenuItem onClick={()=>{
                    closeAddMenu();
                    navigate('/new');
                    }}>
                    Create new PO
                    </MenuItem>
                    <MenuItem onClick={()=>{
                     closeAddMenu();
                     onCreateStandalone && onCreateStandalone();
                   }}>
                     Create new product
                   </MenuItem>
                <MenuItem onClick={()=>{
                     closeAddMenu();
                     onCreateVariant?.();
                   }}>
                     Create product variant
                   </MenuItem>
                   <MenuItem onClick={()=>{
                     closeAddMenu();
                     navigate('/scrapers/new');
                   }}>
                     Create scrape target
                   </MenuItem>
                   <MenuItem onClick={()=>{
                     closeAddMenu();
                     navigate('/competitors/new');
                   }}>
                     Create competitor
                   </MenuItem>
                   <MenuItem onClick={()=>{
                     closeAddMenu();
                     navigate('/vendors/new');
                   }}>
                     Create vendor
                   </MenuItem>
                </Menu>
                </>
            )}
        

          {/* ⚠️ G0b.5 (2026-10-13) — BENANNT, nicht entschieden: die
              Kopfaktionsknöpfe liegen im SELBEN zentrierten Bereich wie die
              Suche und ruecken damit mit ihr in die Mitte des Hauptbereichs
              (z. B. die Bearbeiten-Knöpfe auf `CompetitorDetail` im
              Editiermodus). Das ist kein NEUER Defekt — der Bereich trug schon
              vorher `justifyContent: center`, die Knöpfe standen also bereits
              mittig; neu ist nur der Bezug (Hauptbereich statt Flex-Zwischenraum
              zwischen Logo und Rechtszone). Eine eigene UX-Bewertung dieser
              Knöpfe ist nicht Teil des Schnitts.
              G0b.5-Nachbesserung 5: `Grow` klont seinen `Stack` (kein eigenes
              DOM-Element), die Spaltenzuweisung steht darum am `Stack`.
              🔴 G0b.5-Nachbesserung 6 (2026-10-13): das gilt **AB `lg`**.
              Darunter rücken die Knöpfe wie auf master im Fluss mit
              (`justifyContent: center` der Fluss-Form) — dort ändert dieser
              Schnitt an ihnen nichts. */}
          {hasActions && (
            <Grow in={hasActions} timeout={DUR.ui}>
              <Stack direction="row" spacing={2} sx={{ gridColumn: 2 }}>
                {actions.map(({ key, label, onClick, disabled, variant = 'text', color = 'inherit', startIcon, loading }) => (
                  <Button
                       key={key}
                       color={color}
                       variant={variant}
                       startIcon={startIcon}
                       onClick={onClick}
                       disabled={disabled || loading}
                     >
                       {loading ? '…' : label}
                     </Button>
                ))}
              </Stack>
            </Grow>
          )}
        </Box>

        {/* Right adornment (sync indicators etc.) + always-visible Bell */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {rightAdornment}
          <Bell />
          <UserMenu />
        </Box>
      </Toolbar>
    </AppBar>
  )
}

/**
 * useVisualViewport — die zwei Masse, aus denen die mobile Saeule gebaut wird
 * (M3b, §B2.3): `top` = `visualViewport.offsetTop`, `hoehe` =
 * `visualViewport.height`, beide gerundet.
 *
 * 🔴 Warum die Saeule aus dem VISUAL Viewport kommt. `100vh` beschreibt den
 * **Layout**-Viewport, und der bleibt stehen, wenn die Tastatur aufgeht — die
 * Tastatur liegt DARUEBER. Genau daraus entstand O2a: die Paneloberkante stand
 * auf 0, also unter der Statusleiste, und die erste Trefferzeile lag darunter.
 *
 * 🔴 **`window.innerHeight` kommt in dieser Funktion nicht mehr vor** — das ist
 * die ganze Abhilfe zu O2a. Ein Rueckfall darauf waere die Rueckkehr der
 * Ursache; `M3.1c` prueft es mit einer Mutation genau darauf.
 *
 * 🔴 **Seit Nachbesserung 2 (R15-W3) ist `innerHeight` an der Saeule aber ein
 * Rechenwert — als VERGLEICH in `tastaturOffen`, nicht in der Saeulenformel.**
 * Die Differenz Layout-Viewport − Visual Viewport (mit 150-px-Schwelle und
 * `scale < 1.05`) entscheidet den Zweig, und der Zweig speist `--suche-unten`
 * — die Geometrie haengt damit MITTELBAR daran. Die Formel selbst (`top`,
 * `height`) liest weiterhin nur `offsetTop`/`height`.
 *
 * Rueckfall `{ top: 0, hoehe: null, scale: 1 }`: aeltere Browser und jsdom
 * kennen `visualViewport` nicht. `hoehe: null` heisst „unbekannt" — die Saeule
 * faellt dann auf `100vh` zurueck, statt zu verschwinden.
 */
function useVisualViewport(aktiv) {
  const [zustand, setZustand] = useState({ top: 0, hoehe: null, scale: 1, hatVv: false });
  useEffect(() => {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    if (!aktiv || !vv) { setZustand({ top: 0, hoehe: null, scale: 1, hatVv: false }); return undefined; }
    const messen = () => setZustand({
      top: Math.round(vv.offsetTop || 0),
      hoehe: Math.round(vv.height),
      // 🔴 R15-W3: `scale` unterscheidet den Pinch-Zoom von der Tastatur.
      // Fehlt die Eigenschaft (aeltere Umgebung), gilt 1 = kein Zoom.
      scale: typeof vv.scale === 'number' ? vv.scale : 1,
      hatVv: true,
    });
    messen();
    vv.addEventListener('resize', messen);
    vv.addEventListener('scroll', messen);
    return () => {
      vv.removeEventListener('resize', messen);
      vv.removeEventListener('scroll', messen);
    };
  }, [aktiv]);
  return zustand;
}

/**
 * SuchergebnisGeruest — der LADEZUSTAND der mobilen Trefferliste (R16-W3).
 *
 * 🔴 Warum es ihn gibt. Zwischen Tastendruck und Antwort liegen 280 ms
 * Entprellung PLUS die Laufzeit der Anfrage. In dieser Zeit stand hier vorher
 * „No results for …" — die Aussage „nichts gefunden" ueber eine Frage, die noch
 * gar nicht gestellt war. `anti-patterns.md` §11 verlangt „Skelett statt
 * Spinner"; das Geruest ist die Form der GELADENEN Flaeche, damit beim
 * Eintreffen der Treffer nichts springt.
 *
 * Die Anatomie ist die von `common/SearchResultItem.jsx` — und seit Suche
 * mobil v2 Stufe 2 sind das **ZWEI** Anatomien, weil die Trefferzeile zwei hat
 * (`variante`). 🔴 **R16-W1 (Nachbesserung 1, 2026-11-01):** bis dahin zeichnete
 * das Geruest auch mobil die ALTE (Desktop-)Zeile — `py: 1.5`, drei Textbalken,
 * zwei Pillen, keine Kachel. Die echte mobile Zeile ist `py: 1`, 40-px-Kachel,
 * zwei Titelzeilen und EINE Metazeile mit einer Pille; gemessen lagen zwischen
 * Geruest (≈ 88 px) und Trefferzeile (77,5 px) elf Pixel, und der Text begann
 * bei x = 16 statt bei x = 64. Der Docstring sagte das Gegenteil („damit beim
 * Eintreffen nichts springt").
 *   - **Desktop (Vorgabe):** eine Zeile mit `py: 1.5`, Titelzeile (`body1`),
 *     zwei Unterzeilen (`body2`/`caption`) und die zwei Pillen — byte-gleich
 *     wie vor Stufe 2.
 *   - **Mobil (`variante="mobil"`):** `py: 1`, 40-px-Kachel, zwei Titelzeilen
 *     (`body1`, 2 × 21 px) und eine Metazeile (`19,5 px`) mit der Status-Pille.
 *     Rechnung: 16 + 42 + 19,5 = **77,5 px**, dieselbe Zahl, die V2.0 an der
 *     echten Zeile misst (Plan §14 N8).
 * ⚠️ **Was das Geruest NICHT wissen kann:** ob der echte Titel ein- oder
 * zweizeilig ausfaellt. Es zeichnet den ZWEIZEILIGEN Fall (den unguenstigen);
 * bei einem einzeiligen Titel ist es 21 px zu hoch. Die Alternative waere ein
 * Geruest, das die Treffer kennt — dann braeuchte es den Ladezustand nicht.
 * KEIN erfundener Text — nur Balken in derselben Form.
 *
 * 🔴 M2 §7 (2026-10-16) — DREI Abweichungen sind behoben, alle in
 * `owner_1_skelett.png` sichtbar:
 *   1. ZWEI Balken statt drei Textzeilen plus zwei Etiketten. Die echte Zeile
 *      hat Titel, Unterzeile und Zusammenfassung und rechts in der Titelzeile
 *      zwei Pillen — das Geruest hatte fuer sie KEINEN Platz, die geladene
 *      Flaeche sprang beim Eintreffen der Treffer.
 *   2. Die Balken klebten aneinander (`Skeleton variant="text"` bringt seine
 *      eigene Zeilenbox mit). Jetzt traegt jeder Balken die HOEHE der
 *      Textzeile, die er vertritt — der Abstand entsteht aus den Zeilenhoehen,
 *      wie bei echten Zeilen auch, und nicht aus einem `mb`.
 *   3. Der Abstand lag an der falschen Stelle: das Geruest riss ~70 px
 *      ZWISCHEN die Zeilen auf und 0 px IN ihnen. Der Rhythmus ist jetzt der
 *      der echten Zeile (`py: 1.5` je Zeile).
 *   🔴 Und mit Bauform A (§5) kommt ein KOPF-BALKEN dazu: die geladene Liste
 *   traegt Gruppenkoepfe (`overline`), ein Geruest ohne sie springt beim
 *   Eintreffen um genau diese Hoehe.
 *
 * ⚠️ Warum kein Baustein unter `Skeletons/`: die dortigen Gerueste bilden
 * Karten, Tabellen und Seitenkoepfe ab (`CardListSkeleton`, `TableSkeleton`,
 * `POInboxSkeleton`), keine dreizeilige Trefferzeile — und ein eigenes
 * `Skeletons/…` waere ein neuer geteilter Baustein (Regel 12) mit genau EINEM
 * Aufrufer. `Skeleton` ist dieselbe MUI-Primitive, die jene Gerueste benutzen.
 *
 * 🔴 Der Kopf-Balken ist NICHT klebend: das Geruest scrollt nicht, und ein
 * `position: sticky` in einer Ladeflaeche waere eine zweite Flaeche ohne
 * Gegenstand.
 *
 * `role="status"` + `aria-label` + `aria-busy` melden den Ladezustand
 * Hilfsmitteln an, wie es die uebrigen Gerueste unter `Skeletons/` tun.
 * 🔴 Sie bleiben WOERTLICH stehen: vier Jest-Proben haengen daran
 * (`SidebarAndHeaderBar.mobil.test.jsx`, die vier W3-Proben). Sie pruefen
 * Anwesenheit, nicht Anatomie — sie bleiben also gruen UND sehen den Umbau
 * nicht; die Anatomie hat ihre eigene Probe. ⚠️ **Bekannt und abgelegt, nicht behoben (Regel-16 W1, 2026-10-16):** das Geruest zeigt **EINEN** Kopf-Balken, die Liste typisch **ZWEI** (die Fixture traegt `rma_case` und `product`) — ein Rest-Sprung von ~26–44 px. Die Karte steht unter `docs/backlog-auto-repair/2026-10-16-suche-geruest-zweiter-gruppenkopf.md`, samt der Begruendung, warum hier KEIN zweiter Balken steht (das Geruest kennt die Gruppenzahl nicht).
 */
function SuchergebnisGeruest({ zeilen = 4, kopf = true, variante }) {
  // 🔴 Die Abfrage liegt hier SELBST, nicht als Prop an den zwei Aufrufstellen:
  // sonst muessten beide Aufrufer denselben Ausdruck mitschleppen, und eine
  // dritte Aufrufstelle koennte ihn vergessen. `framer-motion` merkt sich die
  // Praeferenz modulweit — der zweite Aufruf derselben Abfrage ist gratis.
  const reduzierteBewegung = useReducedMotion();
  const animation = reduzierteBewegung ? false : 'pulse';

  return (
    <Box role="status" aria-label="Searching" aria-busy="true">
      {/* Kopf-Balken — die Form des echten Gruppenkopfes (§5), NICHT klebend.
          🔴 Suche mobil v2, Stufe 2 (B2): `kopf` mit Vorgabe `true`. NUR der
          mobile Aufruf setzt `false` — dort gibt es seit der Bereichsleiste
          keinen Gruppenkopf mehr, und ein Balken fuer eine Zeile, die es nicht
          gibt, waere ein Sprung beim Eintreffen der Treffer. Der DESKTOP-
          Ladezustand bleibt damit byte-gleich; `SidebarAndHeaderBar.kopf-
          suchleerzustand.test.jsx` pinnt ihn. */}
      {kopf && (
        <Box sx={{ px: 2, pt: 1 }}>
          <Skeleton variant="text" width="30%" height={18} animation={animation} />
        </Box>
      )}
      {[...Array(zeilen)].map((_, i) => (variante === 'mobil' ? (
        // ── MOBILE Anatomie (R16-W1), Masse nach Stufe 6a — die Form von
        // `SearchResultItem` mit `variante="mobil"`: `py: 1.5` (12 px je
        // Seite), 48-px-Kachel mit 12er-Radius, Text ab derselben Kante, zwei
        // Titelzeilen (2 × 19,5) und EINE Metazeile (19,5) mit der Pille.
        // 24 + 48 = 72 px einzeilig bzw. 24 + 39 + 19,5 = 82,5 zweizeilig.
        <Box
          key={i}
          data-testid="suche-geruest-zeile"
          sx={{ py: SUCHE_ZEILE_POLSTER, px: 2, display: 'flex', alignItems: 'center', gap: SP.tight }}
        >
          <Skeleton
            data-testid="suche-geruest-kachel"
            variant="rounded"
            width={SUCHE_ZEILE_BILD_PX}
            height={SUCHE_ZEILE_BILD_PX}
            sx={{ borderRadius: SUCHE_ZEILE_BILD_RADIUS, flexShrink: 0 }}
            animation={animation}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: 0 }}>
            {/* Zwei Titelzeilen (15 / 1,3 → 19,5 px). */}
            <Skeleton variant="text" width="85%" height={19.5} animation={animation} />
            <Skeleton variant="text" width="55%" height={19.5} animation={animation} />
            {/* Die Metazeile: Text links, Status-Pille rechts (`F5-A`). */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: SP.chip, width: '100%' }}>
              <Skeleton variant="text" width="45%" height={19.5} sx={{ flexGrow: 1 }} animation={animation} />
              <Skeleton variant="rounded" width={56} height={19.5} sx={{ borderRadius: SKELETON_PILL_RADIUS, flexShrink: 0 }} animation={animation} />
            </Box>
          </Box>
        </Box>
      ) : (
        <Box key={i} sx={{ py: 1.5, px: 2 }}>
          {/* Zeile 1 — Titel plus die zwei Pillen (Art/Status, `:143`/`:160`
              in `SearchResultItem.jsx`, beide 20 px hoch). */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: SP.tight, width: '100%' }}>
            <Skeleton variant="text" width="60%" height={20} sx={{ flexGrow: 1 }} animation={animation} />
            <Skeleton variant="rounded" width={56} height={20} sx={{ borderRadius: SKELETON_PILL_RADIUS, flexShrink: 0 }} animation={animation} />
            <Skeleton variant="rounded" width={64} height={20} sx={{ borderRadius: SKELETON_PILL_RADIUS, flexShrink: 0 }} animation={animation} />
          </Box>
          {/* Zeilen 2 und 3 — Unterzeile und Zusammenfassung, in der Hoehe der
              neuen Skala aus §5 (`FS.sm`, 12,5 px). */}
          <Skeleton variant="text" width="45%" height={18} animation={animation} />
          <Skeleton variant="text" width="70%" height={20} animation={animation} />
        </Box>
      )))}
    </Box>
  );
}

/** Combined Layout: Sidebar + HeaderBar + content area */
export default function SidebarAndHeaderBar({
   onCreateStandalone,
   onCreateVariant,
}) {
    
    const navigate = useNavigate();
    const theme    = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // ── Die Fallansicht traegt ihre eigene Telefonbedienung ──────────────────
    // 🔴 **Owner-Entscheid 43** (Telefon bekommt eine eigene, ruhige
    //    Interaktion, nicht die schmale Fassung des Rechners). Der Klickdummy
    //    `ku-41-fall-telefon.png` zeigt sie: unten steht NUR der Verfasser,
    //    keine schwebende Icon-Leiste; zurueck geht es ueber den Pfeil im
    //    Fallkopf (`fall-zurueck`). Die Leiste deckte dort mitten im Scrollen
    //    Strom, Agent und Karten zu - gemessen im Design-Gate B5 (BLOCKER 2).
    //
    //    Die Leiste gehoert dem RAHMEN, nicht der Ansicht: hier wird sie
    //    ausgelassen, nicht in der Ansicht weggeschoben. Die Route kommt aus
    //    `fall/lib/route` (eine Wahrheit, das Muster steht in `App.js`).
    //
    //    Der Rechner (`md` und aufwaerts) und jede andere Route bleiben genau
    //    wie heute - `istFallansicht` ist ein Routentest, kein Umbau des
    //    Rahmens.
    //
    //    🔴 Der Wert wird erst UNTEN gesetzt, wo `location` steht: `location`
    //    ist weiter unten erklaert, und ein Zugriff hier waere eine
    //    Zeitluecke (Konstante vor ihrer Zeile gelesen).

    // ── Customize-Modus der Seitenleiste (W-21b) ─────────────────────────────
    // 🔴 Der Zustand liegt HIER und nicht in `Sidebar`: der Modus aendert die
    // BREITE der Leiste, und die steht als `--sidebar-width` am Grid-Rahmen
    // (unten, `gridTemplateColumns`). Ein Zustand in `Sidebar` koennte sie nicht
    // erreichen — er muesste den Wert erst per Effekt nach oben melden, und das
    // waere ein Bild lang die alte Breite.
    const [anpassen, setAnpassen] = useState(false);

    // ── Befehlspalette (W-20) ────────────────────────────────────────────────
    // 🔴 Der Griff haengt am DOCUMENT, nicht an einem Feld: er muss auch
    // greifen, wenn der Fokus gerade in einem Filterfeld steht. Genau dort
    // greifen Leute nach Cmd+K, und genau dort versagt Atlassians
    // Fokus-Waechter (der Plan warnt selbst davor).
    const [paletteOffen, setPaletteOffen] = useState(false);
    useEffect(() => {
      const onKey = (e) => {
        if (istPaletteGeste(e)) {
          e.preventDefault();
          setPaletteOffen(v => !v);
        } else if (e.key === 'Escape') {
          setPaletteOffen(false);
        }
      };
      document.addEventListener('keydown', onKey);
      return () => document.removeEventListener('keydown', onKey);
    }, []);
  
    // mobile inline search state
    const [mobileSearchOpen,    setMobileSearchOpen]    = useState(false);
    const [mobileSearchQ,       setMobileSearchQ]       = useState('');
    // 🔴 Suche mobil v2, Stufe 6a (§4.1): der Fokus-Zustand des Suchfelds.
    // Er entscheidet allein ueber das LEEREN-✕ — Leeren ist nicht Schliessen:
    // ohne Text gibt es nichts zu leeren, und ohne Fokus ist der ✕ eine
    // Einladung zu einer Handlung, die die Tastatur wieder oeffnen wuerde.
    // Der Schliessen-Kreis daneben bleibt in 6a IMMER sichtbar (B5): die Navi
    // ist noch verdeckt, und ein Telefon ohne ✕ waere nicht schliessbar.
    const [feldFokus,           setFeldFokus]           = useState(false);
    // 🔴 Owner-Befund 2026-10-16, mobil: dieselbe Rueckkehr des Fokus wie im
    // Kopf. Der Befund selbst („die Suche schliesst sich") trifft das Panel
    // NICHT — es haengt an `mobileSearchOpen` und hat keinen `ClickAwayListener`,
    // der auf ein Portalmenue hereinfiele. Der FOKUS ging trotzdem verloren:
    // MUI gibt ihn beim Schliessen an den Bereichsknopf zurueck, und die
    // naechste Taste erreichte die Eingabe nicht.
    const mobileSucheInputRef = useRef(null);
    // 🔴 Stufe B (B6): die Bereichswahl gibt es AUCH mobil. Ohne diesen Zustand
    // filterte das Feld auf dem Telefon nichts — und die Regel-8-Abnahme
    // (Projekt `search`, Desktop) bliebe dabei gruen.
    const [mobileSearchBereich, setMobileSearchBereich] = useState(ALLE_BEREICHE);
    // 🔴 Suche mobil v2, Stufe 3 (Plan §6.2): die zuletzt gesuchten BEGRIFFE.
    // Gelesen beim OEFFNEN der Suche (nicht bei jedem Bild), geschrieben beim
    // Klick auf einen Treffer. Der Speicher selbst liegt in
    // `search/sucheRecents.js` — hier steht nur die Anzeige.
    const [mobileRecents, setMobileRecents] = useState([]);
    // 🔴 R16-B2, zweiter Aufrufer: auch hier folgt die Anzeige dem WIRKSAMEN
    // Bereich aus den Antwort-Koepfen. Dieselbe Bauform wie in `HeaderBar` —
    // inklusive `fuer`, damit das Ergebnis der vorigen Frage nicht in der Pille
    // stehenbleibt, waehrend die neue noch laeuft.
    const [mobileWirksam, setMobileWirksam] = useState({ fuer: '', bereich: ALLE_BEREICHE, text: '' });
    const [mobileSearchResults, setMobileSearchResults] = useState([]);
    // 🔴 R16-W3 — „nichts gefunden" und „die Suche antwortet nicht" sind ZWEI
    // Zustaende. Vorher setzte der `catch` nur die Trefferliste auf leer, und
    // die Flaeche sagte daraufhin „No results for …": ein 500er sah Zeichen fuer
    // Zeichen aus wie eine ehrliche Leermenge (Regel 22 §4).
    const [mobileSearchFehler,  setMobileSearchFehler]  = useState(false);
    // 🔴 Und ein DRITTER: die Entprellung. Ohne ihn stand waehrend der 280 ms
    // „No results for …" — die Aussage „nichts gefunden" ueber eine Frage, die
    // noch gar nicht gestellt war.
    const [mobileSearchLaedt,   setMobileSearchLaedt]   = useState(false);
    // Der „Try again"-Knopf des Fehlerzustands. Er ist der EINZIGE Weg, eine
    // gescheiterte Anfrage zu wiederholen, ohne den Suchtext zu aendern — ohne
    // ihn waere der Fehler eine Sackgasse (Regel 22 §4, „different affordance").
    const [mobileSearchVersuch, setMobileSearchVersuch] = useState(0);
    // 🔴 M3b §B2.7 — liegt das Bereichsblatt offen? Es ist der Grund, warum der
    // Esc-Zuhoerer des Panels in dieser Lage NICHT schliesst: erst das Blatt,
    // dann die Suche. Der Zustand steht hier, weil der Zuhoerer hier sitzt; das
    // Blatt selbst meldet ihn ueber `onGeoeffnet`/`onGeschlossen`.
    const [mobileBereichsBlattOffen, setMobileBereichsBlattOffen] = useState(false);
    // 🔴 Suche mobil v2, Stufe 2 — die Bereichsleiste braucht die LISTE, nicht
    // nur das Etikett: `SucheBereichChips` rendert je aktiver Art einen Chip.
    // Dieselbe Quelle wie das Blatt (`ladeBereiche`, zwischengespeichert) —
    // eine zweite Abfrage waere ein zweiter Zustand, und die zwei koennten
    // auseinanderlaufen. Geladen wird beim OEFFNEN des Panels, nicht beim
    // Montieren: die Liste aendert sich nur im Admin, und ein Abruf je
    // Seitenaufruf waere eine Abfrage ohne Anlass.
    const [mobileSucheBereiche, setMobileSucheBereiche] = useState([]);
    useEffect(() => {
      if (!mobileSearchOpen) return undefined;
      let aktiv = true;
      ladeBereiche().then((liste) => { if (aktiv) setMobileSucheBereiche(liste); });
      return () => { aktiv = false; };
    }, [mobileSearchOpen]);

    useEffect(() => {
      if (!mobileSearchQ.trim()) {
        setMobileSearchResults([]);
        setMobileSearchFehler(false);
        setMobileSearchLaedt(false);
        // Ohne Text keine wirksame Syntax — die Pille faellt auf die Auswahl
        // zurueck (Begruendung wie in `HeaderBar`).
        setMobileWirksam({ fuer: '', bereich: mobileSearchBereich, text: '' });
        return undefined;
      }
      // `clearTimeout` allein reicht NICHT: es bricht den Timer ab, aber eine
      // bereits abgesandte Anfrage landet trotzdem und ueberschreibt die
      // Anzeige. Dieselbe Wettlaufschranke wie in `fetchResults` oben.
      let aktiv = true;
      // Beide Zustaende werden VOR dem Timer gesetzt, nicht in ihm: die
      // Entprellung selbst ist Wartezeit, und genau in ihr stand vorher die
      // falsche Aussage.
      setMobileSearchLaedt(true);
      setMobileSearchFehler(false);
      const timer = setTimeout(async () => {
        try {
          // POST, nicht GET — Begruendung wie bei `fetchResults` oben.
          // 🔴 Stufe B: `types` geht MIT (B6). Ohne dieses Feld filtert die
          // Bereichsauswahl im Mobil-Panel nichts, und der Aufruf oben bliebe
          // gruen, weil er den Mobilpfad gar nicht faehrt.
          const { data, headers } = await axios.post(`${API}/api/search`, {
            q: mobileSearchQ,
            ...(mobileSearchBereich ? { types: [mobileSearchBereich] } : {}),
          });
          if (aktiv) {
            setMobileSearchResults(Array.isArray(data) ? data : []);
            setMobileSearchLaedt(false);
            // 🔴 R16-B2: derselbe Kopf wie in `HeaderBar` — der wirksame Bereich
            // kommt vom Server, hier wird nichts geparst (B6).
            setMobileWirksam({
              fuer: mobileSearchQ,
              ...wirksamAusKoepfen(headers, mobileSearchQ, mobileSearchBereich),
            });
          }
        } catch {
          if (aktiv) {
            setMobileSearchResults([]);
            setMobileSearchFehler(true);
            setMobileSearchLaedt(false);
          }
        }
      }, 280);
      return () => { aktiv = false; clearTimeout(timer); };
    }, [mobileSearchQ, mobileSearchBereich, mobileSearchVersuch]);

    // 🔴 R16-W1/W2 (Begruendung wie in `HeaderBar`, s. dort): die FLAECHE bleibt
    // auf dem letzten Messwert, der TEXT folgt `fuer`, und den Kurzweg gibt es
    // nur bei `text !== fuer` — dem Server-Signal, nicht dem blossen
    // Unterschied Auswahl ↔ wirksamer Bereich.
    const mobileGemessen = mobileWirksam.fuer !== '';
    const mobileWirksamBereich = mobileGemessen
      ? mobileWirksam.bereich
      : mobileSearchBereich;
    const mobileWirksamText = mobileWirksam.fuer === mobileSearchQ
      ? mobileWirksam.text
      : mobileSearchQ;
    const mobileSyntaxWirksam = mobileWirksam.fuer === mobileSearchQ
      && mobileWirksam.text !== mobileWirksam.fuer;

    // 🔴 Suche mobil v2, Stufe 3 (Plan §6.2): die Recents stehen im LEEREN
    // Zustand, unter der Chip-Zeile. Ohne gespeicherte Begriffe bleibt die
    // Flaeche leer — keine Ueberschrift, kein „Clear", kein Fuelltext.
    const mobileZeigtRecents = !mobileSearchQ && mobileRecents.length > 0;

    // ── Stufe M — das mobile Such-Overlay, fuenf Befunde ─────────────────────
    // Die Befunde 1–4 sind am Bildschirm gemessen (Playwright, Projekt
    // `search`, `tests/search/mobil.spec.ts`), Befund 5 von Hand (Foto): das
    // Projekt faehrt `Desktop Chrome`, und Playwright hat keine
    // iOS-Tastaturemulation.
    //
    // 🔴 `closeMobileSearch` liegt in `useCallback`, seit die Effekte unten es
    // als Abhaengigkeit tragen. Als nacktes `const` entstuende die Funktion bei
    // jedem Bild neu; der Esc-Effekt raeumte sich dann staendig ab und wieder
    // auf, statt stehenzubleiben.
    const closeMobileSearch = useCallback(() => {
      setMobileSearchOpen(false);
      setMobileSearchQ('');
      setMobileSearchResults([]);
      // 🔴 M3b §B2.7: die Blatt-Marke darf das Panel nicht ueberleben. Wird die
      // Suche mit offenem Blatt geschlossen (chancenlos: `SearchBereichWahl`
      // haengt dann ab, ohne `onGeschlossen` zu rufen), bliebe sie sonst stehen
      // und der Esc-Riegel sperrte beim NAECHSTEN Oeffnen das Panel.
      setMobileBereichsBlattOffen(false);
    }, []);

    // 🔴 Suche mobil v2 Stufe 1 (V1.9) — das ✕ AUSSERHALB des Feldes SCHLIESST
    // und laesst den Begriff stehen; das ✕ IM Feld LEERT und laesst das Panel
    // offen. Bis v2 taten beide dasselbe (`closeMobileSearch` leerte immer),
    // damit waren es zwei Knoepfe mit einer Aufgabe. Die uebrigen Schliesswege
    // (Esc, Abdunklung, Zeilenklick) leeren weiter — sie BEENDEN die Suche,
    // statt sie nur zuzuklappen.
    const schliesseSucheOhneLeeren = useCallback(() => {
      setMobileSearchOpen(false);
      setMobileBereichsBlattOffen(false);
    }, []);

    // ── R16-B1 — der Fokus kehrt beim Schliessen zu seinem Ausloeser zurueck ──
    //
    // Hausform ist `components/common/SlidePanel.jsx:133-148`: merken beim
    // Oeffnen, zuruecksetzen beim Schliessen, mit `document.contains`-Guard.
    //
    // 🔴 WARUM DER MERKER AM AUSLOESER HAENGT UND NICHT IN EINEM EFFEKT STEHT.
    // Dort wird `document.activeElement` im OEFFNENDEN Effekt gelesen. Hier geht
    // das nicht: die Eingabe traegt `autoFocus`, und React setzt `autoFocus` in
    // der COMMIT-Phase (ReactDOM `commitMount`) — also VOR jedem Effekt. Wer im
    // Effekt liest, liest die EINGABE, nicht den Knopf, der gedrueckt wurde, und
    // setzt den Fokus spaeter auf sich selbst. Der Merker sitzt deshalb eine
    // Ebene hoeher, im Klickpfad (`merkeAusloeser`).
    //
    // 🔴 Der Guard stammt aus demselben Muster und ist VORSORGE, nicht
    // Reparatur — 🔴 R16-W2-5 (Nachbesserung 2, 2026-10-15), ehrlich benannt:
    // gemessen an `App.js:316` ist `SidebarAndHeaderBar` das Layout-Element der
    // Route `path="/"`; die Schale UEBERLEBT eine Trefferwahl, der Ausloeser
    // bleibt im Baum. Der Guard greift also beim normalen Weg NICHT. Er bleibt
    // trotzdem stehen, weil `focus()` auf einem abgehaengten Knoten nicht wirft,
    // sondern nur nichts tut — eine stille halbe Zusage (Regel 17 §1). Die
    // Zusage lautet nicht „er faengt den Trefferklick ab", sondern „er greift
    // nie ins Leere".
    const suchAusloeserRef = useRef(null);

    // 🔴 R15-W2 (Nachbesserung 2, 2026-10-15): der Ausloeser kommt aus dem
    // KLICKEREIGNIS, nicht aus `document.activeElement`.
    //
    // Grund, gemessen: iOS Safari fokussiert einen `<button>` beim Tippen NICHT
    // — `document.activeElement` bleibt dort `<body>`. Der Merker traegt dann
    // `body`, und der Rueckweg setzte den Fokus beim Schliessen auf `body`
    // zurueck: auf dem Geraet, fuer das ein mobiles Overlay gebaut wird, waere
    // der ganze Rueckweg ein Nullvorgang. Der Ausloeser steht aber im Ereignis
    // (`currentTarget` ist der Knopf, der `onClick` traegt — `MobileBottomNav`
    // reicht `onOpenSearch` direkt an `onClick` durch). `document.activeElement`
    // bleibt als RUECKFALL fuer einen Aufruf ohne Ereignis.
    const merkeAusloeser = (ereignis) => {
      const ausEreignis = ereignis && ereignis.currentTarget;
      suchAusloeserRef.current = ausEreignis || document.activeElement;
      // 🔴 M3b §B2.6 (W5): VOR dem State gemerkt — der Handler laeuft vor dem
      // Fokus, der gemerkte Wert ist der Stand VOR dem Oeffnen.
      scrollYRef.current = typeof window !== 'undefined' ? window.scrollY : 0;
      // 🔴 Stufe 3 (Plan §6.2): die zuletzt gesuchten Begriffe werden BEIM
      // OEFFNEN gelesen — nicht in einem Effekt auf `mobileSearchOpen`, der
      // dieselbe Arbeit an einer zweiten Stelle taete, und nicht bei jedem
      // Bild. So steht der Stand da, den der Speicher beim Aufklappen hat.
      setMobileRecents(ladeRecents());
      setMobileSearchOpen(true);
    };

    useEffect(() => {
      if (mobileSearchOpen) return undefined;
      const vorher = suchAusloeserRef.current;
      if (vorher && document.contains(vorher)) vorher.focus();
      return undefined;
    }, [mobileSearchOpen]);

    // Befund 1 — reduzierte Bewegung. `useReducedMotion` liest die
    // Medienabfrage (framer-motion@6 fragt `(prefers-reduced-motion)`, ohne
    // `: reduce`). Ohne die Abfrage faehrt das Panel auch dann mit der Feder
    // herein, wenn das Betriebssystem genau das abgeschaltet hat.
    const reduzierteBewegung = useReducedMotion();

    // M3b §B2.3 — die zwei Masse des Visual Viewports. Die Saeule (Panelwurzel)
    // wird daraus gebaut; `window.innerHeight` ist hier NICHT beteiligt.
    const vv = useVisualViewport(mobileSearchOpen);

    // 🔴 R16-W3 (Nachbesserung 1) + R15-W3 (Nachbesserung 2) — der
    // Tastatur-Zustand wird EINMAL abgeleitet. Drei Verbraucher lesen denselben
    // Wert: `data-tastatur` (Probenmerker), `data-suche-unten` (Zweig) und
    // `--suche-unten` (Geometrie). Eine zweite Bedingung daneben waere die
    // zweite Wahrheit.
    //
    // 🔴 R15-W3: ZWEI Bedingungen, gemeinsam. Ohne die Schwelle las ein
    // eingerasteter Leisten-/Adressleisten-Zustand (wenige Pixel) als
    // „Tastatur offen"; ohne die `scale`-Bedingung las ein Pinch-Zoom so.
    // Beides verschoeb `--suche-unten` auf den blossen Abstand und nahm dem
    // Home-Indikator seinen Schutz.
    const tastaturOffen = vv.hatVv
      && vv.scale < SUCHE_TASTATUR_SCALE_MAX
      && window.innerHeight - vv.hoehe >= SUCHE_TASTATUR_SCHWELLE_PX;

    // 🔴 R16-W3 — der untere Abstand. Ist die Tastatur OFFEN, endet der Visual
    // Viewport bereits an ihrer Oberkante; darunter ist nur das Trefferpolster
    // noetig. Ist sie ZU, endet der VV an der Bildschirmkante — und dort liegt
    // auf dem iPhone der Home-Indikator (`viewport-fit=cover`,
    // `env(safe-area-inset-bottom)` ≈ 34 px). Deshalb `max(polster, env(...))`:
    // der Geraeteboden gewinnt nur, wenn er groesser ist.
    //
    // 🔴 **Seit Suche mobil v2 Stufe 1 (2026-10-31) ist der Grundwert 8 px,
    // nicht 12:** `--suche-unten` ist jetzt das Polster der LISTE (Plan §2.2,
    // §2.3), und die 12 px `SUCHE_ABSTAND` gehoeren dem Bereichsblatt. Die
    // Regel steht in der CSS-Variablen, damit die Liste sie ohne zweite
    // Rechnung liest.
    //
    // 🔴 **EIN Objekt, EINE Quelle** (R15-W1, Nachbesserung 2): der Probenmerker
    // `art` wird aus demselben `wert` ABGELEITET, den `--suche-unten` liest.
    // Vorher standen zwei Literale ueber demselben Booleschen — die Mutation
    // „Wert unbedingt `var(--suche-abstand)`" liess den Merker auf `max` und
    // `M3.2c` blieb gruen (Chromium substituiert `env()` zu 0, beide Zweige
    // lesen dann `12px`). Jetzt kippt der Merker mit dem Wert.
    const untererAbstandWert = tastaturOffen
      ? 'var(--suche-treffer-polster)'
      : 'max(var(--suche-treffer-polster), env(safe-area-inset-bottom, 0px))';
    const untererAbstand = {
      wert: untererAbstandWert,
      art: untererAbstandWert.startsWith('max(') ? 'max' : 'abstand',
    };

    // 🔴 M3b §B2.5 — die `scrollTop`-Ruecksetzung (R15 B1 + Orchestrator-Entscheid
    // 2026-10-19). Der Schluessel ist der TEXT (und der Bereich), NICHT das
    // Ergebnis-Array: ein Effekt auf `mobileSearchResults` liefe bei jeder neuen
    // Antwort — auch bei gleichem Text („Try again") — und risse den Nutzer aus
    // einer Liste, in der er gerade liest.
    const mobileTrefferScrollerRef = useRef(null);

    // 🔴 Suche mobil v2, Stufe 3 (Plan §7.1/§7.2) — ein Zeigerweg in der Liste
    // blendet die Tastatur aus. Begriff und Blatt bleiben: `mobileSearchQ`
    // wird NICHT angefasst, `closeMobileSearch` nicht gerufen.
    //
    // Der Riegel ist `document.activeElement === Feld`: nach dem ersten Blur
    // ist er falsch, und der Handler wird zum No-Op — ohne
    // `requestAnimationFrame` und ohne Entprellung.
    //
    // 🔴 **`scroll` ist KEIN Weg** (Nachbesserung 2, 2026-11-02). Ein
    // `scroll`-Ereignis sagt nichts ueber den Nutzer: Traegheit eines Wisches,
    // Scroll-Anchoring und der eigene Reset darunter erzeugen es ebenso. Mit
    // `onScroll` fiel deshalb der Fokus nach einem Wisch wieder aus dem Feld,
    // sobald ein spaetes `scroll` eintraf — am Geraet: ins Feld tippen, die
    // Tastatur klappt wieder zu. Der Merker, der genau ein Ereignis
    // schluckte, deckte nur den eigenen Reset ab und keine der beiden anderen
    // Quellen. Er ist mit `onScroll` entfallen.
    //
    // 🔴 Der Fokus geht auf den SCROLLER, nicht ins Leere: `blur()` allein
    // gaebe ihn an `<body>`, und die Tab-Schleife (`beiTasteImPanel`) haette
    // kein Halteelement mehr. Der Scroller traegt `tabIndex={-1}` — er faellt
    // damit aus der Schleife (`[tabindex]:not([tabindex="-1"])` und
    // `el.tabIndex >= 0`), was RICHTIG ist: das `inert` auf den drei
    // Hintergrundknoten haelt den naechsten Tab ohnehin im Panel (§7.2).
    // `preventScroll` haelt die Liste an ihrer Stelle.
    const blendeTastaturAus = useCallback(() => {
      const feld = mobileSucheInputRef.current;
      if (!feld || typeof document === 'undefined') return;
      if (document.activeElement !== feld) return;
      mobileTrefferScrollerRef.current?.focus({ preventScroll: true });
    }, []);
    useEffect(() => {
      if (!mobileSearchOpen) return;
      const el = mobileTrefferScrollerRef.current;
      if (!el) return;
      el.scrollTop = 0;
    }, [mobileSearchQ, mobileSearchBereich, mobileSearchOpen]);

    // 🔴 M3b §B2.6 (W5) — der Scrollstand wird im OEFFNEN-Handler gemerkt, VOR
    // dem State. Verschiebt iOS die Seite beim Fokussieren, liest der Effekt
    // sonst den FALSCHEN Stand und setzt beim Schliessen falsch zurueck.
    const scrollYRef = useRef(0);

    // Befund 3 / M3b §B2.6 — Scroll-Sperre in der `position: fixed`-Form.
    // Ersetzt die `overflow`-Sperre, NICHT verdoppelt: auf iOS ist
    // `body { overflow: hidden }` fuer Touch-Scrollen wirkungslos.
    //   - Vorher-Zustand gemerkt (nicht `''`): hat eine andere Flaeche
    //     `position` schon gesetzt, bliebe ihre Sperre sonst haengen.
    //   - `scrollY` zurueckgesetzt: ohne das springt die Seite beim Schliessen
    //     an den Anfang (der Preis aus der Akte).
    //   - `left/right/width` mitgesetzt: `position: fixed` ohne Breite laesst
    //     die Seite auf Inhaltsbreite schrumpfen.
    useEffect(() => {
      if (!mobileSearchOpen) return undefined;
      const y = scrollYRef.current;
      const b = document.body;
      const vorher = {
        position: b.style.position, top: b.style.top,
        left: b.style.left, right: b.style.right, width: b.style.width,
      };
      b.style.position = 'fixed';
      b.style.top = `-${y}px`;
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
      return () => {
        Object.assign(b.style, vorher);
        window.scrollTo(0, y);
      };
    }, [mobileSearchOpen]);

    // Befund 4 — Esc schliesst das Overlay. Eigener Zuhoerer, NICHT der der
    // Befehlspalette weiter oben: der setzt nur `paletteOffen` zurueck und
    // liesse das Panel stehen.
    // 🔴 M3b §B2.7 — der Riegel: ist das Bereichsblatt offen, schliesst Esc
    // NUR das Blatt. Ohne die Bedingung schloessen beide beim ersten Druck.
    // `M3.9c` misst beide Richtungen.
    useEffect(() => {
      if (!mobileSearchOpen) return undefined;
      const onKey = (e) => {
        if (e.key !== 'Escape') return;
        if (mobileBereichsBlattOffen) return;
        closeMobileSearch();
      };
      document.addEventListener('keydown', onKey);
      return () => document.removeEventListener('keydown', onKey);
    }, [mobileSearchOpen, closeMobileSearch, mobileBereichsBlattOffen]);

    // Befund 2 — der Hintergrund ist `inert`, solange das Panel offen ist.
    // 🔴 Als LEERER String, nicht als Boolean: React 18 kennt `inert` nicht als
    // Boolean-Attribut und warnt bei `true`; `inert=""` ist die gueltige
    // HTML-Form und wirkt in jedem Browser, der das Attribut kennt.
    const hintergrundInert = mobileSearchOpen ? { inert: '' } : {};

    // Befund 2 — die Tab-Schleife an den ZWEI Raendern der Flaeche.
    //
    // Die Flaeche traegt `role="dialog"` und beruft sich damit auf das Muster
    // „Dialog (nicht modal)": Tab verlaesst den Dialog nicht. Gebaut ist nur
    // die Schleife an den Raendern — in der Mitte laeuft der Browser-Standard,
    // sonst waere jede Tab-Bewegung ein Sonderfall.
    //
    // Hausform ist `components/common/FilterSheet.jsx:438-458`; dort steht ein
    // eigenes `tabbbareIn` daneben, weil die Flaeche Kinder des AUFRUFERS
    // traegt. Hier sind es drei Bedienelemente, also steht der Selektor an der
    // Stelle statt in einem zweiten geteilten Baustein.
    const beiTasteImPanel = (e) => {
      if (e.key !== 'Tab') return;
      const halt = Array.from(
        e.currentTarget.querySelectorAll(
          'button, input, select, textarea, a[href], [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => !el.hasAttribute('disabled') && el.tabIndex >= 0);
      if (halt.length === 0) return;
      const erstes = halt[0];
      const letztes = halt[halt.length - 1];
      // `document.activeElement` ist der GEGENSTAND der Frage („wo steht der
      // Fokus"), keine Rollen- oder Textfrage.
      const aktiv = document.activeElement;
      if (!e.shiftKey && aktiv === letztes) {
        e.preventDefault();
        erstes.focus();
      } else if (e.shiftKey && aktiv === erstes) {
        e.preventDefault();
        letztes.focus();
      }
    };

    // header config
    const [headerConfig, setHeaderConfig] = useState({
      title: '', showSearch: true, actions: []
    });

    // Listen for compact sync status to show global indicator
    // { status, id, summary, details, progress? }
    const [syncState, setSyncState] = useState(null);
    useEffect(() => {
      const onState = (event) => {
        setSyncState(event?.detail || null);
      };
      window.addEventListener('admin-sync:state', onState);
      return () => window.removeEventListener('admin-sync:state', onState);
    }, []);



    // When the route changes, reset the header so "search + Add" shows by default
    const location = useLocation();

    // Die NEUE Fallansicht am Telefon traegt ihre eigene Bedienung (Entscheid
    // 43): dort wird die schwebende Icon-Leiste ausgelassen. Begruendung und
    // Grenze stehen oben bei `isMobile`; die Route kommt aus `fall/lib/route`.
    // 🔴 **Seit W4 (2026-10-23) gilt das nur noch unter `rma/:id/neu`.** Classic
    // ist wieder der Standard auf `rma/:id` und bekommt damit den Rahmen von
    // vor S1-8f zurueck - gewollt (Grill-Warnung W1), nicht ein Nebeneffekt.
    const vollflaeche = istFallansicht(location.pathname);

    // 🔴 W-11: der Reset geschieht WAEHREND DES RENDERNS, nicht in einem Effekt.
    //
    // Hier stand `useEffect(() => setHeaderConfig({title:'', showSearch:true,
    // actions:[]}), [location.pathname])`. Dieser Effekt und der Effekt einer
    // Seite, die ihre eigene Kopfzeile setzt, laufen im SELBEN Commit — und
    // React fuehrt Effekte von INNEN nach AUSSEN aus: das `Outlet` haengt in
    // dieser Komponente (`<Outlet />` weiter unten), die Seite ist also das
    // KIND und schreibt ZUERST, der Shell-Effekt danach. Der Reset loeschte
    // damit jede Konfiguration, die eine Seite beim Mounten gesetzt hatte:
    // `showSearch: false` des Dashboards, `title: 'Create Vendor'` in
    // `/vendors/new`, `title`/`showSearch` von `TaxonomyGuide`.
    //
    // Sichtbar war das nur, wo die Zurueckfall-Tabelle `ROUTE_TITLES` etwas
    // ANDERES liefert als die Seite selbst — bei `/overview` und
    // `/incoming-inventory` sind beide Zeichenketten gleich, der Verlust fiel
    // dort nicht auf. `ProductDetail` entkam, weil es erst nach dem Laden des
    // Produkts schreibt, also lange nach diesem Commit.
    //
    // Der Reset muss deshalb VOR den Effekten der Seite liegen. Ein Effekt kann
    // das nicht leisten — auch `useLayoutEffect` laeuft von innen nach aussen.
    // Im Render geht es: React verarbeitet die Zustandsaenderung noch vor dem
    // Commit, die Seite mountet danach und gewinnt. Muster: React-Doku
    // "Adjusting some state when a prop changes".
    //
    // ⚠️ NICHT im Browser bestaetigt — die Herleitung steht oben, ein Browser
    //    stand fuer diesen Posten nicht zur Verfuegung (siehe Bericht).
    const [resetForPath, setResetForPath] = useState(location.pathname);
    if (resetForPath !== location.pathname) {
      setResetForPath(location.pathname);
      setHeaderConfig({ title: '', showSearch: true, actions: [] });
    }

    // 🔴 B1 (Owner-Entscheid, 2026-09-28): hier stand die adminMode-Maschinerie
    // fuer die Legacy-Shell `/admin/legacy/*`. Sie ist geloescht — samt Route
    // und `AdminConfigPage`. Die neue Admin-Shell (`/admin/*`, `AdminLayout`)
    // hat ihre eigene Sektionsnavigation und braucht die globale Sidebar nicht.
    //
    // Die Maschinerie war uebrigens in sich geschlossen UND selbstreferenziell:
    // `handleAdminSectionSelect` setzte den Zustand direkt und feuerte danach
    // ein `admin-section:change`-Event, auf das dieselbe Komponente wieder
    // hoerte, um denselben Zustand noch einmal zu setzen.

    // Track multiple concurrent syncs
    const [syncMap, setSyncMap] = useState(new Map()); // id -> number|null
    const [panelOpen, setPanelOpen] = useState(false);
    const panelAnchorRef = useRef(null);

    useEffect(() => {
      function onSync(e) {
        // `detail` carries an optional human string (e.g. "42 / 150") that
        // updateGlobalSync spreads onto the event; render it over the % when set.
        const { type, id, progress, label, job, detail } = e.detail || {};
        setSyncMap((prev) => {
          const next = new Map(prev);
          if (type === 'start') {
            next.set(id, { id, label, job, status: 'running', progress, detail });
          }
          if (type === 'update' && next.has(id)) {
            const entry = next.get(id);
            next.set(id, { ...entry, progress, status: 'running', detail: detail ?? entry.detail });
          }
          if (type === 'end') next.delete(id);
          return next;
        });
      }
      window.addEventListener('global-sync', onSync);
      return () => window.removeEventListener('global-sync', onSync);
    }, []);

    const [jobStatuses, setJobStatuses] = useState([]);
    const fetchJobStatuses = useCallback(async () => {
      try {
        const { data } = await axios.get(`${API}/api/dashboard/jobs`);
        const jobs = Array.isArray(data?.jobs) ? data.jobs : [];
        setJobStatuses(jobs);
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new CustomEvent(DASHBOARD_JOBS_EVENT, { detail: { jobs } }));
        }
      } catch (err) {
        const status = err?.response?.status;
        if (status === 502 || status === 503) {
          // backend temporarily unavailable — not an app error, suppress noise
        } else {
          console.error(err);
        }
        setJobStatuses([]);
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new CustomEvent(DASHBOARD_JOBS_EVENT, { detail: { jobs: [] } }));
        }
      }
    }, []);

    useEffect(() => {
      fetchJobStatuses();
      // Poll fast when jobs are running, slow when idle (reduces 502 console noise)
      const delay = jobStatuses.length > 0 ? JOB_POLL_FAST : JOB_POLL_IDLE;
      const interval = setInterval(fetchJobStatuses, delay);
      return () => clearInterval(interval);
    }, [fetchJobStatuses, jobStatuses.length]);

    useEffect(() => {
      const handler = () => fetchJobStatuses();
      window.addEventListener(DASHBOARD_JOBS_REFRESH, handler);
      return () => window.removeEventListener(DASHBOARD_JOBS_REFRESH, handler);
    }, [fetchJobStatuses]);

    // Unified job list from all sources
    const allJobs = useMemo(() => {
      const jobs = [];
      // global-sync events (admin sync, etc.)
      for (const entry of syncMap.values()) {
        const hasPct = typeof entry.progress === 'number';
        // Prefer an explicit detail string (e.g. "42 / 150") over the bare %.
        let detail = entry.detail;
        if (!detail) detail = hasPct ? `${Math.round(entry.progress * 100)}%` : 'Running';
        jobs.push({
          id: entry.id,
          label: entry.label || entry.job || 'Sync job',
          progress: hasPct ? entry.progress : null,
          detail,
        });
      }
      // API-polled jobs (/api/dashboard/jobs)
      for (const job of jobStatuses) {
        if (job.status !== 'running') continue;
        if (jobs.some(j => j.id === job.id)) continue;
        const d = job.details || {};
        const progress = d.targets > 0 ? (d.completed ?? 0) / d.targets : null;
        const parts = [];
        if (d.targets > 0) parts.push(`${d.completed ?? 0} / ${d.targets}`);
        if (d.succeeded > 0) parts.push(`${d.succeeded} ok`);
        if (d.failed > 0) parts.push(`${d.failed} failed`);
        jobs.push({
          id: job.id,
          label: job.label,
          progress,
          detail: parts.length ? parts.join(' · ') : 'Running',
        });
      }
      // admin-sync:state event
      if (syncState?.status === 'running') {
        const id = syncState.id || 'admin-sync';
        if (!jobs.some(j => j.id === id)) {
          jobs.push({
            id,
            label: syncState.summary?.label || 'Admin sync',
            progress: typeof syncState.progress === 'number' ? syncState.progress : null,
            detail: syncState.summary?.targets
              ? `${syncState.summary.targets} targets`
              : 'Running',
          });
        }
      }
      return jobs;
    }, [syncMap, jobStatuses, syncState]);

    // Auto-close panel when all jobs finish
    useEffect(() => {
      if (allJobs.length === 0) setPanelOpen(false);
    }, [allJobs.length]);

    const { showBar, percent, indeterminate } = useMemo(() => {
      if (allJobs.length === 0) return { showBar: false, percent: 0, indeterminate: false };
      const withPct = allJobs.filter(j => j.progress != null);
      if (allJobs.length === 1 && withPct.length === 1) {
        return { showBar: true, percent: Math.round(withPct[0].progress * 100), indeterminate: false };
      }
      return { showBar: true, percent: 0, indeterminate: true };
    }, [allJobs]);

      const { title, actions = [] } = headerConfig;
      const toolbarMinHeight = theme.mixins?.toolbar?.minHeight;
      const headerHeight =
        typeof toolbarMinHeight === 'number'
          ? toolbarMinHeight
          : parseInt(toolbarMinHeight, 10) || 64;

      const jobIndicator = allJobs.length > 0 ? (
        <ClickAwayListener onClickAway={() => setPanelOpen(false)}>
          <Box>
            <Tooltip title={panelOpen ? '' : `${allJobs.length} active process${allJobs.length > 1 ? 'es' : ''}`} arrow>
              <Box
                ref={panelAnchorRef}
                onClick={() => setPanelOpen(v => !v)}
                sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
              >
                <PulseDot />
              </Box>
            </Tooltip>
            <Popper
              open={panelOpen}
              anchorEl={panelAnchorRef.current}
              placement="bottom-end"
              disablePortal={false}
              style={{ zIndex: 1400 }}
              modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
            >
              <Grow in={panelOpen}>
                <Paper
                  elevation={6}
                  sx={{ p: 2, minWidth: 300, maxWidth: 380, borderRadius: 2 }}
                >
                  <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>
                    Active processes
                    <Box
                      component="span"
                      sx={{ ml: 1, color: 'text.secondary', fontWeight: 400 }}
                    >
                      ({allJobs.length})
                    </Box>
                  </Typography>
                  {allJobs.map((job, idx) => (
                    <Box key={job.id} sx={{ mb: idx < allJobs.length - 1 ? 2 : 0 }}>
                      <Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>
                        {job.label}
                      </Typography>
                      <LinearProgress
                        variant={job.progress != null ? 'determinate' : 'indeterminate'}
                        value={job.progress != null ? Math.round(job.progress * 100) : undefined}
                        sx={{ mb: 0.5, borderRadius: 1, height: 6 }}
                      />
                      <Typography variant="caption" color="text.secondary">
                        {job.detail}
                      </Typography>
                    </Box>
                  ))}
                </Paper>
              </Grow>
            </Popper>
          </Box>
        </ClickAwayListener>
      ) : null;

      const headerAdornment = jobIndicator ? (
        <Stack direction="row" spacing={1} alignItems="center">
          {jobIndicator}
        </Stack>
      ) : null;
  
      // unsaved guard
      const [unsaved, setUnsaved]         = useState(false);
      const [onDiscard, setOnDiscard]     = useState(() => {});
      const [pendingPath, setPendingPath] = useState(null);
      const [confirmOpen, setConfirmOpen] = useState(false);
    
      const registerDiscard = useCallback(fn => { setOnDiscard(() => fn); setUnsaved(true); }, []);
      const clearUnsaved    = useCallback(() => { setUnsaved(false); setOnDiscard(() => {}); }, []);

      const handleNav = path => {
        if (unsaved) {
          setPendingPath(path);
          setConfirmOpen(true);
        } else {
          navigate(path);
        }
      };
  
      // 🔴 Der Inhalt steht in BEIDEN Breiten an derselben Stelle im Baum und
      // bekommt nur andere Huelle. Bis 2026-10-18 rendete jeder Zweig sein
      // eigenes `<RoutedContent />`; ein Wechsel von `isMobile` (Fenster ueber
      // `sm`, Tablet gedreht) unmountete damit die ganze Fallansicht und riss
      // Agentenkarte, ungesendeten Entwurf und offene Ebenen mit.
      const desktopMainSx = {
        gridArea: 'content',
        // W-13: a grid item's automatic minimum size is its
        // min-content size, so this column used to grow to fit its
        // widest child. A page holding a fixed-width table —
        // POOverview's minWidth:1000 inside its own overflowX:'auto'
        // box, PODetail's minWidth:800, ProductTaxonomyDetail's
        // minWidth:1200 — therefore pushed the whole grid past the
        // viewport and the page scrolled sideways, independently of
        // the --content-min floor that was gated in theme.js.
        // minWidth:0 zeroes that automatic minimum: the column now
        // tracks the viewport and the wide table scrolls inside its
        // own box instead of moving the page.
        // Measured, 1024 px viewport with a minWidth:1000 table:
        // document scrollWidth 1328 -> 1024.
        minWidth: 0,
        pt: `${headerHeight + 16}px`,
        px: { xs: 1.5, sm: 2.5 },
        pb: 4,
        minHeight: '100vh',
      };
      const mobileMainSx = {
        flexGrow: 1,
        px: 0,
        // margin shifts box top to the AppBar's lower edge (bar height +
        // device inset) so border-radius is visible below it — M1, 2026-10-09
        mt: MOBILE_APP_BAR_CLEARANCE,
        pt: 1,        // small internal breathing room below the curve
        // the bottom-nav clearance, incl. device inset — one source with
        // `MobileBottomNav` and the sticky table footers (was `+ 80px`)
        // 🔴 Auf der Fallansicht entfaellt der Abstand MIT der Leiste
        //    (Entscheid 43): ein Abstand ohne Leiste liesse einen
        //    leeren Streifen unter dem Verfasser stehen.
        pb: vollflaeche ? 0 : MOBILE_BOTTOM_NAV_CLEARANCE,
        // minHeight ensures short pages fill the screen;
        // the dark wrapper (parent) fills anything below via flexGrow: 1
        minHeight: `calc(100vh - ${MOBILE_APP_BAR_CLEARANCE})`,
        bgcolor: 'background.default',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
      };

      return (
        <HeaderConfigContext.Provider value={{ ...headerConfig, setHeaderConfig }}>
        <UnsavedContext.Provider value={{ unsaved, registerDiscard, clearUnsaved }}>
    
          <Box
            sx={isMobile
              ? { bgcolor: V2.ink, minHeight: '100vh' }
              : {
                  // Im Customize-Modus breiter — Begruendung und Rechnung an
                  // `SIDEBAR_WIDTH_MODUS`. Ausserhalb bleibt es bei 240.
                  '--sidebar-width': `${anpassen ? SIDEBAR_WIDTH_MODUS : SIDEBAR_WIDTH}px`,
                  minHeight: '100vh',
                  backgroundColor: 'background.default',
                  display: 'grid',
                  gridTemplateColumns: 'var(--sidebar-width) 1fr',
                  gridTemplateRows: '1fr',
                  gridTemplateAreas: '"side content"',
                }}
          >
          {!isMobile ? (
            <>
                <Box sx={{ gridArea: 'side', position: 'relative' }}>
                  <Sidebar
                    onNavigate={handleNav}
                    headerHeight={headerHeight}
                    anpassen={anpassen}
                    setAnpassen={setAnpassen}
                  />
                </Box>
                <HeaderBar
                  title={headerConfig.title}
                  showSearch={headerConfig.showSearch}
                  actions={headerConfig.actions}
                  onCreateStandalone={onCreateStandalone}
                  onCreateVariant={onCreateVariant}
                  backLink={headerConfig.backLink}
                  rightAdornment={headerAdornment}
                />
                <Collapse
                  in={showBar}
                  unmountOnExit
                  sx={{
                    position: 'fixed',
                    top: headerHeight,
                    left: 0,
                    right: 0,
                    zIndex: (theme) => theme.zIndex.appBar + 1,
                  }}
                >
                  <LinearProgress
                    variant={indeterminate ? 'indeterminate' : 'determinate'}
                    value={indeterminate ? undefined : percent}
                  />
                </Collapse>
            </>
          ) : (
            // ─── Mobile ──────────────────
            // The dark wrapper background (outer Box, sx above) shows through
            // the content's rounded top corners.
            <>
              <AppBar
                {...hintergrundInert}
                position="fixed"
                elevation={0}
                sx={{
                  // Fully opaque — matches the wrapper bgcolor exactly so the
                  // border-radius corners behind the bar have no colour mismatch
                  background: V2.ink,
                  // 🔴 M1 (2026-10-09): dieser 1 px gehoert in den Kopfabstand —
                  // er steckt in `MOBILE_APP_BAR_CLEARANCE` als
                  // `MOBILE_APP_BAR_BORDER_PX` (`theme/tokens.js`). Ohne ihn
                  // beginnt die Inhaltsflaeche 1 px unter der Leiste.
                  borderBottom: '1px solid rgba(255,255,255,0.08)',
                  boxShadow: '0 1px 0 rgba(0,0,0,0.12), 0 2px 16px rgba(0,0,0,0.18)',
                  // 🔴 M1 (2026-10-09): das Geraetepolster der Statusleiste. Die
                  // Leiste wird um das Polster HOEHER, nicht verschoben — der
                  // `Toolbar` darunter behaelt seine 44 px (E9), und die Summe
                  // ist `MOBILE_APP_BAR_CLEARANCE`. Seit `viewport-fit=cover`
                  // (`public/index.html:9`) ist der Wert auf einem Geraet mit
                  // Home-Indikator > 0; ohne ihn laege die Leiste unter der Uhr.
                  pt: 'env(safe-area-inset-top, 0px)',
                }}
              >
                {/* E9 (2026-10-07): die 44 ist hier die HOEHE DER LEISTE, kein
                    Tippziel — MUI's Toolbar-Vorgabe waere 56 px. Sie bleibt
                    darum stehen und wird nicht auf einen Tippziel-Boden
                    umgestellt; das waere eine andere Aussage. */}
                <Toolbar sx={{ gap: 0.5, minHeight: 44, px: 1.5 }}>
                  {/* Small logo */}
                  <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
                    <img
                      src={LogoImg}
                      alt="Logo"
                      style={{ height: 24, width: 'auto', opacity: 0.95 }}
                    />
                  </Box>
                  <Typography
                    variant="h6"
                    noWrap
                    sx={{ flex: 1, fontWeight: 600, fontSize: 15, letterSpacing: -0.1 }}
                  >
                    {/* Befund 5(i): Seiten mit eigenem Seitentitel tragen ihn im Kopf —
                        die Leiste zeigt dann NICHTS (sonst stuende er zweimal da). Der
                        Knoten bleibt stehen, er traegt den `flex: 1`-Abstandhalter. */}
                    {hatEigenenKopf(location.pathname)
                      ? ''
                      : (title || deriveRouteTitle(location.pathname))}
                  </Typography>
                  {/* Page-level actions (Save / Discard etc.) */}
                  {actions.length > 0 && (
                    <Stack direction="row" spacing={0.5}>
                      {actions.map(({ key, label, onClick, disabled, variant = 'contained', color = 'inherit', loading }) => (
                        <Button
                          key={key}
                          color={color}
                          variant={variant}
                          onClick={onClick}
                          disabled={disabled || loading}
                          size="small"
                          sx={{ borderRadius: 999, px: 2 }}
                        >
                          {loading ? '…' : label}
                        </Button>
                      ))}
                    </Stack>
                  )}
                </Toolbar>
              </AppBar>

              {/* ── Floating search overlay ──────────────────────────────── */}
              <AnimatePresence>
                {mobileSearchOpen && (
                  <Box
                    key="search-backdrop"
                    data-testid="mobil-suche-abdunklung"
                    component={motion.div}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    // Befund 1: dieselbe Abfrage wie am Panel — die Abdunklung
                    // faehrt sonst weiter ein, waehrend das Panel schon steht.
                    transition={reduzierteBewegung ? { duration: 0 } : { duration: 0.18 }}
                    // 🔴 **`onPointerDown`, NICHT `onClick` — und der Grund ist
                    // die ANIMATION** (R16-W2, S Nachbesserung 6, 2026-10-18).
                    // Die Abdunklung ist ein `AnimatePresence`-Kind mit 180 ms
                    // `exit`; sie bleibt nach dem Schliessen im Baum, waehrend
                    // das Panel schon geht. Ein `onClick` fiele erst nach dem
                    // vollstaendigen Tipp — und der Rest desselben Klicks traefe
                    // die Seite darunter. Der fruehe `pointerdown` schliesst,
                    // bevor `mouseup`/`click` ein zweites Ziel finden; die
                    // laufende Ausblendung schluckt den Rest. Der DESKTOP-Backdrop
                    // haengt dagegen synchron ab und traegt deshalb `onClick`
                    // (s. dort).
                    // 🔴 M3b §B2.7 — ist das Bereichsblatt offen, schliesst ein
                    // Tippen daneben NUR das Blatt: die Suche bleibt offen und
                    // der Fokus kehrt ins Feld zurueck (M3.9b). Ohne diesen
                    // Riegel schloesse die Schicht die ganze Suche, bevor der
                    // eigene Ausserhalb-Zuhoerer des Blatts sie erreicht.
                    onPointerDown={(e) => {
                      // 🔴 Suche mobil v2, Stufe 2 — der TOLERANZSTREIFEN
                      // (R16-W10) ist als SONDERLOGIK gefallen (Plan §9.1,
                      // §9.3). Seine WIRKUNG traegt jetzt die Innenspalte: die
                      // Feldzeile (`suche-suchleiste`) und die Bereichsleiste
                      // (`suche-chip-zeile`) stehen mit `pointerEvents: 'auto'`
                      // im Panel, samt ihrem 8-px-Polster — ein Fehltipp auf
                      // das Polster oder in die Luecke Feld ↔ Chips ist damit
                      // IHR Ziel und erreicht diese Schicht gar nicht.
                      // `M3.9e`/`M3.9g` pruefen genau diese Luecke.
                      if (mobileBereichsBlattOffen) {
                        // 🔴 R15/M3.9b (Nachbesserung 1): `preventDefault` ist
                        // hier TRAGEND, nicht Kosmetik. Der Fokus wird auf
                        // `pointerdown` gesetzt; die Standardaktion des darauf
                        // folgenden `mousedown` setzt ihn sonst auf `<body>`
                        // zurueck, weil die Schicht kein fokussierbares Element
                        // ist. Gemessen im A/B m3b1: `toBeFocused` war danach
                        // rot. Die zwei anderen Schliesswege (✕, Blattzeile)
                        // rufen `preventDefault` aus demselben Grund.
                        e.preventDefault();
                        setMobileBereichsBlattOffen(false);
                        mobileSucheInputRef.current?.focus();
                        return;
                      }
                      closeMobileSearch();
                    }}
                    sx={{
                      // 🔴 R16-W1 (Nachbesserung 1): die Abdunklung beginnt bei
                      // `top: 0` und deckt die Kopfleiste MIT ab.
                      //
                      // Vorher stand hier `top: MOBILE_APP_BAR_CLEARANCE` mit der
                      // Begruendung „so the top bar stays crisp" — und das war der
                      // Fehler: die Leiste ist `inert`, solange das Panel offen
                      // ist, sah aber voll bedienbar aus. Sichtbare „Save"/„Discard"-
                      // Knoepfe, die nichts tun, sind die schlechtere Auskunft als
                      // eine abgedunkelte Leiste. `zIndex` 1299 liegt ueber
                      // `theme.zIndex.appBar` (1100), die Leiste liegt also darunter.
                      //
                      // Der `MOBILE_APP_BAR_CLEARANCE`-Abstand bleibt am PANEL und
                      // an `<main>` — dort trennt er Inhalt von Leiste. Hier war er
                      // nur die Sichtbarkeitsregel fuer den Kopf.
                      // 🔴 M3b §B2.2 — der UEBERSTAND ist eine HYPOTHESE (W11),
                      // kein Beleg: ob `inset: 0` bei layout-relativem `fixed`
                      // Luecken laesst, ist nicht gemessen. Er kostet nichts und
                      // schadet nicht; `M3.3` misst die WIRKUNG (unter der
                      // Kapsel liegt Overlay), nicht den Wert. Er ist KEINE
                      // Mutationsgroesse: `SUCHE_SCHICHT_UEBERSTAND_PX → 0` und
                      // `bottom: 0` deckt den Messpunkt weiterhin.
                      position: 'fixed',
                      top: -SUCHE_SCHICHT_UEBERSTAND_PX,
                      left: 0,
                      right: 0,
                      bottom: -SUCHE_SCHICHT_UEBERSTAND_PX,
                      zIndex: 1299,
                      bgcolor: 'rgba(0,0,0,0.35)',
                      backdropFilter: 'blur(3px)',
                      WebkitBackdropFilter: 'blur(3px)',
                      // 🔴 M2 §3 Abhilfe 3: die Abdunklung ist `position: fixed`
                      // ueber die volle Flaeche und KEIN Scroller. Ohne diesen
                      // Riegel reicht ein Wisch dort die Bewegung an die Seite
                      // durch (Scroll-Chaining) — und genau das beschreibt der
                      // Owner. `touch-action: none` bricht den Kettengang an der
                      // Wurzel und laesst `onPointerDown` (Schliessen durch
                      // Tippen) unberuehrt.
                      // 🔴 NUR an die Abdunklung, NICHT an das Panel: das Panel
                      // traegt den Scroller, und `touch-action: none` darauf
                      // machte die Trefferliste unscrollbar. `M2.3` prueft beide
                      // Richtungen.
                      touchAction: 'none',
                    }}
                  />
                )}
              </AnimatePresence>
              <AnimatePresence>
                {mobileSearchOpen && (
                  <Box
                    key="search-panel"
                    component={motion.div}
                    // Befund 2: die Flaeche ist ein Dialog und nimmt den Fokus
                    // gefangen (Schleife an den Raendern, `inert` auf dem
                    // Hintergrund). `aria-modal` ist deshalb keine Behauptung
                    // mehr, sondern gedeckt — ein `aria-modal` OHNE Falle waere
                    // ein falsches Versprechen an die Hilfstechnik.
                    role="dialog"
                    aria-modal="true"
                    // 🔴 R16-W5 / R15-W10: eigener Name. Vorher hiessen Dialog
                    // UND Eingabe „Search" — zwei Bedienelemente mit demselben
                    // zugaenglichen Namen auf derselben Flaeche. Die Eingabe
                    // behaelt „Search" (das ist ihre Rolle), der Dialog sagt,
                    // WAS er ist.
                    aria-label="Search overlay"
                    onKeyDown={beiTasteImPanel}
                    // 🔴 Befund 1, der Stellvertreter. „Ohne Spring" ist keine
                    // DOM-beobachtbare Aussage; der Zweig, den der Kode nimmt,
                    // ist eine. Die Probe liest dieses Attribut in BEIDE
                    // Richtungen (reduce → 'ruhig', sonst → 'feder'), damit sie
                    // nicht schon ohne die Aenderung gruen sein kann.
                    data-bewegung={reduzierteBewegung ? 'ruhig' : 'feder'}
                    // 🔴 M2 §6 Punkt 2: derselbe Griff wie `data-bewegung` — der
                    // ZWEIG, den der Kode nimmt, wird beobachtbar. In Chromium ist
                    // `env(safe-area-inset-bottom)` 0, also rechnet
                    // `calc(0px + 12px)` = 12 px in BEIDEN Zweigen; eine Probe auf
                    // die berechnete Polsterung koennte sie nicht unterscheiden
                    // (Regel 17 §1). Das Attribut macht den Zweig lesbar, die
                    // Probe erzwingt ihn ueber `window.innerHeight`.
                    // 🔴 M3b §B2.3: der Zweig-MERKER fuer Proben — gespeist aus
                    // `visualViewport`. 🔴 **Seit R15-W3 (Nachbesserung 2) ist
                    // `window.innerHeight` hier ein RECHENWERT**, aber nur als
                    // VERGLEICH in `tastaturOffen` (Differenz ≥ 150 px, `scale`
                    // < 1,05) — nicht in der Saeulenformel. Der Zweig speist
                    // `--suche-unten`, die Geometrie haengt also mittelbar
                    // daran. Verboten bleibt `innerHeight` in
                    // `useVisualViewport` und in der Formel (M3.1c).
                    data-tastatur={tastaturOffen ? 'offen' : 'zu'}
                    // R16-W3 — der Zweig-MERKER des unteren Abstands. Chromium
                    // substituiert `var()` in `getComputedStyle(...)--suche-unten`
                    // (dann sind beide Zweige „12px", weil `env()` dort 0 ist);
                    // der Zweig ist deshalb wie `data-tastatur` DOM-beobachtbar.
                    // 🔴 R15-W1: `art` wird aus DEMSELBEN `wert` abgeleitet, den
                    // `--suche-unten` liest (ein Objekt, eine Quelle).
                    data-suche-unten={untererAbstand.art}
                    data-testid="mobil-suche-panel"
                    // W-71: volle `transform`-Strings statt der x/y-Kurzform.
                    // Framer Motions Shorthand laeuft ueber requestAnimationFrame
                    // auf dem Hauptthread — NICHT hardwarebeschleunigt. Dieses
                    // Panel ist `position: fixed` ueber die volle Breite und
                    // faehrt um 100 % herein: die Stelle, an der fallende Frames
                    // sichtbar werden. Kein `scale` daneben, also geht die
                    // Umstellung ohne Kompositionsverlust.
                    initial={{ transform: 'translateY(100%)' }}
                    animate={{ transform: 'translateY(0)' }}
                    exit={{ transform: 'translateY(100%)' }}
                    // Befund 1: bei reduzierter Bewegung KEINE Feder, sondern
                    // ein Sprung (`duration: 0`).
                    transition={
                      reduzierteBewegung
                        ? { duration: 0 }
                        : { type: 'spring', damping: 32, stiffness: 340, mass: 0.75 }
                    }
                    sx={{
                      // 🔴 M3b §B2.1/§B2.3 — die Panelwurzel IST die Saeule.
                      // Sie bleibt das dialogtragende Element (Rolle, Name,
                      // `data-bewegung`, `data-tastatur`, `data-testid`) und
                      // bekommt die Geometrie aus dem Visual Viewport.
                      position: 'fixed',
                      '--suche-vv-top': `${vv.top}px`,
                      '--suche-hoehe': vv.hoehe == null ? '100vh' : `${vv.hoehe}px`,
                      '--suche-sicher-oben': SUCHE_SICHER_OBEN,
                      // Der seitliche Rand des Bereichsblatts (12 px). Er ist
                      // seit v2 der EINZIGE Verbraucher dieser Variablen im
                      // Panel — Kapsel und Karte gibt es nicht mehr.
                      '--suche-abstand': `${SUCHE_ABSTAND_PX}px`,
                      // Der Grundwert des unteren Listenrands (8 px) — Tastatur
                      // offen; geschlossen `max(8px, env(safe-area-inset-bottom))`.
                      '--suche-treffer-polster': `${SUCHPANEL_TREFFER_POLSTER_PX}px`,
                      '--suche-unten': untererAbstand.wert,
                      // 🔴 Suche mobil v2 Stufe 1 (§2.3) — die neue Geometrie.
                      // `top = max(vv.top, sicher)`: der sichere Bereich zaehlt
                      // nur, solange der Visual Viewport ihn noch enthaelt, und
                      // die 8 px der Feldzeile liegen INNEN (kein Zuschlag).
                      // `height = max(Boden, vv.top + vv.hoehe − top)`: die
                      // Subtraktion ist der einzige Ausdruck, der in beiden
                      // Lagen (mit und ohne Versatz) an derselben Kante endet;
                      // `vv.hoehe` allein endete bei gesetztem `top` 59 px unter
                      // der Tastatur. Der Boden 112 steht IN der Formel (B5),
                      // nicht als `minHeight` daneben: das Panel darf hoeher als
                      // der sichtbare Bereich sein, damit die Feldzeile nicht
                      // angeschnitten wird.
                      '--suche-top': 'max(var(--suche-vv-top), var(--suche-sicher-oben))',
                      '--suche-boden': `${SUCHE_PANEL_MINDESTHOEHE_PX}px`,
                      top: 'var(--suche-top)',
                      height:
                        'max(var(--suche-boden), calc(var(--suche-vv-top) + var(--suche-hoehe) - var(--suche-top)))',
                      left: 0, right: 0,
                      zIndex: 1300,
                      // 🔴 Suche mobil v2 Stufe 1 — NACHBESSERUNG 1 (2026-10-31):
                      // der Grund der Saeule ist DECKEND (`background.default`,
                      // Plan §2, §2.2). Bis hierher stand die Zusicherung nur im
                      // Kommentar darunter; im Kode fehlte sie, und das Foto
                      // (`foto/suche1_zweig_klein/390_treffer.jpg`) zeigte die
                      // Seite verschwommen durch Feldzeile UND Trefferliste,
                      // waehrend die klebenden Gruppenkoepfe als helle Baender
                      // quer darueber standen. Der Grund liegt an der WURZEL und
                      // nicht an den zwei Kindern: er deckt die volle
                      // Panelhoehe in BEIDEN Zustaenden (`leer` und Treffer) —
                      // der Scroller wird nur mit `mobileSearchQ` gerendert.
                      // Die Abdunklung darunter bleibt die Trennung von der
                      // Seite (Plan §9.1). `pointerEvents: 'none'` bleibt
                      // unveraendert: eine deckende Flaeche aendert an der
                      // Trefferweitergabe nichts, sie malt nur.
                      bgcolor: 'background.default',
                      display: 'flex',
                      flexDirection: 'column',
                      // 🔴 v2: Inhalt von OBEN (Feldzeile oben, Liste darunter).
                      // `justifyContent: 'flex-end'` war die untere Verankerung
                      // der Kapsel; mit dem Feld oben haette es den Inhalt an den
                      // unteren Rand gedrueckt.
                      justifyContent: 'flex-start',
                      // Die Saeule selbst nimmt keine Zeigerereignisse: Karte,
                      // Kapsel und Blatt schalten ihre eigenen ein (§B2.1).
                      pointerEvents: 'none',
                      // 🔴 M2 §3 Abhilfe 2 bleibt: `overflow: 'hidden'` macht die
                      // Saeule zum Scroll-Container — die Voraussetzung dafuer,
                      // dass `overscroll-behavior: contain` greift. Beides steht
                      // hier EXPLIZIT im Bauteil (§B2.1); `MOBILE_SEARCH_PANEL_SX`
                      // gibt es seit M3b-Nachbesserung 3 nicht mehr.
                      overflow: 'hidden',
                      overscrollBehavior: 'contain',
                    }}
                  >
                    {/* 🔴 Suche mobil v2 Stufe 1 (§2.1/§2.2) — die FELDZEILE
                        sitzt OBEN. Kein Kapselradius, kein Kasten, kein Glas:
                        der Grund der Flaeche ist `background.default` und steht
                        an der PANELWURZEL (s. dort; Nachbesserung 1, 2026-10-31),
                        die Abdunklung darunter bleibt die Trennung von der Seite.
                        Der seitliche Rand ist der 8-px-Rand INNEN (`pt`, `pb`
                        und `px` derselbe Wert) — nicht ein Zuschlag vor der
                        Panel-Oberkante (§2.3, W5). */}
                    <Box data-testid="suche-suchleiste" sx={{
                      flexShrink: 0,
                      px: SUCHE_V2_RAND,
                      pt: SUCHE_V2_RAND,
                      // 🔴 Stufe 6a (§2.3/B3): die 16-px-Luecke zur Chip-Zeile
                      // wird 8/8 geteilt — hier die obere Haelfte. Sichtbar
                      // bleibt EINE Luecke von 16.
                      pb: SUCHE_LUECKE_HALB,
                      // Die Feldzeile traegt die Zeigerereignisse SELBST: ein
                      // Tipp auf ihr Polster gehoert der Suche, nicht der
                      // Abdunklung (die Wirkung des alten Toleranzstreifens,
                      // §9.1). Der Wisch darf die Seite nicht bewegen.
                      touchAction: 'none',
                      pointerEvents: 'auto',
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {/* 🔴 v2, Stufe 6a — DAS FELD: volle Pille
                            (`SUCHE_FELD_RADIUS` = 999 px), 48 px hoch
                            (`SUCHE_FELD_HOEHE_PX`), weiss mit `divider`-Rand
                            und `SHADOWS.card`. Es traegt Lupe, Eingabe und das
                            ✕ ZUM LEEREN; das ✕ zum SCHLIESSEN steht ausserhalb,
                            rechts daneben (V1.9). */}
                        <Box
                          data-testid="suche-feld"
                          // 🔴 R15-B2 (Runde 1, 2026-11-04): Fokuswechsel werden
                          // an der GEMEINSAMEN Zeile gezaehlt, nicht am Feld. Der
                          // Tab aus dem Feld trifft zuerst das Leeren-✕ (das
                          // naechste Tab-Ziel, ein Geschwister in derselben Box);
                          // ein `onBlur` am Feld allein saehe nur diesen einen
                          // Wechsel und muesste ihn durchlassen — dann faellt der
                          // Zustand nie, wenn der Fokus SPAETER die Zeile
                          // verlaesst. Hier gilt: solange `relatedTarget` in der
                          // Zeile liegt (Feld ↔ ✕), bleibt `feldFokus`; sobald
                          // der Fokus die Zeile verlaesst (`<body>`, Fenster,
                          // `null`), faellt er. Reacts `onFocus`/`onBlur` blubbern
                          // (`focusin`/`focusout`), der Handler sieht also BEIDE
                          // Kinder.
                          onFocus={() => setFeldFokus(true)}
                          onBlur={(e) => {
                            // `relatedTarget` ist `null` beim Fokusverlust ans
                            // Fenster und kann ein Nicht-Knoten sein; `contains`
                            // erwartet einen Knoten (R15-B2).
                            const ziel = e.relatedTarget;
                            if (ziel instanceof Node && e.currentTarget.contains(ziel)) return;
                            setFeldFokus(false);
                          }}
                          sx={{
                            flex: 1, minWidth: 0, display: 'flex', alignItems: 'center',
                            // 🔴 Stufe 6a (Akz. 1): weisse Pille mit Rand und
                            // Schatten statt grauer Flaeche. Der Rand steht als
                            // ZWEI Eigenschaften — `border: '1px solid divider'`
                            // ist kein gueltiger Wert: MUI loest
                            // Palette-Schluessel fuer `borderColor` auf, nicht
                            // innerhalb der `border`-Kurzform (W-G).
                            bgcolor: 'background.paper',
                            border: '1px solid',
                            borderColor: 'divider',
                            boxShadow: SUCHE_FELD_SCHATTEN,
                            borderRadius: SUCHE_FELD_RADIUS,
                            px: 1.5,
                            minHeight: SUCHE_FELD_HOEHE_PX,
                            // 🔴 R16-W4 (Runde 1, 2026-11-04): der Fokusring
                            // der Pille. Der hausweite `*:focus-visible`-Ring
                            // (`theme.js:450-454`) erreicht das Feld NICHT:
                            // MUI's `InputBase` setzt `&:focus { outline: 0 }`
                            // (InputBase.js:163) und gewinnt gegen den
                            // Stern-Selektor. Deshalb traegt die PILLE den Ring,
                            // sobald irgendetwas in ihr den Fokus hat — Hausform
                            // `focusRing()`, hell und dunkel derselbe Ton.
                            '&:focus-within': { ...focusRing() },
                          }}
                        >
                          <SearchIcon sx={{ fontSize: SUCHE_IKON_PX, mr: 0.75, color: 'text.disabled', flexShrink: 0 }} />
                          <InputBase
                            autoFocus
                            placeholder="Search…"
                            // 🔴 M3b §B2.9 (F2) — Enter schliesst die
                            // TASTATUR, nicht die Suche: `enterKeyHint` sagt dem
                            // iOS-Keyboard „Search", `onKeyDown` gibt dem Feld
                            // den Fokus zurueck an die Seite. Es loest KEINEN
                            // Abruf aus (der laeuft ueber die 280-ms-
                            // Entprellung), schliesst NICHT das Panel und
                            // aendert NICHT `mobileSearchQ`. Das ist eine NEUE
                            // Verhaltensänderung (Changelog, Regel 10).
                            inputProps={{
                              'aria-label': 'Search',
                              // 🔴 Suche mobil v2, Stufe 3 (Plan §8.1): die
                              // Tastatur-Attribute des Suchfelds. `enterKeyHint`
                              // bleibt unveraendert (blaue „Suchen"-Taste).
                              // 🔴 KEIN `type="search"` (§8.2): das aendert die
                              // ROLLE (`textbox` → `searchbox`) an 41
                              // Aufrufstellen der Tests und bringt WebKits
                              // eigenen Loeschknopf neben unseren ✕.
                              inputMode: 'search',
                              autoCorrect: 'off',
                              autoCapitalize: 'none',
                              spellCheck: false,
                              autoComplete: 'off',
                              enterKeyHint: 'search',
                              onKeyDown: (e) => {
                                if (e.key !== 'Enter') return;
                                e.preventDefault();
                                e.target.blur();
                              },
                            }}
                            inputRef={mobileSucheInputRef}
                            value={mobileSearchQ}
                            onChange={(e) => setMobileSearchQ(e.target.value)}
                            // 🔴 Stufe 6a: `feldFokus` haelt den Zustand, den
                            // allein das LEEREN-✕ liest. `onBlur` feuert beim
                            // Tipp auf ✕ oder Chip NICHT: beide rufen
                            // `preventDefault` im `pointerdown`/`mousedown` und
                            // halten den Fokus damit im Feld (R16-W2).
                            // 🔴 Stufe 6a (§4.1, R15-B1/R16-W1): `FS.inputMobil`
                            // (16), NICHT `FS.lg` (15). Das Panel ist nur unter
                            // `sm` erreichbar, und `theme.js:471-481` erzwingt
                            // dort `font-size: 16px !important` fuer jedes
                            // `input` — iOS zoomt beim Fokussieren, sobald ein
                            // Feld kleiner als 16 ist. Die 15 in `sx` waere eine
                            // Absicht, die der Riegel ueberschreibt, und die
                            // Quelle behauptete eine Zahl, die nie erscheint.
                            sx={{ flex: 1, minWidth: 0, '& input': { fontSize: FS.inputMobil, py: 0 } }}
                          />
                          {/* 🔴 Stufe 6a (Akz. 3): das Leeren-✕ nur bei FOKUS
                              und TEXT. `mobileSearchQ &&` allein hiesse: ein ✕
                              neben einem Feld, in dem der Cursor nicht steht —
                              der Tipp oeffnet die Tastatur, statt zu leeren. */}
                          {mobileSearchQ && feldFokus && (
                            /* Befund 2: derselbe Grund wie beim ✕ oben — ein
                               echtes Bedienelement, nicht ein `div`. */
                            <Box
                              component="button"
                              type="button"
                              // 🔴 R16-W2-2 → R16-W3-1 (Nachbesserung 3, 2026-10-15):
                              // „Clear search", NICHT „Clear search text".
                              // Nachbesserung 2 gab diesem ✕ einen eigenen Namen und
                              // begruendete ihn mit „es leert den Text, der Knopf in
                              // der Leermenge die Suche". Den Unterschied gibt der
                              // Kode NICHT her: BEIDE Knopfe rufen `setMobileSearchQ('')`
                              // (dieser hier und `EmptyState.jsx` ueber `onClearSearch`
                              // unten) — es gibt in diesem Panel keinen zweiten
                              // Suchzustand ausser `mobileSearchQ`. Und die Dopplung
                              // ist im Repo bereits entschieden, auf der
                              // Schwesternkomponente derselben Suche:
                              // `frontend/src/components/common/SearchTrigger.jsx:53-59`
                              // — „alle leeren dieselbe Suche, also ist der gleiche
                              // Name richtig; mehrere Namen fuer eine Handlung waeren
                              // die schlechtere Auskunft." (R15-W5, 2026-10-08).
                              // Beide Knopfe heissen deshalb wieder gleich; die
                              // Jest-Probe sichert BEIDE Namen UND die gemeinsame
                              // Handlung zu.
                              aria-label="Clear search"
                              onPointerDown={(e) => { e.preventDefault(); setMobileSearchQ(''); }}
                              onClick={() => setMobileSearchQ('')}
                              sx={{
                                // 🔴 Suche mobil v2, Stufe 2 (Plan-Nachtrag N7 b)
                                // — 24 px SICHTBARE Breite und 44 px
                                // TREFFERFLAECHE bis zur Nachbarkante. Bis
                                // Stufe 1 war der Kreis 18 px breit und der
                                // Ueberstand reichte waagerecht nur 34 px: die
                                // Hausregel 44 war damit verfehlt (WCAG 2.5.8
                                // erfuellt, das Haus nicht).
                                ml: 0.5, width: 24, height: 24, flexShrink: 0,
                                border: 'none', p: 0, font: 'inherit',
                                borderRadius: '50%',
                                // 🔴 Kontrast (Plan-Nachtrag N7 b): `text.disabled`
                                // (rgba(0,0,0,0.38)) auf `action.hover` ergab
                                // ≈ 2,8:1 gegen das helle Icon — unter den 3:1
                                // aus WCAG 1.4.11. `text.secondary` ist die
                                // naechste Stufe der Palette und traegt beide
                                // Modi (hell ≈ 6:1, dunkel ≈ 8:1).
                                bgcolor: 'text.secondary',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                cursor: 'pointer',
                                // Die Trefferflaeche waechst NUR nach aussen:
                                // senkrecht 10 + 24 + 10 = 44; waagerecht links
                                // 8 (die Eingabe steht im Abstand `ml: 0.5`, ein
                                // weiterer Ueberstand naehme ihr den letzten
                                // Zentimeter weg) und rechts 12 bis zur
                                // Feldkante, danach 8 px `gap` bis zum
                                // Schliessen-Knopf — 8 + 24 + 12 = 44 bis zu
                                // dessen Kante, ohne ihn zu ueberlappen.
                                position: 'relative',
                                '&::after': {
                                  content: '""', position: 'absolute', inset: '-10px -12px -10px -8px',
                                },
                                '&:focus-visible': {
                                  outline: '2px solid',
                                  outlineColor: 'primary.main',
                                  outlineOffset: 2,
                                },
                              }}
                            >
                              {/* R15-W5 (Nachbesserung 1): 14 ist `FS.base` —
                                  der rohe Zahlenwert faellt, der Pixel bleibt. */}
                              <CloseIcon sx={{ fontSize: FS.base, color: 'background.default' }} />
                            </Box>
                          )}
                        </Box>
                        {/* 🔴 v2 — das ✕ zum SCHLIESSEN, rechts AUSSERHALB des
                            Feldes (Foto 2/3). Zwei Schliessen-Elemente, zwei
                            Aufgaben: dieses hier schliesst das Panel und laesst
                            den Begriff stehen; das ✕ IM Feld leert den Begriff
                            und laesst das Panel offen (V1.9).
                            🔴 Befund 2: ein ECHTER Knopf. Bis hierher war das ein
                            `div` mit `onPointerDown` — fuer die Maus bedienbar, fuer
                            die Tastatur unsichtbar: ohne ihn haette die Tab-Schleife
                            genau EIN Halteelement (die Eingabe) und das Panel liesse
                            sich nur mit Esc verlassen.
                            `pointerDown` feuert vor dem Tastatur-`blur`. */}
                        <Box
                          component="button"
                          type="button"
                          aria-label="Close search"
                          onPointerDown={(e) => { e.preventDefault(); schliesseSucheOhneLeeren(); }}
                          onClick={schliesseSucheOhneLeeren}
                          sx={{
                            width: SUCHE_FELD_HOEHE_PX, height: SUCHE_FELD_HOEHE_PX, flexShrink: 0,
                            border: 'none', p: 0, font: 'inherit',
                            borderRadius: '50%',
                            bgcolor: 'action.hover',
                            color: 'inherit',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer',
                            '&:active': { opacity: 0.7 },
                            '&:focus-visible': {
                              outline: '2px solid',
                              outlineColor: 'primary.main',
                              outlineOffset: 2,
                            },
                          }}
                        >
                          <CloseIcon sx={{ fontSize: SUCHE_IKON_PX }} />
                        </Box>
                      </Box>
                    </Box>
                    {/* 🔴 Suche mobil v2, Stufe 2 — die BEREICHSLEISTE (Plan
                        §2.1/§10). Eine Zeile, waagerecht rollbar; „All", die
                        aktiven Arten und „All filters". Sie ersetzt die
                        Bereichsauswahl in der Feldzeile UND die Gruppenkoepfe
                        der Trefferliste: der Bereich wird vor der Suche
                        gewaehlt, die Art steht danach in der Metazeile.

                        🔴 EINE Quelle fuer `types`: `setMobileSearchBereich`
                        ist derselbe Zustand, den das Blatt setzt — die Chips
                        lesen und schreiben ihn, es gibt keinen zweiten. */}
                    <SucheBereichChips
                      bereiche={mobileSucheBereiche}
                      // 🔴 Suche mobil v2, Stufe 5 (Plan §5.2): die Zaehlkarte
                      // kommt aus den Zeilen der LETZTEN Antwort. Waehrend ein
                      // neuer Begriff laedt, stehen hier noch die alten Zeilen —
                      // genau wie die Liste darunter; Zahl und Liste wechseln
                      // zusammen mit der Antwort. Leer/Fehler → keine Zahl.
                      treffer={mobileSearchResults}
                      // 🔴 R16-B1 (Nachbesserung 1, 2026-11-01): der gedrueckte
                      // Chip zeigt den WIRKSAMEN Bereich, sobald die getippte
                      // Syntax greift — sonst stuende „All" gedrueckt ueber
                      // einer auf Faelle verengten Liste. 🔴 **Warum der
                      // `mobileSyntaxWirksam`-Riegel und NICHT
                      // `mobileWirksamBereich` allein:** der blosse Unterschied
                      // Auswahl ↔ wirksamer Bereich hat zwei Ursachen (Syntax
                      // ODER eine veraltete Messung); `SearchBereichWahl.jsx`
                      // (Kommentar an `ueberstimmt`) erklaert das ausfuehrlich.
                      // Ohne den Riegel reagierte ein frisch getippter Chip
                      // erst nach der Antwort — und in der Zwischenzeit zeigte
                      // er den Bereich der VORIGEN Frage.
                      // 🔴 `onChange` bleibt `setMobileSearchBereich`: es gibt
                      // keinen zweiten Zustand.
                      // 🔴 R16-C1 (Nachbesserung 4, 2026-11-01): bei wirksamer
                      // Syntax ist ein Chip-Tipp WIRKUNGSLOS — er setzt die
                      // Auswahl, sichtbar wird sie erst nach dem Leeren des
                      // Textes (der Server laesst die Syntax gewinnen,
                      // `backend/search.py`). Bis hierher schwieg die Leiste
                      // dazu und setzte still einen Zustand. Jetzt gilt: die
                      // Umschalt-Chips sind GESPERRT und die Leiste traegt den
                      // Satz, den auch das Blatt zeigt (`SYNTAX_HINWEIS_TEXT`,
                      // EINE Quelle) — sichtbar, nicht als Tooltip: diese Leiste
                      // gibt es nur am Telefon, und dort zeigt kein Zeiger
                      // einen. „All filters" bleibt bedienbar; das Blatt
                      // erklaert denselben Zustand ohnehin schon.
                      wert={mobileSyntaxWirksam ? mobileWirksamBereich : mobileSearchBereich}
                      syntaxHinweis={mobileSyntaxWirksam ? SYNTAX_HINWEIS_TEXT : null}
                      onChange={setMobileSearchBereich}
                      onAlleFilter={() => {
                        if (mobileBereichsBlattOffen) {
                          setMobileBereichsBlattOffen(false);
                          mobileSucheInputRef.current?.focus();
                        } else {
                          setMobileBereichsBlattOffen(true);
                        }
                      }}
                      alleFilterOffen={mobileBereichsBlattOffen}
                    />
                    {/* 🔴 Das Bereichsblatt OHNE Ausloeser (Plan §9.1, W14).
                        Es oeffnet unter der Chip-Zeile — `blattObenPx` ist
                        deren Unterkante samt Polster (`SUCHE_PANEL_MINDESTHOEHE_PX`
                        = 2 · 16 + 2 · 8 + 48 + 28 = 124, Stufe 6a). Der
                        Zustand ist GESTEUERT:
                        „All filters" und `aria-expanded` am Chip brauchen
                        denselben Wert. */}
                    <SearchBereichWahl
                      ohneAusloeser
                      blattOffen={mobileBereichsBlattOffen}
                      onBlattOffenAendern={setMobileBereichsBlattOffen}
                      blattObenPx={SUCHE_PANEL_MINDESTHOEHE_PX}
                      wert={mobileSearchBereich}
                      // 🔴 R16-B2: auch hier zeigt die Liste den WIRKSAMEN
                      // Bereich (die Syntax schlaegt die Auswahl).
                      wirksam={mobileWirksamBereich}
                      // 🔴 R16-W1: derselbe Riegel wie im Kopf — der Kurzweg
                      // haengt am Server-Signal.
                      syntaxWirksam={mobileSyntaxWirksam}
                      onChange={setMobileSearchBereich}
                      // 🔴 M3b §B2.7 — der Esc-Riegel des Panels: solange das
                      // Blatt offen ist, schliesst Esc NUR das Blatt.
                      onGeoeffnet={() => setMobileBereichsBlattOffen(true)}
                      // 🔴 Owner-Befund 2026-10-16: die Auswahl laesst die Suche
                      // OFFEN und holt den Fokus ins Feld.
                      onGeschlossen={() => {
                        setMobileBereichsBlattOffen(false);
                        mobileSucheInputRef.current?.focus();
                      }}
                    />
                    {/* 🔴 Suche mobil v2 Stufe 1 (§2.1) — die Trefferliste ist
                        RANDLOS: kein Kasten (`mobil-suche-karte` gibt es nicht
                        mehr), keine Rundung, kein Glas. Sie nimmt den Rest unter
                        der Feldzeile (`flex: 1` + `minHeight: 0`) und endet am
                        unteren Rand. */}
                    {/* 🔴 Suche mobil v2, Stufe 3 (Plan §6.2/§7.1): der Scroller
                        traegt auch die RECENTS. Sie stehen im leeren Zustand
                        unter der Chip-Zeile — und sie sollen ueber DIESELBE
                        Flaeche wischen wie die Treffer (Z3), sonst braeuchte
                        der Wisch zwei Wege. Ohne Begriff und ohne Recents
                        bleibt die Flaeche weg (kein leerer Kasten). */}
                    {(mobileSearchQ || mobileZeigtRecents) && (
                      <Box
                        // 🔴 R16-W3-2 (Nachbesserung 3, 2026-10-15): der Behaelter
                        // meldet die Wartezeit SELBST — das Geruest steht nur bei
                        // LEERER Liste. Wer schon Treffer hat und ein Zeichen ergaenzt,
                        // saehe sonst fuer 280 ms Entprellung PLUS Laufzeit kein
                        // Signal, dass eine neue Frage laeuft, und die alten Treffer
                        // blieben anklickbar. Nur bei VORHANDENEN Treffern: im Leerfall
                        // traegt das Geruest (`role="status"`) den Zustand selbst —
                        // sonst hielte das busy-Elternteil seine Ansage zurueck.
                        data-testid="suche-treffer-scroller"
                        ref={mobileTrefferScrollerRef}
                        // 🔴 R16-W3 (Nachbesserung 1, 2026-11-01): der Wisch
                        // setzt den Fokus auf den Scroller (`:2493`). Ohne
                        // Rolle und Namen sagt die Vorlesung dann nur „Gruppe"
                        // — der Fokus springt aus dem Textfeld in ein `div`,
                        // das nichts ueber sich sagt. `role="region"` +
                        // `aria-label` gibt der Flaeche einen Namen, je nach
                        // Inhalt: die Recents sind keine Treffer.
                        // ⚠️ NICHT mit einem Screenreader gemessen — der
                        // Zustand ist gesetzt, die Ansage selbst offen.
                        role="region"
                        aria-label={mobileZeigtRecents ? 'Recent searches' : 'Search results'}
                        aria-busy={mobileSearchLaedt && mobileSearchResults.length > 0}
                        // 🔴 Stufe 3 (Plan §7.1/§7.2): zwei Wege — der
                        // Zeigerweg am Telefon und der am Schreibtisch. Ein
                        // `scroll`-Ereignis ist KEIN dritter: es sagt nichts
                        // ueber den Nutzer (Traegheit, Scroll-Anchoring, eigener
                        // Reset) und klappte die Tastatur nach einem spaeten
                        // `scroll` wieder zu (Nachbesserung 2, 2026-11-02).
                        // `tabIndex={-1}` macht den Scroller zum Fokus-Ziel,
                        // ohne ihn in die Tab-Reihenfolge zu nehmen; `-1` ist
                        // Absicht (§7.2, Korrektur aus dem Grill).
                        tabIndex={-1}
                        onTouchMove={blendeTastaturAus}
                        onWheel={blendeTastaturAus}
                        // 🔴 M2 §2 Abhilfe 4 (der dritte Gurt) und §3 Abhilfe 1.
                        // `overflowY: 'auto'` setzt `overflow-x` heute schon auf
                        // `auto` (CSS-Regel: ist eine Achse nicht `visible`, wird
                        // die andere `auto`) — das ist der Grund, warum ueberhaupt
                        // waagerecht gescrollt werden kann. Mit `overflowX:
                        // 'hidden'` ist die Flaeche strukturell nicht mehr
                        // waagerecht scrollbar.
                        // ⚠️ Das ist KEIN Ersatz fuer die Ursachenbehebung: nach
                        // CSSOM View ist `overflow: hidden` SELBST ein
                        // Scroll-Container, sein `scrollWidth` bleibt groesser als
                        // sein `clientWidth`. `M2.1` bleibt rot, solange
                        // `width: '100%'` bzw. `minWidth: 0` fehlen — was der Gurt
                        // wirklich tut, misst `M2.1b` (`scrollLeft` bleibt 0).
                        sx={{
                          flex: 1, minHeight: 0,
                          overflowY: 'auto', overflowX: 'hidden',
                          overscrollBehavior: 'contain',
                          // Der Scroller traegt die Zeigerereignisse (das Panel
                          // selbst nimmt keine, §B2.1): ohne das faellt jeder
                          // Tipp auf eine Zeile an die Abdunklung.
                          pointerEvents: 'auto',
                          // 🔴 M3b §B2.5/§B2.6 — der Scroller ist die EINE
                          // Flaeche mit `pan-y`; die Kapsel traegt `none`, die
                          // Saeule gar nichts (sie enthielte sonst den Scroller).
                          touchAction: 'pan-y',
                          // 🔴 Suche mobil v2, Stufe 2 — `scroll-padding-top`
                          // ist mit dem Klebekopf gefallen (Plan §9.1): es hielt
                          // eine programmatische Scrollbewegung unter dem Kopf
                          // frei, und den Kopf gibt es nicht mehr. Die Probe
                          // `M3.4d` faellt mit ihm (Plan §9.2) — ihre
                          // Zusicherung haette sonst eine Flaeche gemessen, die
                          // es nicht gibt.
                          //
                          // 🔴 v2 — das untere Polster ist `--suche-unten`
                          // (8 px, geschlossen `max(8px, env(safe-area-inset-
                          // bottom))`): die Liste endet am unteren Rand und
                          // respektiert den Home-Indikator. Die 12 px
                          // `SUCHE_ABSTAND` gehoeren jetzt allein dem
                          // Bereichsblatt (§2.3).
                          px: 0, pt: 0, pb: 'var(--suche-unten)',
                        }}
                      >
                        {/* 🔴 R16-W3 — DREI Zustaende, drei Flaechen. Vorher waren
                            es zwei, und der dritte (Fehler) sah aus wie der
                            zweite (Leermenge). Die Reihenfolge ist die
                            Vorrangfolge: ein Fehler schlaegt ein leeres
                            Ergebnis, ein laufender Abruf schlaegt „nichts
                            gefunden". */}
                        {mobileZeigtRecents ? (
                          /* 🔴 Suche mobil v2, Stufe 3 (Plan §6.2): die zuletzt
                             gesuchten Begriffe. Der Block erscheint NUR im
                             leeren Zustand und NUR mit gespeicherten Begriffen
                             — ohne sie bleibt die Flaeche leer (keine
                             Ueberschrift, kein „Clear", kein Fuelltext).
                             Gelesen wird beim Oeffnen (`merkeAusloeser`),
                             geschrieben beim Klick auf einen Treffer. */
                          /* 🔴 R16-W1 (Nachbesserung 3, 2026-11-02): der
                             Abschnitt traegt KEINEN zugaenglichen Namen mehr,
                             und die `id` der Ueberschrift ist mitgefallen —
                             nichts verweist mehr darauf. Ein `<section>` MIT
                             Namen ist laut HTML-AAM selbst eine `region`; neben
                             dem Scroller (`role="region"`, „Recent searches")
                             stand damit eine zweite, ineinandergeschachtelte
                             Region („Recent") fuer dieselbe Flaeche, und
                             „naechste Region" landete zweimal im selben Block.
                             Die `h2` bleibt: sie ist die sichtbare Ueberschrift
                             und bleibt in der Ueberschriften-Navigation. Die
                             FLAECHE benennt der Scroller — eine benannte Region
                             im Recents-Zustand, nicht zwei. */
                          <Box
                            component="section"
                            data-testid="suche-recents"
                            sx={{ pt: 0, pointerEvents: 'auto' }}
                          >
                            <Box sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              minHeight: SUCHE_FELD_HOEHE_PX,
                              px: SUCHE_V2_RAND,
                            }}>
                              <Typography
                                component="h2"
                                sx={{ fontSize: FS.sm, fontWeight: 600, color: 'text.secondary' }}
                              >
                                Recent
                              </Typography>
                              {/* 🔴 Kein Dialog (§6.2, das Foto zeigt keinen):
                                  „Clear" leert den Schluessel und die Anzeige.
                                  🔴 R16-C1 (Nachbesserung 1, 2026-11-01): der
                                  Knopf loescht ohne Rueckfrage und sitzt am
                                  rechten Bildrand — dort landet ein Daumen beim
                                  Hochscrollen. `minWidth` in der Hoehe des
                                  Feldes macht die Trefferflaeche 44 × 44; der
                                  Text bleibt rechtsbuendig (`flex-end`), das
                                  Bild aendert sich nicht.
                                  🔴 R16-W1: danach faellt der Fokus ins Feld
                                  zurueck — der Knopf verschwindet mit dem
                                  Block, sonst stuende `activeElement` auf
                                  `<body>` und die Stelle waere fuer Tastatur
                                  und Schalter verloren.
                                  🔴 R16-W2: der sichtbare Text „Clear" bleibt,
                                  die zugaengliche Bezeichnung nennt das Ziel
                                  („Clear recent searches") und enthaelt ihn
                                  damit (WCAG 2.5.3). Daneben heisst das ✕ im
                                  Feld „Clear search" — ohne den Zusatz hoerte
                                  man zwei Knoepfe mit derselben Wirkung. */}
                              <Box
                                component="button"
                                type="button"
                                aria-label="Clear recent searches"
                                onClick={() => {
                                  setMobileRecents(loescheRecents())
                                  mobileSucheInputRef.current?.focus()
                                }}
                                sx={{
                                  border: 'none', bgcolor: 'transparent', p: 0,
                                  font: 'inherit', fontSize: FS.sm,
                                  color: 'primary.main', cursor: 'pointer',
                                  minWidth: SUCHE_FELD_HOEHE_PX,
                                  minHeight: SUCHE_FELD_HOEHE_PX,
                                  display: 'flex', alignItems: 'center',
                                  justifyContent: 'flex-end',
                                  '&:active': { opacity: 0.7 },
                                  // 🔴 NB4 (2026-11-02): hier steht bewusst
                                  // KEINE eigene Fokusregel. Den Hausring am
                                  // Tastaturfokus zeichnet die globale
                                  // `*:focus-visible`-Regel in `theme.js` —
                                  // eine Quelle fuer die ganze App. Die lokale
                                  // Regel, die bis heute hier stand, trug
                                  // dieselben Werte und aenderte die Optik
                                  // nicht (gemessen: der Rotweg liess V7.13
                                  // gruen).
                                }}
                              >
                                Clear
                              </Box>
                            </Box>
                            {/* Zeilen als BUTTONS: ein Tipp setzt den Begriff
                                und holt den Fokus ins Feld (§6.2). Die Liste
                                traegt einen Namen, damit die Vorlesung
                                „Recent searches, Liste" sagt statt nur „Liste".
                                🔴 R16-W2 (Nachbesserung 1, 2026-11-01): der
                                Name ist `aria-label`, NICHT noch einmal
                                `aria-labelledby` auf die Ueberschrift — sonst
                                hoerte man „Recent" zweimal (Abschnitt und
                                Liste).
                                🔴 R15-C1 (Nachbesserung 3, 2026-11-02):
                                `role="list"` gehoert dazu — `list-style: none`
                                nimmt dem `<ul>` in WebKit (Safari/VoiceOver)
                                die Listen-Semantik, und ein `aria-label` auf
                                `generic` ist unzulaessig: auf dem iPhone bliebe
                                weder Rolle noch Name. Hausform und Begruendung
                                woertlich in `RMAFaelligkeit.jsx` (mobile
                                Kartenliste). Die `h2` darueber ist seitdem eine
                                reine Ueberschrift; die FLAECHE benennt der
                                Scroller. */}
                            <Box
                              component="ul"
                              role="list"
                              aria-label="Recent searches"
                              sx={{ listStyle: 'none', m: 0, p: 0 }}
                            >
                              {mobileRecents.map((begriff) => (
                                <Box component="li" key={begriff}>
                                  <Box
                                    component="button"
                                    type="button"
                                    data-testid="suche-recents-zeile"
                                    onClick={() => {
                                      setMobileSearchQ(begriff)
                                      mobileSucheInputRef.current?.focus()
                                    }}
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: SP.tight,
                                      px: SUCHE_V2_RAND,
                                      minHeight: SUCHE_FELD_HOEHE_PX,
                                      border: 'none',
                                      bgcolor: 'transparent',
                                      font: 'inherit',
                                      color: 'inherit',
                                      textAlign: 'left',
                                      cursor: 'pointer',
                                      '&:active': { opacity: 0.7 },
                                      // 🔴 NB4 (2026-11-02): keine eigene
                                      // Fokusregel — den Hausring zeichnet die
                                      // globale `*:focus-visible`-Regel in
                                      // `theme.js` (eine Quelle, siehe „Clear"
                                      // darueber).
                                    }}
                                  >
                                    <AccessTimeIcon sx={{
                                      fontSize: SUCHE_IKON_PX, color: 'text.disabled', flexShrink: 0,
                                    }} />
                                    <Box component="span" sx={{
                                      fontSize: FS.sm,
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}>
                                      {begriff}
                                    </Box>
                                  </Box>
                                </Box>
                              ))}
                            </Box>
                          </Box>
                        ) : mobileSearchFehler ? (
                          <EmptyState
                            reason="error"
                            message="Search is unavailable right now."
                            // 🔴 R16-W2-1 / R15-W1 (Nachbesserung 2, 2026-10-15):
                            // `showDuringOutage`. Der globale Ausfall-Banner liegt
                            // bewusst UNTER jedem Modal (`bannerEbene` =
                            // `zIndex.modal - 1`), dieses Panel ist ein `role="dialog"`
                            // auf 1300 — im Ausfall schwiege hier also die Fehlerflaeche
                            // UND der Banner waere verdeckt: eine leere Trefferliste
                            // ohne jede Aussage. Dieses Overlay traegt den Ausfall
                            // deshalb selbst.
                            showDuringOutage
                            onRetry={() => setMobileSearchVersuch((v) => v + 1)}
                          />
                        ) : mobileSearchLaedt && mobileSearchResults.length === 0 ? (
                          /* 🔴 R16-W2-4 (Nachbesserung 2, 2026-10-15): das Geruest
                             nur, solange NOCH NICHTS dasteht. `setMobileSearchLaedt(true)`
                             laeuft bei JEDER Aenderung von `mobileSearchQ` (s. Effekt
                             oben) — unbedingt gebunden ersetzte es auch die RICHTIGEN
                             Treffer der vorigen Frage fuer die Dauer der Entprellung.
                             🔴 R16-W3-2 (Nachbesserung 3, 2026-10-15) — DREI Folgen,
                             alle drei hier benannt, keine verschwiegen:
                             (1) BEHOBEN: die falsche Leermenge („No results" ueber eine
                                 noch nicht gestellte Frage) ist weg;
                             (2) BEHOBEN: das Flackern — „alt ist besser als leer"
                                 (`useOverviewPolling`/`useCaseLive`);
                             (3) NEU, und deshalb steht `aria-busy` am Behaelter oben:
                                 waehrend der Entprellung bleiben die ALTEN Treffer
                                 sichtbar UND ANKLICKBAR, und diese Bindung nimmt der
                                 Flaeche ihre einzige sichtbare Ladeanzeige. Wer tippt
                                 und Treffer sieht, bekommt fuer 280 ms plus Laufzeit
                                 kein sichtbares Signal; `aria-busy` meldet den Behaelter
                                 nur als beschaeftigt, es sagt nichts an. */
                          /* 🔴 `variante="mobil"` (R16-W1): die mobile Zeile
                             hat eine ANDERE Anatomie als die Desktop-Zeile
                             (Kachel, zwei Titelzeilen, eine Metazeile) — ein
                             Geruest in der alten Form springt beim Eintreffen
                             um elf Pixel und rueckt den Text um 48 px nach
                             links. Dieselbe Prop wie an `SearchResultItem`. */
                          <SuchergebnisGeruest kopf={false} variante="mobil" />
                        ) : mobileSearchResults.length > 0 ? (
                          /* 🔴 Suche mobil v2, Stufe 2 — die FLACHE Liste.
                             Gruppenkoepfe, ihr Kleben und der 12er-Deckel sind
                             mit der Bereichsleiste gefallen (Plan §9.1): die Art
                             steht bei „Alle" in der Metazeile, bei gewaehltem
                             Bereich waere sie Redundanz. Was bleibt, ist die
                             Reihenfolge des Servers. */
                          mobileSearchResults.map((r) => (
                            <SearchResultItem
                              key={`${r.type}:${r.key}`}
                              id={`suche-treffer-${r.type}-${r.key}`}
                              result={r}
                              // 🔴 Suche mobil v2, Stufe 2 (Plan §10):
                              // FLACHE Liste — kein Gruppenkopf, kein
                              // `slice(0, 12)`. Die Reihenfolge ist die des
                              // Servers (`backend/search.py` haengt
                              // Schluesseltreffer vorn ein); die Sicht deckelt
                              // selbst auf 30, mehr kommt hier nicht an.
                              //
                              // 🔴 Der zugaengliche Name kommt aus `…-inhalt`
                              // ALLEIN. Der Idref auf den Gruppenkopf entfaellt
                              // mit ihm (W10); die Art steht bei „Alle" in der
                              // Metazeile und ist damit im Inhalt. `V2.11`
                              // prueft, dass JEDER Idref ein Element trifft —
                              // ein stehengebliebener `suche-gruppe-…` zeigte
                              // sonst ins Leere, und keine bestehende Probe
                              // haette das gesehen.
                              aria-labelledby={`suche-treffer-${r.type}-${r.key}-inhalt`}
                              // 🔴 Suche mobil v2, Stufe 2 Teil A (Plan §4.2/§10):
                              // die mobile Anatomie — Kachel, zwei Titelzeilen,
                              // EINE Metazeile mit der Status-Pille rechts.
                              variante="mobil"
                              // Bei „Alle" (kein Bereich gewaehlt) traegt die
                              // Metazeile die Art voran; bei gewaehltem Bereich
                              // ist sie Redundanz.
                              showKindInMeta={!mobileWirksamBereich}
                              // R16-B1: die Zeile ist fuer den Marker ein
                              // echtes `<a href>` — der Browser oeffnet den
                              // neuen Tab. Hier nur schliessen und innen
                              // navigieren; kein `window.open` mehr.
                              // 🔴 Suche mobil v2, Stufe 3 (Plan §6.2): der
                              // Begriff wird BEIM KLICK auf einen Treffer
                              // gemerkt — nicht bei jedem Tastendruck und nicht
                              // beim Schliessen.
                              // ⚠️ Die Reihenfolge gegenueber
                              // `closeMobileSearch()` traegt NICHT: `mobileSearchQ`
                              // ist die Variable dieses Renderdurchlaufs, ein
                              // `setMobileSearchQ('')` daneben aendert sie nicht.
                              // Gemessen am 2026-11-01 — die Probe bleibt gruen,
                              // wenn man die zwei Zeilen tauscht. Sie steht
                              // trotzdem vorn, weil das der Ablauf ist, den man
                              // liest; der Rotweg der Probe ist ein anderer
                              // (Merken im `onChange` bzw. gar nicht).
                              onClick={() => {
                                setMobileRecents(merkeRecent(mobileSearchQ));
                                closeMobileSearch();
                                oeffneTreffer(r.href, navigate);
                              }}
                            />
                          ))
                        ) : (
                          /* 🔴 R16-B2 (Nachbesserung 1): dieselbe Verzweigung
                             wie im Kopf — ist der WIRKSAME Bereich eine
                             abgeschaltete Art, nennt die leere Antwort den
                             GRUND statt „no-match". Beide Stellen, nicht nur
                             eine: das Mobil-Panel ist ein eigener Aufrufer mit
                             eigener Wirkungsmessung. */
                          mobileWirksamBereich
                            && bereichIstAbgeschaltet(mobileWirksamBereich) ? (
                            <EmptyState
                              reason="no-data"
                              message={`${bereichsEtikett(mobileWirksamBereich)} is turned off in Admin settings.`}
                              detail="Turn it back on under Admin settings, or clear the area to search everywhere."
                              // 🔴 R16-W4, dieselbe Naht im Mobil-Panel: ohne den
                              // Bereich im Ruecksetzen stuende derselbe Leerzustand
                              // wieder da. Beide Stellen, nicht nur eine — das Panel
                              // ist ein eigener Aufrufer mit eigener Wirkungsmessung.
                              onClearSearch={() => {
                                setMobileSearchQ('')
                                setMobileSearchBereich(ALLE_BEREICHE)
                              }}
                              // 🔴 R16-W5, dieselbe Naht im Mobil-Panel.
                              action={(
                                <Button
                                  variant="outlined"
                                  onClick={() => { closeMobileSearch(); navigate('/admin/settings') }}
                                >
                                  Open Admin settings
                                </Button>
                              )}
                            />
                          ) : (
                          /* Hausform statt handgeschriebener Zeile: `EmptyState`
                             traegt `data-reason` unbedingt (Regel 22 §5) und
                             trennt Leermenge und Fehler schon im Namen. Das
                             `query`-Echo nennt die gestellte Frage; der
                             Ausweg-Knopf ist Pflicht, sonst warnt die
                             Komponente (ein Echo ohne Weg heraus). */
                          <EmptyState
                            reason="no-match"
                            // 🔴 R16-B2: das Echo nennt den WIRKSAMEN Text und
                            // den Bereich — vorher stand hier der Rohtext, und
                            // dass auf einen Bereich verengt war, stand nirgends.
                            query={mobileWirksamText || mobileSearchQ}
                            searchedIn={mobileWirksamBereich
                              ? bereichsEtikett(mobileWirksamBereich)
                              : undefined}
                            onClearSearch={() => setMobileSearchQ('')}
                          />
                          )
                        )}
                      </Box>
                    )}
                  </Box>
                )}
              </AnimatePresence>

            </>
          )}

          {/* Outlet rendered directly — no motion.div / key=pathname wrapper.
              The wrapper REMOUNTED the entire Outlet on every URL change
              (key change forced unmount+remount), destroying nested-route
              layout state and creating a stacking-context that broke
              `position: sticky` on tables. PageContainer's built-in fadeInUp
              keyframes still cover entry anim. Steht jetzt in EINEM Baum:
              ein Wechsel der Breite aendert nur die Huelle, nicht die
              Montage dieses Inhalts. */}
          <Box component="main" {...hintergrundInert} sx={isMobile ? mobileMainSx : desktopMainSx}>
            {/* 🔴 W7 (2026-10-24): der iOS-Hinweis steht IM FLUSS am Kopf der
                Inhaltsspalte. Bis dahin war er `position: fixed` unten und lag
                in iOS-Safari ueber dem Verfasser der neuen Fallansicht und
                ueber den festen Tabellenfuessen der Listen. Auf
                `vollflaeche`-Seiten erscheint er gar nicht - ihre Spalte hat
                feste Hoehe, ein Hinweis im Fluss wuerde sie verschieben. */}
            <IOSInstallBanner ausgeblendet={vollflaeche} />
            <RoutedContent />
          </Box>

              {/* 🔴 Die Fallansicht traegt ihre eigene Telefonbedienung
                  (Entscheid 43): hier wird die schwebende Leiste AUSGELASSEN,
                  nicht versteckt - sie deckte sonst Strom, Agent und Karten zu
                  (Design-Gate B5, BLOCKER 2). Zurueck geht es ueber den Pfeil
                  im Fallkopf (`fall-zurueck`). Jede andere Route und der
                  Rechner behalten die Leiste unveraendert. */}
          {isMobile && !vollflaeche && (
            /* Befund 2: `MobileBottomNav` nimmt keine fremden Attribute an
               (ihre Signatur listet nur ihre zwei Props) - die Unterleiste
               bekommt ihren `inert`-Schalter deshalb ueber diese Huelle.
               Sie ist `position: fixed`, ein zusätzlicher Blockknoten
               aendert am Layout nichts. */
            <Box {...hintergrundInert}>
              <MobileBottomNav
                // 🔴 `merkeAusloeser` statt `setMobileSearchOpen(true)`: hier
                // faellt der Fokus-Merker, BEVOR die Eingabe ihn sich mit
                // `autoFocus` holt (Begruendung an der Definition).
                onOpenSearch={merkeAusloeser}
                onCreateStandalone={onCreateStandalone}
              />
            </Box>
          )}
          </Box>
    
          {/* Discard‐changes dialog (both layouts) */}
          <Dialog open={confirmOpen}
            onClose={() => setConfirmOpen(false)}>
            <DialogTitle>Discard changes?</DialogTitle>
            <DialogContent>
              You have unsaved changes. Are you sure you want to discard and leave?
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setConfirmOpen(false)}>
                Keep editing
              </Button>
              <Button color="error" onClick={() => {
                onDiscard();
                clearUnsaved();
                navigate(pendingPath);
                setConfirmOpen(false);
              }}>
                Discard & leave
              </Button>
            </DialogActions>
          </Dialog>
    
        <CommandPalette open={paletteOffen} onClose={() => setPaletteOffen(false)} />
        </UnsavedContext.Provider>
        </HeaderConfigContext.Provider>
      );
    }

// R16-A C-1 / R16-B C1: die Kandidaten fuer `aria-current` sind genau die
// Eintraege, die die Leiste TATSAECHLICH rendert — die persoenliche
// Voreinstellung (`prefs`) blendet Eintraege aus. Ein ausgeblendetes Kind gibt
// die Markierung damit an den sichtbaren Eltern weiter.
//
// 🔴 Die FAVORITEN gehoeren dazu (Plan §3.4, B4): sie sind gerendert, auch wenn
// ihre Heimatzeile ausgeblendet ist — genau dann traegt die Kopie die Markierung.
// Ohne diesen Zusatz waere die Zelle „Heimatzeile nicht gerendert" traegerlos.
//
// Steht am Dateiende, damit keine Zeile davor wandert (Zeilenzeiger der Doku).
function alleSichtbarenPfade(prefs) {
  return [
    ...NAV_SECTIONS.flatMap((section) => sichtbarePfade(section, prefs)),
    ...(prefs.favoriten || []),
  ]
}
